window.SCART_CONFIGURATOR_DATA = {
  "vehicles": [
    {
      "id": "porsche-356",
      "displayName": "Porsche 356",
      "shortName": "Porsche 356",
      "brand": "Porsche",
      "model": "356",
      "modelId": "356",
      "generation": "356",
      "generationId": "356",
      "generationLabel": "356 (1948-1965)",
      "period": "1948 - 1965",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-356",
      "drawingAsset": "scart-undercarriage-porsche-356.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-super-sound-porsche-356"
      ],
      "activeProducts": [
        {
          "handle": "echappement-super-sound-porsche-356",
          "title": "Échappement super sound - Porsche 911 (356)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-super-sound-porsche-356",
              "l": "Échappement super sound - Porsche 911 (356)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet vehicle_compat_label « 356 » (carte compat PDP vide). Le titre produit dit « Porsche 911 (356) », erreur de nommage.",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "356"
      ]
    },
    {
      "id": "porsche-911-type-f",
      "displayName": "911 Type F (1963-1973)",
      "shortName": "911 2.0 / 2.2 / 2.4",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type F",
      "generationId": "type-f",
      "generationLabel": "Type F (1963-1973)",
      "period": "1963 - 1973",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-f",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "logoKey": "porsche-911-simple",
      "logoAsset": "scart-logo-porsche-911.svg",
      "logoTitle": "911",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons",
        "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons-1",
        "silencieux-2-entr-es-1-sortie-sonorit-riva",
        "silencieux-2-entr-es-2-sorties-d-g-sonorit-sport",
        "silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound",
        "silencieux-2-entrees-1-sortie-sonorite-sport",
        "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound",
        "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound-copie",
        "silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport",
        "silencieux-2-entrees-2-sorties-droite-gauche-sonorite-sport-copie",
        "silencieux-monte-carlo-2-entr-es-2-sorties-sonorit-super-sound"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons",
          "title": "Silencieux 3,0L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons-1",
          "title": "Silencieux 2,8L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entr-es-1-sortie-sonorit-riva",
          "title": "Silencieux 2 entrées, 1 sortie - sonorité Riva - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entr-es-2-sorties-d-g-sonorit-sport",
          "title": "Silencieux 2 entrées, 2 sorties D/G - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound",
          "title": "Silencieux 2 entrées, 2 sorties D/G - sonorité super sound - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-1-sortie-sonorite-sport",
          "title": "Silencieux 2 entrées, 1 sortie - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound",
          "title": "Silencieux 2 entrées, 2 sorties arrières 70mm - sonorité super sound - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound-copie",
          "title": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport",
          "title": "Silencieux 2 entrées, 2 sorties centrées 70mm - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-droite-gauche-sonorite-sport-copie",
          "title": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité super sound - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-monte-carlo-2-entr-es-2-sorties-sonorit-super-sound",
          "title": "Silencieux Monte Carlo 2 entrées, 2 sorties - Sonorité super sound - Porsche 911 (Type F)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 11,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-2-entr-es-2-sorties-d-g-sonorit-sport",
              "l": "Silencieux 2 entrées, 2 sorties D/G - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entrees-1-sortie-sonorite-sport",
              "l": "Silencieux 2 entrées, 1 sortie - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound-copie",
              "l": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport",
              "l": "Silencieux 2 entrées, 2 sorties centrées 70mm - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entr-es-1-sortie-sonorit-riva",
              "l": "Silencieux 2 entrées, 1 sortie - sonorité Riva - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            },
            {
              "h": "silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound",
              "l": "Silencieux 2 entrées, 2 sorties D/G - sonorité super sound - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound",
              "l": "Silencieux 2 entrées, 2 sorties arrières 70mm - sonorité super sound - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-droite-gauche-sonorite-sport-copie",
              "l": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité super sound - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-monte-carlo-2-entr-es-2-sorties-sonorit-super-sound",
              "l": "Silencieux Monte Carlo 2 entrées, 2 sorties - Sonorité super sound - Porsche 911 (Type F)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons",
              "l": "Silencieux 3,0L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux"
            },
            {
              "h": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons-1",
              "l": "Silencieux 2,8L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [
        "ACTIVE mais non publié(s) : silencieux-2-entr-es-1-sortie-valve-command-e-par-interrupteur"
      ],
      "aliases": [
        "Type F",
        "Type F (1963-1973)"
      ]
    },
    {
      "id": "porsche-911-type-f-1973-1976",
      "displayName": "911 « Type F » 1973-1976",
      "shortName": "911 (1973-1976)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type F",
      "generationId": "type-f",
      "generationLabel": "Type F (1963-1973)",
      "period": "1973 - 1976",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-f",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "logoKey": "porsche-911-simple",
      "logoAsset": "scart-logo-porsche-911.svg",
      "logoTitle": "911",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "paire-de-collecteurs-racing-courts-diam-tre-38-5mm",
        "silencieux-2-entrees-1-sortie-riva-sound"
      ],
      "activeProducts": [
        {
          "handle": "paire-de-collecteurs-racing-courts-diam-tre-38-5mm",
          "title": "Paire de collecteurs racing courts - Diamètre 38,5mm - Porsche 911 Type F (1973-1976)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-1-sortie-riva-sound",
          "title": "Silencieux 2 entrées, 1 sortie - Riva Sound - Porsche 911 Type F (1973-1976)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-2-entrees-1-sortie-riva-sound",
              "l": "Silencieux 2 entrées, 1 sortie - Riva Sound - Porsche 911 Type F (1973-1976)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "paire-de-collecteurs-racing-courts-diam-tre-38-5mm",
              "l": "Paire de collecteurs racing courts - Diamètre 38,5mm - Porsche 911 Type F (1973-1976)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé hérité ambigu : la Type F s'arrête en 1973, 1973-1976 correspond à la Type G 2,7 L. Deux produits (collecteurs racing courts 38,5 mm, silencieux 1 sortie Riva Sound). Rattaché provisoirement au dessin Type F car la zone vendue (silencieux arrière 2 entrées / 1 sortie) est celle de la Type F ; à confirmer avec Martin.",
      "anomalies": [],
      "aliases": [
        "Type F (1973-1976)"
      ]
    },
    {
      "id": "porsche-911-carrera-rs-2-7",
      "displayName": "911 Carrera RS 2.7",
      "shortName": "911 Carrera RS 2.7",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type F",
      "generationId": "type-f",
      "generationLabel": "Type F (1963-1973)",
      "period": "1973",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-f",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "logoKey": "porsche-carrera-rs-27",
      "logoAsset": "scart-logo-porsche-carrera-rs.svg",
      "logoTitle": "Carrera RS",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport-pour-911-2-7l-rs",
        "silencieux-sport-pour-911-2-7l-rs-3-sorties-courtes-bouchons",
        "silencieux-sport-pour-911-2-7l-rs-3-sorties-longues-bouchons",
        "silencieux-super-sound-pour-911-2-7l-rs"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport-pour-911-2-7l-rs",
          "title": "Silencieux sport - 2,7L - Porsche 911 (2.7L RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-pour-911-2-7l-rs-3-sorties-courtes-bouchons",
          "title": "Silencieux sport pour 2,7L - 3 sorties courtes à bouchons - Porsche 911 (2.7L RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-pour-911-2-7l-rs-3-sorties-longues-bouchons",
          "title": "Silencieux sport pour 2,7L - 3 sorties longues à bouchons - Porsche 911 (2.7 RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound-pour-911-2-7l-rs",
          "title": "Silencieux super sound - Porsche 911 (2,7L RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-pour-911-2-7l-rs",
              "l": "Silencieux sport - 2,7L - Porsche 911 (2.7L RS)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-pour-911-2-7l-rs-3-sorties-courtes-bouchons",
              "l": "Silencieux sport pour 2,7L - 3 sorties courtes à bouchons - Porsche 911 (2.7L RS)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-pour-911-2-7l-rs-3-sorties-longues-bouchons",
              "l": "Silencieux sport pour 2,7L - 3 sorties longues à bouchons - Porsche 911 (2.7 RS)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-super-sound-pour-911-2-7l-rs",
              "l": "Silencieux super sound - Porsche 911 (2,7L RS)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Trois alias non normalisés (`2.7L RS`, `2,7L RS`, `2.7 RS`). La RS 2.7 est une Type F 1973 : même architecture arrière (échangeurs + silencieux transversal), mêmes zones vendues.",
      "anomalies": [],
      "aliases": [
        "2.7L RS",
        "2,7L RS",
        "2.7 RS"
      ]
    },
    {
      "id": "porsche-912",
      "displayName": "912 (1965-1969)",
      "shortName": "912 Classic (1965-1969)",
      "brand": "Porsche",
      "model": "912",
      "modelId": "912",
      "generation": "912",
      "generationId": "912",
      "generationLabel": "912 (1965-1976)",
      "period": "1965 - 1969",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-912",
      "drawingAsset": "scart-undercarriage-porsche-912.webp",
      "logoKey": "porsche-912",
      "logoAsset": "scart-logo-porsche-912.jpg",
      "logoTitle": "912",
      "logoFormat": "jpg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-porsche-912",
        "echappement-sport-porsche-913",
        "echappement-sport-super-sound-type-riva-porsche-912",
        "echappement-super-sound-type-riva-porsche-912"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-porsche-912",
          "title": "Échappement sport - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-913",
          "title": "Échappement sport - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-super-sound-type-riva-porsche-912",
          "title": "Échappement sport super sound type Riva - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-super-sound-type-riva-porsche-912",
          "title": "Échappement super sound type Riva - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-912",
              "l": "Échappement sport - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-porsche-913",
              "l": "Échappement sport - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-super-sound-type-riva-porsche-912",
              "l": "Échappement sport super sound type Riva - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            },
            {
              "h": "echappement-super-sound-type-riva-porsche-912",
              "l": "Échappement super sound type Riva - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Quatre fiches actives pour deux propositions (Sport et Riva dupliqués sous `echappement-sport-porsche-913` et `echappement-sport-super-sound-type-riva-porsche-912`). Doublons à réconcilier.",
      "anomalies": [],
      "aliases": [
        "912"
      ]
    },
    {
      "id": "porsche-912e",
      "displayName": "912E (1976)",
      "shortName": "912E (1976)",
      "brand": "Porsche",
      "model": "912",
      "modelId": "912",
      "generation": "912",
      "generationId": "912",
      "generationLabel": "912 (1965-1976)",
      "period": "1976",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-912e",
      "drawingAsset": "scart-undercarriage-porsche-912e.webp",
      "logoKey": "porsche-912e",
      "logoAsset": "scart-logo-porsche-912e.svg",
      "logoTitle": "912E",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-porsche-912e",
        "echappement-super-sound-type-riva-porsche-912e"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-porsche-912e",
          "title": "Échappement sport - Porsche 911 (912E)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-super-sound-type-riva-porsche-912e",
          "title": "Échappement super sound type Riva - Porsche 911 (912E)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-912e",
              "l": "Échappement sport - Porsche 911 (912E)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-super-sound-type-riva-porsche-912e",
              "l": "Échappement super sound type Riva - Porsche 911 (912E)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "912E"
      ]
    },
    {
      "id": "porsche-914-4-1-7",
      "displayName": "914/4 1.7 L",
      "shortName": "914/4 1.7 L",
      "brand": "Porsche",
      "model": "914",
      "modelId": "914",
      "generation": "914",
      "generationId": "914",
      "generationLabel": "914 (1969-1976)",
      "period": "1969 - 1973",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-914-4",
      "drawingAsset": "scart-undercarriage-porsche-914-4.webp",
      "logoKey": "porsche-914",
      "logoAsset": "scart-logo-porsche-914.svg",
      "logoTitle": "914",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport-1-7l",
        "silencieux-super-sound-1-7l"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport-1-7l",
          "title": "Silencieux sport 1,7L - Porsche 914/4 1.7L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound-1-7l",
          "title": "Silencieux super sound 1,7L - Porsche 914/4 1.7",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-1-7l",
              "l": "Silencieux sport 1,7L - Porsche 914/4 1.7L",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-super-sound-1-7l",
              "l": "Silencieux super sound 1,7L - Porsche 914/4 1.7",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "914/4 1.7L",
        "914/4 1.7"
      ]
    },
    {
      "id": "porsche-914-4-2-0",
      "displayName": "914/4 2.0 L",
      "shortName": "914/4 2.0 L",
      "brand": "Porsche",
      "model": "914",
      "modelId": "914",
      "generation": "914",
      "generationId": "914",
      "generationLabel": "914 (1969-1976)",
      "period": "1973 - 1976",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-914-4",
      "drawingAsset": "scart-undercarriage-porsche-914-4.webp",
      "logoKey": "porsche-914",
      "logoAsset": "scart-logo-porsche-914.svg",
      "logoTitle": "914",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-avec-2-sorties-arri-re-pour-914-4-2-0l-super-sound",
        "silencieux-sport-2-0l",
        "silencieux-super-sound-2-0l"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-avec-2-sorties-arri-re-pour-914-4-2-0l-super-sound",
          "title": "Silencieux avec 2 sorties arrière pour /4 2,0L - super sound - Porsche 914/4 2.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-2-0l",
          "title": "Silencieux sport 2,0L - Porsche 914/4 2.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound-2-0l",
          "title": "Silencieux super sound 2,0L - Porsche 914/4 2.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-2-0l",
              "l": "Silencieux sport 2,0L - Porsche 914/4 2.0L",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-avec-2-sorties-arri-re-pour-914-4-2-0l-super-sound",
              "l": "Silencieux avec 2 sorties arrière pour /4 2,0L - super sound - Porsche 914/4 2.0L",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-super-sound-2-0l",
              "l": "Silencieux super sound 2,0L - Porsche 914/4 2.0L",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "914/4 2.0L"
      ]
    },
    {
      "id": "porsche-911-type-g-2-7",
      "displayName": "Porsche 911 Type G 2,7 L / 3,0 L",
      "shortName": "911 2.7 L",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type G",
      "generationId": "type-g",
      "generationLabel": "Type G (1974-1989)",
      "period": "1974 - 1977",
      "architecture": "Atmosphérique",
      "description": "Ligne atmosphérique classique : tube de liaison, pré-silencieux, silencieux arrière et sortie.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-g",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "logoKey": "porsche-911-simple",
      "logoAsset": "scart-logo-porsche-911.svg",
      "logoTitle": "911",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "bmc-sport-air-filter-for-911-3-0l",
        "pr-silencieux-2-en-1-catalys-sport-100cc",
        "pr-silencieux-2-en-1-catalys-standard-300cc",
        "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
        "pr-silencieux-2-en-1-racing-sonorit-super-sound",
        "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
        "pr-silencieux-valve",
        "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
        "silencieux-sport-avec-valve-command-par-interrupteur",
        "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
        "sortie-chrom-e-origine-porsche",
        "sortie-noire-origine",
        "tube-interm-diaire-r-glable"
      ],
      "activeProducts": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-sport-100cc",
          "title": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-standard-300cc",
          "title": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
          "title": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
          "title": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
          "title": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-valve",
          "title": "Présilencieux à valve - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
          "title": "Silencieux pour 2,7L & 3,0L - sonorité super sound type Riva - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-command-par-interrupteur",
          "title": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
          "title": "Silencieux sport type banane pour 2,7 & 3,0L - sonorité sport - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-chrom-e-origine-porsche",
          "title": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-noire-origine",
          "title": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-interm-diaire-r-glable",
          "title": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 13,
      "zones": [
        {
          "id": "rear",
          "n": "Le silencieux arrière",
          "d": "La pièce principale qui donne sa voix à la voiture.",
          "rects": [
            [
              14.7,
              19.1,
              60.1,
              20.6
            ]
          ],
          "scale": [
            "Sport",
            "Riva"
          ],
          "journeyTitle": "La même pièce, deux sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
              "g": "sound",
              "l": "Sport",
              "s": 1
            },
            {
              "h": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "silencieux-sport-avec-valve-command-par-interrupteur",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "pre",
          "n": "Le pré-silencieux ou catalyseur",
          "d": "En amont, il prépare le son et libère le débit.",
          "rects": [
            [
              20.2,
              31.6,
              9.7,
              61.7
            ]
          ],
          "scale": [
            "Sonorité douce",
            "Riva",
            "Racing"
          ],
          "journeyTitle": "La même pièce, trois sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
              "g": "sound",
              "l": "Sonorité douce",
              "s": 1
            },
            {
              "h": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
              "g": "sound",
              "l": "Racing",
              "s": 3
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-sport-100cc",
              "g": "catalyst",
              "l": "Catalysé sport 100 cc"
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-standard-300cc",
              "g": "catalyst",
              "l": "Catalysé standard 300 cc"
            },
            {
              "h": "pr-silencieux-valve",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "link",
          "n": "Le tube de liaison",
          "d": "Il relie l’échangeur droit au pré-silencieux.",
          "rects": [
            [
              26.5,
              74,
              12,
              18
            ]
          ],
          "products": [
            {
              "h": "tube-interm-diaire-r-glable",
              "l": "Tube intermédiaire réglable"
            }
          ]
        },
        {
          "id": "outlet",
          "n": "La sortie d’échappement",
          "d": "Deux finitions d’origine, sans hiérarchie sonore entre elles.",
          "rects": [
            [
              7.5,
              12.5,
              14,
              14
            ]
          ],
          "products": [
            {
              "h": "sortie-chrom-e-origine-porsche",
              "l": "Chromée d’origine"
            },
            {
              "h": "sortie-noire-origine",
              "l": "Noire d’origine"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "2.7L (Type G)",
        "2.7L"
      ]
    },
    {
      "id": "porsche-911-sc-3-0",
      "displayName": "Porsche 911 Type G 2,7 L / 3,0 L",
      "shortName": "911 SC 3.0 L",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type G",
      "generationId": "type-g",
      "generationLabel": "Type G (1974-1989)",
      "period": "1978 - 1983",
      "architecture": "Atmosphérique",
      "description": "Ligne atmosphérique classique : tube de liaison, pré-silencieux, silencieux arrière et sortie.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-g",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "logoKey": "porsche-911-sc",
      "logoAsset": "scart-badge-911-sc.svg",
      "logoTitle": "911 SC",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "bmc-sport-air-filter-for-911-3-0l",
        "pr-silencieux-2-en-1-catalys-sport-100cc",
        "pr-silencieux-2-en-1-catalys-standard-300cc",
        "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
        "pr-silencieux-2-en-1-racing-sonorit-super-sound",
        "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
        "pr-silencieux-valve",
        "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
        "silencieux-sport-avec-valve-command-par-interrupteur",
        "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
        "sonde-lambda-pour-911-3-2l",
        "sortie-chrom-e-origine-porsche",
        "sortie-noire-origine",
        "tube-interm-diaire-r-glable"
      ],
      "activeProducts": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-sport-100cc",
          "title": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-standard-300cc",
          "title": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
          "title": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
          "title": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
          "title": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-valve",
          "title": "Présilencieux à valve - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
          "title": "Silencieux pour 2,7L & 3,0L - sonorité super sound type Riva - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-command-par-interrupteur",
          "title": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
          "title": "Silencieux sport type banane pour 2,7 & 3,0L - sonorité sport - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sonde-lambda-pour-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.0L)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-chrom-e-origine-porsche",
          "title": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-noire-origine",
          "title": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-interm-diaire-r-glable",
          "title": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 14,
      "zones": [
        {
          "id": "rear",
          "n": "Le silencieux arrière",
          "d": "La pièce principale qui donne sa voix à la voiture.",
          "rects": [
            [
              14.7,
              19.1,
              60.1,
              20.6
            ]
          ],
          "scale": [
            "Sport",
            "Riva"
          ],
          "journeyTitle": "La même pièce, deux sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
              "g": "sound",
              "l": "Sport",
              "s": 1
            },
            {
              "h": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "silencieux-sport-avec-valve-command-par-interrupteur",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "pre",
          "n": "Le pré-silencieux ou catalyseur",
          "d": "En amont, il prépare le son et libère le débit.",
          "rects": [
            [
              20.2,
              31.6,
              9.7,
              61.7
            ]
          ],
          "scale": [
            "Sonorité douce",
            "Riva",
            "Racing"
          ],
          "journeyTitle": "La même pièce, trois sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
              "g": "sound",
              "l": "Sonorité douce",
              "s": 1
            },
            {
              "h": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
              "g": "sound",
              "l": "Racing",
              "s": 3
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-sport-100cc",
              "g": "catalyst",
              "l": "Catalysé sport 100 cc"
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-standard-300cc",
              "g": "catalyst",
              "l": "Catalysé standard 300 cc"
            },
            {
              "h": "pr-silencieux-valve",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "link",
          "n": "Le tube de liaison",
          "d": "Il relie l’échangeur droit au pré-silencieux.",
          "rects": [
            [
              26.5,
              74,
              12,
              18
            ]
          ],
          "products": [
            {
              "h": "tube-interm-diaire-r-glable",
              "l": "Tube intermédiaire réglable"
            }
          ]
        },
        {
          "id": "outlet",
          "n": "La sortie d’échappement",
          "d": "Deux finitions d’origine, sans hiérarchie sonore entre elles.",
          "rects": [
            [
              7.5,
              12.5,
              14,
              14
            ]
          ],
          "products": [
            {
              "h": "sortie-chrom-e-origine-porsche",
              "l": "Chromée d’origine"
            },
            {
              "h": "sortie-noire-origine",
              "l": "Noire d’origine"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "sonde-lambda-pour-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.0L)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "3.0L"
      ]
    },
    {
      "id": "porsche-911-carrera-3-2",
      "displayName": "911 Carrera 3.2 L",
      "shortName": "911 SC 3.0 L",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type G",
      "generationId": "type-g",
      "generationLabel": "Type G (1974-1989)",
      "period": "1984 - 1989",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-g",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "logoKey": "porsche-911-sc",
      "logoAsset": "scart-badge-911-sc.svg",
      "logoTitle": "911 SC",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "filtre-air-sport-bmc-pour-911-3-2l",
        "o2-sensor-for-911-3-2l",
        "pr-silencieux-2-en-1-catalys-sport-100cc",
        "pr-silencieux-2-en-1-catalys-standard-300cc",
        "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
        "pr-silencieux-2-en-1-racing-sonorit-super-sound",
        "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
        "rear-dual-tail-pipe-skurt",
        "rear-dual-tail-pipes",
        "silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller",
        "silencieux-sport-avec-valve-command-par-interrupteur",
        "silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport",
        "sortie-chrom-e-origine-porsche",
        "sortie-noire-origine",
        "tube-interm-diaire-r-glable"
      ],
      "activeProducts": [
        {
          "handle": "filtre-air-sport-bmc-pour-911-3-2l",
          "title": "Filtre à air sport BMC pour 3,2L - Porsche 911 (3.2L)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "o2-sensor-for-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.2L)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-sport-100cc",
          "title": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-standard-300cc",
          "title": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
          "title": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
          "title": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
          "title": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "rear-dual-tail-pipe-skurt",
          "title": "Échappement sortie double arrière + jupe Riva - Porsche 911 3.2L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "rear-dual-tail-pipes",
          "title": "Échappement sortie double arrière + jupe - Porsche 911 (3.2L)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller",
          "title": "Silencieux pour 3,2L - sonorité super sound type Riva - Porsche 911 (3.2L)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-command-par-interrupteur",
          "title": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport",
          "title": "Silencieux sport type banane pour 3,2L - sonorité sport - Porsche 911 (3.2L)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-chrom-e-origine-porsche",
          "title": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-noire-origine",
          "title": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-interm-diaire-r-glable",
          "title": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 15,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport",
              "l": "Silencieux sport type banane pour 3,2L - sonorité sport - Porsche 911 (3.2L)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller",
              "l": "Silencieux pour 3,2L - sonorité super sound type Riva - Porsche 911 (3.2L)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            },
            {
              "h": "silencieux-sport-avec-valve-command-par-interrupteur",
              "l": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "mid",
          "n": "Le tube intermédiaire",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
              "l": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
              "l": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
              "l": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "tube-interm-diaire-r-glable",
              "l": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "pr-silencieux-2-en-1-catalys-sport-100cc",
              "l": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-standard-300cc",
              "l": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "rear-dual-tail-pipe-skurt",
              "l": "Échappement sortie double arrière + jupe Riva - Porsche 911 3.2L",
              "type": "Silencieux"
            },
            {
              "h": "rear-dual-tail-pipes",
              "l": "Échappement sortie double arrière + jupe - Porsche 911 (3.2L)",
              "type": "Silencieux"
            },
            {
              "h": "sortie-chrom-e-origine-porsche",
              "l": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
              "type": "Sortie"
            },
            {
              "h": "sortie-noire-origine",
              "l": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-911-3-2l",
          "title": "Filtre à air sport BMC pour 3,2L - Porsche 911 (3.2L)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "o2-sensor-for-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.2L)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "3.2L"
      ]
    },
    {
      "id": "porsche-911-930-turbo",
      "displayName": "Porsche 911 Turbo 930",
      "shortName": "911 Turbo (930)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "930",
      "generationId": "930",
      "generationLabel": "930 Turbo (1975-1989)",
      "period": "1975 - 1989",
      "architecture": "Simple turbo et wastegate",
      "description": "La ligne Turbo suit un chemin propre, avec alimentation du turbo et wastegate.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-930-turbo",
      "drawingAsset": "porsche-911-930-turbo-undercarriage-exhaust.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-sport-100-cc-930-turbo",
        "catalyseur-standard-400-cellules",
        "muffler-super-sound",
        "pipe-from-headers-to-turbo-wg",
        "silencieux-sport-sonorit-sport",
        "silencieux-sport-sonorit-super-sound",
        "silencieux-sport-sorties-jointes",
        "silencieux-super-sound",
        "silencieux-type-934-une-sortie-centrale-arri-re-90mm",
        "silencieux-type-934-une-sortie-centrale-arriere-90mm",
        "silencieux-us-super-sound",
        "tube-de-wastegate"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-sport-100-cc-930-turbo",
          "title": "Catalyseur sport 100 cc - Turbo - Porsche 911 (930)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-400-cellules",
          "title": "Catalyseur standard (400 cellules) - Porsche 911 (930)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "muffler-super-sound",
          "title": "Silencieux sport 3.0L - sonorité super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pipe-from-headers-to-turbo-wg",
          "title": "Tube de liaison collecteurs > turbo - Porsche 911 (930)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sonorit-sport",
          "title": "Silencieux sport - sonorité sport - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sonorit-super-sound",
          "title": "Silencieux sport - sonorité super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sorties-jointes",
          "title": "Silencieux sport - sorties jointes - 3.3L - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound",
          "title": "Silencieux super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-type-934-une-sortie-centrale-arri-re-90mm",
          "title": "Silencieux type 934 (une sortie centrale arrière 90mm) - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-type-934-une-sortie-centrale-arriere-90mm",
          "title": "Silencieux type 934 (une sortie centrale arrière 90mm) - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-us-super-sound",
          "title": "Silencieux US - super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-de-wastegate",
          "title": "Tube de wastegate - Porsche 911 (930)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 12,
      "zones": [
        {
          "id": "link",
          "n": "Le tube d’alimentation du turbo",
          "d": "Le conduit d’alimentation du turbo et de la wastegate.",
          "rects": [
            [
              21.5,
              26,
              29,
              49
            ]
          ],
          "products": [
            {
              "h": "pipe-from-headers-to-turbo-wg",
              "l": "Tube collecteurs vers turbo et wastegate"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Le catalyseur ou by-pass",
          "d": "Pour les 930 3,3 L US : préserve l’origine en 400 cellules ou libère flux et son en 100 cellules.",
          "rects": [
            [
              42,
              24,
              12,
              13
            ]
          ],
          "scale": [
            "Standard 400 c",
            "Sport 100 c"
          ],
          "journeyTitle": "La même pièce, deux caractères",
          "journeyHint": "La densité du catalyseur change le résultat",
          "products": [
            {
              "h": "catalyseur-standard-400-cellules",
              "s": 1,
              "l": "Standard 400 cellules"
            },
            {
              "h": "catalyseur-sport-100-cc-930-turbo",
              "s": 2,
              "l": "Sport 100 cellules"
            }
          ]
        },
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Choisissez la cylindrée et, pour la 3,3 L, la configuration Europe ou US catalysée.",
          "rects": [
            [
              40.5,
              17,
              34,
              15
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Super Sound"
          ],
          "journeyTitle": "Le même silencieux, deux sonorités",
          "journeyHint": "La forme fait le son",
          "filter": {
            "label": "Quelle configuration équipe votre 930 ?",
            "options": [
              {
                "id": "all",
                "l": "Toutes configurations"
              },
              {
                "id": "30",
                "l": "3,0 L"
              },
              {
                "id": "33",
                "l": "3,3 L Europe"
              },
              {
                "id": "33-us",
                "l": "3,3 L US · catalysée"
              }
            ]
          },
          "products": [
            {
              "h": "silencieux-sport-sonorit-sport",
              "f": [
                "30"
              ],
              "g": "sound",
              "s": 1,
              "l": "Sport · sortie simple (3.0 L)"
            },
            {
              "h": "silencieux-sport-sonorit-super-sound",
              "f": [
                "30"
              ],
              "g": "sound",
              "s": 2,
              "l": "Super Sound · sortie simple (3.0 L)"
            },
            {
              "h": "silencieux-sport-sorties-jointes",
              "f": [
                "33"
              ],
              "g": "sound",
              "s": 1,
              "l": "Sport · sorties jointes (3.3 L)"
            },
            {
              "h": "silencieux-super-sound",
              "f": [
                "33"
              ],
              "g": "sound",
              "s": 2,
              "l": "Super Sound · sorties jointes (3.3 L)"
            },
            {
              "h": "silencieux-type-934-une-sortie-centrale-arriere-90mm",
              "f": [
                "30",
                "33"
              ],
              "l": "Type 934 · sortie centrale"
            },
            {
              "h": "silencieux-us-super-sound",
              "f": [
                "33-us"
              ],
              "l": "Version US · Super Sound"
            }
          ]
        },
        {
          "id": "wastegate",
          "n": "Le tube de wastegate",
          "d": "La sortie dédiée de régulation du turbo.",
          "rects": [
            [
              25,
              29,
              18,
              30
            ]
          ],
          "products": [
            {
              "h": "tube-de-wastegate",
              "l": "Tube de wastegate"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "Alias `930` et `930 ` (espace final) coexistent dans le métaobjet.",
      "anomalies": [],
      "aliases": [
        "930",
        "930 "
      ]
    },
    {
      "id": "porsche-911-964-carrera",
      "displayName": "Porsche 911 Carrera 964",
      "shortName": "911 Carrera (964)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "964",
      "generationId": "964",
      "generationLabel": "964 (1989-1994)",
      "period": "1989 - 1994",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique à catalyseur transversal et deux étages de silencieux.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-964-carrera",
      "drawingAsset": "porsche-911-964-carrera-undercarriage-exhaust.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-racing",
        "catalyseur-by-pass-sport-porsche-964",
        "catalyseur-sport-100cc-porsche-964",
        "catalyseur-standard-300-cc-porsche-964",
        "col-de-cygne",
        "collier-964",
        "echappement-a-valve-porsche-964",
        "echappement-sport-riva",
        "filtre-air-sport-bmc-pour-964",
        "kit-montage-964",
        "ligne-d-chappements-1-sortie-sonorit-sport",
        "ligne-d-chappements-2-sorties-sonorit-sport",
        "ligne-d-chappements-racing-1-sortie-sonorit-super-sound",
        "ligne-d-chappements-racing-2-sorties-sonorit-super-sound",
        "olive-964",
        "silencieux-arri-re-droit-version-sport",
        "silencieux-arri-re-droit-version-super-sound",
        "sonde-lambda-964",
        "sortie-avec-ourlet-90mm-insert",
        "sortie-ovale",
        "syst-me-cup-1-sortie-sonorit-sport",
        "syst-me-cup-2-sorties-sonorit-sport",
        "syst-me-cup-2-sorties-super-sound",
        "tube-cup"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-racing",
          "title": "Catalyseur by-pass racing - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-by-pass-sport-porsche-964",
          "title": "Catalyseur by-pass sport - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100cc-porsche-964",
          "title": "Catalyseur sport 100cc - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cc-porsche-964",
          "title": "Catalyseur standard 300 cc - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "col-de-cygne",
          "title": "Col de cygne - Porsche 911 (964 / 964 Turbo)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collier-964",
          "title": "Collier - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valve-porsche-964",
          "title": "Échappement à valves - Porsche 911 (964)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-riva",
          "title": "Échappement sport Riva - Porsche 911 (964)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-964",
          "title": "Filtre à air sport BMC - Porsche 911 (964)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-montage-964",
          "title": "Kit montage - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-1-sortie-sonorit-sport",
          "title": "Ligne d’échappements à 1 sortie - Sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-2-sorties-sonorit-sport",
          "title": "Ligne d’échappements à 2 sorties - Sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-racing-1-sortie-sonorit-super-sound",
          "title": "Ligne d’échappements Racing à 1 sortie - Sonorité super sound - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-racing-2-sorties-sonorit-super-sound",
          "title": "Ligne d’échappements racing à 2 sorties - Sonorité super sound - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "olive-964",
          "title": "Olive - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-sport",
          "title": "Silencieux arrière droit - Version sport - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-super-sound",
          "title": "Silencieux arrière droit - Version super sound - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sonde-lambda-964",
          "title": "Sonde Lambda - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-avec-ourlet-90mm-insert",
          "title": "Sortie avec ourlet (90mm) + insert - Porsche 911 (964)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-ovale",
          "title": "Sortie ovale - Porsche 911 (964)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "syst-me-cup-1-sortie-sonorit-sport",
          "title": "Système Cup 1 sortie - sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "syst-me-cup-2-sorties-sonorit-sport",
          "title": "Système Cup 2 sorties - sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "syst-me-cup-2-sorties-super-sound",
          "title": "Système Cup 2 sorties - super sound - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-cup",
          "title": "Tube CUP - Porsche 911 (964)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 24,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le catalyseur ou by-pass",
          "d": "L’emplacement de dépollution peut recevoir un catalyseur standard, sport ou un by-pass lorsque disponible.",
          "rects": [
            [
              16.8,
              29.5,
              11.8,
              44.2
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Le plus radical"
          ],
          "journeyTitle": "La même pièce, quatre niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage hors route ouverte.",
          "products": [
            {
              "h": "catalyseur-standard-300-cc-porsche-964",
              "s": 1,
              "l": "Standard 300 cc",
              "d": "Le plus proche du comportement d’origine."
            },
            {
              "h": "catalyseur-sport-100cc-porsche-964",
              "s": 2,
              "l": "Sport 100 cc",
              "d": "Plus libre et plus sportif."
            },
            {
              "h": "catalyseur-by-pass-sport-porsche-964",
              "s": 3,
              "l": "By-pass Sport",
              "d": "Sans catalyseur, avec silencieux intégré."
            },
            {
              "h": "catalyseur-by-pass-racing",
              "s": 4,
              "l": "By-pass Racing",
              "d": "Tube direct sans silencieux."
            }
          ]
        },
        {
          "id": "primary",
          "n": "Le silencieux primaire transversal",
          "d": "Section transversale propre à la Carrera. Le Tube Cup et la solution à valve compatible sont proposés ici.",
          "rects": [
            [
              28.2,
              17.5,
              44.5,
              15.5
            ]
          ],
          "scale": [
            "Direct",
            "Progressif",
            "Pilotable"
          ],
          "journeyTitle": "Le même emplacement, trois réponses",
          "journeyHint": "Direct, progressif ou pilotable",
          "products": [
            {
              "h": "tube-cup",
              "s": 1,
              "l": "Tube CUP",
              "d": "Tube direct en inox fin, sans commande."
            },
            {
              "h": "echappement-sport-riva",
              "s": 2,
              "l": "Riva",
              "d": "Doux à régime stabilisé, agressif à l’accélération."
            },
            {
              "h": "echappement-a-valve-porsche-964",
              "s": 3,
              "l": "Valves fermées / ouvertes",
              "d": "Discret ou très sport à la demande."
            }
          ]
        },
        {
          "id": "secondary",
          "n": "Le silencieux secondaire droit",
          "d": "La dernière section de contrôle sonore avant la sortie unique.",
          "rects": [
            [
              71.8,
              35.2,
              15.2,
              42.8
            ]
          ],
          "scale": [
            "Son proche de l’origine",
            "Puissant et profond"
          ],
          "journeyTitle": "La même pièce, trois sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-arri-re-droit-version-sport",
              "s": 1,
              "l": "Sport",
              "d": "Une présence légèrement renforcée."
            },
            {
              "h": "silencieux-arri-re-droit-version-super-sound",
              "s": 2,
              "l": "Super Sound",
              "d": "Un niveau intermédiaire plus expressif."
            },
            {
              "h": "col-de-cygne",
              "s": 3,
              "l": "Col de cygne",
              "d": "Le choix le plus puissant et profond."
            }
          ]
        },
        {
          "id": "outlet",
          "n": "La sortie d’échappement",
          "d": "La pièce de finition visible à l’arrière de la voiture.",
          "rects": [
            [
              77.5,
              9.2,
              9.2,
              27.5
            ]
          ],
          "scale": [
            "Finition d’origine",
            "Atténuation amovible"
          ],
          "journeyTitle": "La même pièce, deux usages",
          "journeyHint": "Finition ou atténuation amovible",
          "products": [
            {
              "h": "sortie-ovale",
              "s": 1,
              "l": "Sortie ovale",
              "d": "Une finition fidèle à l’origine."
            },
            {
              "h": "sortie-avec-ourlet-90mm-insert",
              "s": 2,
              "l": "Sortie 90 mm avec insert",
              "d": "Insert amovible pour atténuer le son."
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "collier-964",
          "title": "Collier - Porsche 911 (964)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-964",
          "title": "Filtre à air sport BMC - Porsche 911 (964)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-montage-964",
          "title": "Kit montage - Porsche 911 (964)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "olive-964",
          "title": "Olive - Porsche 911 (964)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "sonde-lambda-964",
          "title": "Sonde Lambda - Porsche 911 (964)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 5,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [
        "ACTIVE mais non publié(s) : syst-me-cup-1-sortie-sonorit-super-sound"
      ],
      "aliases": [
        "964"
      ]
    },
    {
      "id": "porsche-911-964-turbo",
      "displayName": "Porsche 911 Turbo 964",
      "shortName": "911 Turbo (964)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "964",
      "generationId": "964",
      "generationLabel": "964 (1989-1994)",
      "period": "1990 - 1994",
      "architecture": "Simple turbo et wastegate",
      "description": "Architecture spécifique à simple turbo, distincte de la Carrera.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-964-turbo",
      "drawingAsset": "porsche-911-964-turbo-undercarriage-exhaust.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-racing-porsche-964-turbo",
        "catalyseur-sport-100-cellules",
        "catalyseur-standard-300-cellules",
        "col-de-cygne",
        "filtre-a-air-sport-bmc-porsche-964-turbo",
        "paire-de-sorties-ovales",
        "silencieux-arri-re-droit-version-sport",
        "silencieux-arri-re-droit-version-super-sound",
        "tube-de-waste-gate"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-racing-porsche-964-turbo",
          "title": "Catalyseur By-Pass Racing - Porsche 964 Turbo",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100-cellules",
          "title": "Catalyseur sport (100 cellules) - Porsche 911 (964 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cellules",
          "title": "Catalyseur standard (300 cellules) - Porsche 911 (964 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "col-de-cygne",
          "title": "Col de cygne - Porsche 911 (964 / 964 Turbo)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-a-air-sport-bmc-porsche-964-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (964 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-ovales",
          "title": "Paire de sorties ovales - Porsche 911 (964 Turbo)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-sport",
          "title": "Silencieux arrière droit - Version sport - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-super-sound",
          "title": "Silencieux arrière droit - Version super sound - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-de-waste-gate",
          "title": "Tube de waste - gate - Porsche 911 (964 Turbo)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 9,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le catalyseur ou by-pass",
          "d": "Du remplacement proche de l’origine au by-pass le plus libre.",
          "rects": [
            [
              20,
              50,
              13,
              27
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Le plus radical"
          ],
          "journeyTitle": "La même pièce, trois niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Le by-pass est réservé à un usage hors route ouverte.",
          "products": [
            {
              "h": "catalyseur-standard-300-cellules",
              "s": 1,
              "l": "Standard 300 cellules"
            },
            {
              "h": "catalyseur-sport-100-cellules",
              "s": 2,
              "l": "Sport 100 cellules"
            },
            {
              "h": "catalyseur-by-pass-racing-porsche-964-turbo",
              "s": 3,
              "l": "By-pass Racing"
            }
          ]
        },
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Il détermine le niveau et la profondeur du son.",
          "rects": [
            [
              69,
              26,
              16,
              50
            ]
          ],
          "scale": [
            "Son proche de l’origine",
            "Puissant et profond"
          ],
          "journeyTitle": "La même pièce, deux sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-arri-re-droit-version-sport",
              "s": 1,
              "l": "Sport"
            },
            {
              "h": "silencieux-arri-re-droit-version-super-sound",
              "s": 2,
              "l": "Super Sound"
            }
          ]
        },
        {
          "id": "link",
          "n": "Le tube de liaison",
          "d": "Il relie le silencieux principal à la sortie d’échappement.",
          "rects": [
            [
              76,
              20,
              6,
              15
            ]
          ],
          "products": [
            {
              "h": "col-de-cygne",
              "l": "Col de cygne"
            }
          ]
        },
        {
          "id": "wastegate",
          "n": "La branche de wastegate",
          "d": "La sortie dédiée de régulation du turbo.",
          "rects": [
            [
              13,
              13,
              19,
              22
            ]
          ],
          "products": [
            {
              "h": "tube-de-waste-gate",
              "l": "Tube de wastegate"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties Turbo",
          "d": "La paire de sorties adaptée à cette architecture.",
          "rects": [
            [
              12,
              9,
              11,
              20
            ],
            [
              82,
              8,
              7,
              14
            ]
          ],
          "products": [
            {
              "h": "paire-de-sorties-ovales",
              "l": "Paire de sorties ovales Turbo"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-a-air-sport-bmc-porsche-964-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (964 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "`catalyseur-by-pass-racing-porsche-964-turbo` n'est rattaché que par mod_le (vehicle_compat absent) : relancer sync_vehicle_compat.py.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : catalyseur-by-pass-racing-porsche-964-turbo"
      ],
      "aliases": [
        "964 Turbo"
      ]
    },
    {
      "id": "porsche-911-993-carrera",
      "displayName": "Porsche 911 Carrera 993",
      "shortName": "911 Carrera (993)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "993",
      "generationId": "993",
      "generationLabel": "993 (1994-1998)",
      "period": "1994 - 1998",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique avec catalyseur transversal et silencieux latéraux.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-993-carrera",
      "drawingAsset": "porsche-911-993-carrera-undercarriage-exhaust.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-racing-by-pass-bischoff",
        "catalyseur-racing-by-pass-gillet",
        "catalyseur-sport-100-cc-bischoff",
        "catalyseur-sport-100-cc-gillet",
        "catalyseur-standard-300-cc-bischoff",
        "catalyseur-standard-300-cc-gillet",
        "echappement-a-valves-porsche-993",
        "filtre-air-sport-bmc-pour-993",
        "kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
        "option-interrupteur-porsche",
        "silencieux-riva",
        "sonde-lambda-pour-porsche-993"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-racing-by-pass-bischoff",
          "title": "Catalyseur racing by-pass - Bischoff - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-racing-by-pass-gillet",
          "title": "Catalyseur racing by-pass - Gillet - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100-cc-bischoff",
          "title": "Catalyseur sport 100 cc - Bischoff - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100-cc-gillet",
          "title": "Catalyseur sport 100 cc - Gillet - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cc-bischoff",
          "title": "Catalyseur standard 300 cc - Bischoff - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cc-gillet",
          "title": "Catalyseur standard 300 cc - Gillet - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valves-porsche-993",
          "title": "Échappement à valves - Porsche 911 (993)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-993",
          "title": "Filtre à air sport BMC - Porsche 911 (993)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
          "title": "Kit de colliers et d'olives pour sorties de silencieux – Porsche 993",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "option-interrupteur-porsche",
          "title": "Option interrupteur - Porsche 911 (993)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-riva",
          "title": "Échappement super sound Type Riva - Porsche 911 (993)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sonde-lambda-pour-porsche-993",
          "title": "Sonde Lambda - Porsche 911 (993)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 12,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le catalyseur transversal double voie",
          "d": "La bonne référence Scart dépend du fournisseur d’origine, Bischoff ou Gillet.",
          "rects": [
            [
              20.5,
              11.8,
              59,
              15.2
            ]
          ],
          "journeyTitle": "La même pièce, trois niveaux",
          "journeyHint": "Selon votre fournisseur d’origine",
          "filter": {
            "label": "Quel est le fournisseur du catalyseur d’origine ?",
            "options": [
              {
                "id": "all",
                "l": "Tous"
              },
              {
                "id": "bischoff",
                "l": "Bischoff"
              },
              {
                "id": "gillet",
                "l": "Gillet"
              }
            ]
          },
          "products": [
            {
              "h": "catalyseur-standard-300-cc-bischoff",
              "f": [
                "bischoff"
              ],
              "s": 1,
              "l": "Standard 300 cc (Bischoff)"
            },
            {
              "h": "catalyseur-sport-100-cc-bischoff",
              "f": [
                "bischoff"
              ],
              "s": 2,
              "l": "Sport 100 cc (Bischoff)"
            },
            {
              "h": "catalyseur-racing-by-pass-bischoff",
              "f": [
                "bischoff"
              ],
              "s": 3,
              "l": "By-pass Racing (Bischoff)"
            },
            {
              "h": "catalyseur-standard-300-cc-gillet",
              "f": [
                "gillet"
              ],
              "s": 1,
              "l": "Standard 300 cc (Gillet)"
            },
            {
              "h": "catalyseur-sport-100-cc-gillet",
              "f": [
                "gillet"
              ],
              "s": 2,
              "l": "Sport 100 cc (Gillet)"
            },
            {
              "h": "catalyseur-racing-by-pass-gillet",
              "f": [
                "gillet"
              ],
              "s": 3,
              "l": "By-pass Racing (Gillet)"
            }
          ]
        },
        {
          "id": "mufflers",
          "n": "Les silencieux gauche et droit",
          "d": "Une paire assortie contrôle le son des deux côtés. Le système à valves apparaît uniquement comme option de cette pièce.",
          "rects": [
            [
              9.5,
              27.5,
              13.5,
              24.5
            ],
            [
              77,
              27.5,
              13.5,
              24.5
            ]
          ],
          "scale": [
            "Sonorité douce",
            "Riva",
            "Valves"
          ],
          "journeyTitle": "Le même emplacement, trois réponses",
          "journeyHint": "Trois signatures acoustiques distinctes",
          "products": [
            {
              "h": "silencieux",
              "g": "sound",
              "s": 1,
              "l": "Sonorité douce",
              "d": "Une présence légèrement renforcée mais très civilisée."
            },
            {
              "h": "silencieux-riva",
              "g": "sound",
              "s": 2,
              "l": "Riva",
              "d": "Une signature sonore fixe, pensée pour rester vivante."
            },
            {
              "h": "echappement-a-valves-porsche-993",
              "g": "valve",
              "s": 3,
              "l": "Valves fermées / ouvertes",
              "d": "Deux caractères accessibles à la demande."
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-993",
          "title": "Filtre à air sport BMC - Porsche 911 (993)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
          "title": "Kit de colliers et d'olives pour sorties de silencieux – Porsche 993",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "option-interrupteur-porsche",
          "title": "Option interrupteur - Porsche 911 (993)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "sonde-lambda-pour-porsche-993",
          "title": "Sonde Lambda - Porsche 911 (993)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 4,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "`kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993` rattaché par mod_le seulement.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
        "ACTIVE mais non publié(s) : silencieux"
      ],
      "aliases": [
        "993"
      ]
    },
    {
      "id": "porsche-911-993-turbo",
      "displayName": "Porsche 911 Turbo 993",
      "shortName": "911 Turbo (993)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "993",
      "generationId": "993",
      "generationLabel": "993 (1994-1998)",
      "period": "1995 - 1998",
      "architecture": "Deux turbos",
      "description": "Architecture à deux turbos avec catalyseurs et silencieux latéraux spécifiques.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-993-turbo",
      "drawingAsset": "porsche-911-993-turbo-undercarriage-exhaust.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-sport-200-cellules",
        "silencieux-sport-riva",
        "silencieux-valves-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-sport-200-cellules",
          "title": "Catalyseur sport (200 cellules) - Porsche 911 (993 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-riva",
          "title": "Échappement super sound Type Riva - Porsche 911 (993 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves-commande-par-interrupteur",
          "title": "Échappement à valves - Porsche 911 (993 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le bloc catalytique Turbo",
          "d": "La paire de catalyseurs sport propre à cette architecture.",
          "rects": [
            [
              20,
              18,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "catalyseur-sport-200-cellules",
              "l": "Catalyseurs Sport 200 cellules"
            }
          ]
        },
        {
          "id": "mufflers",
          "n": "Les silencieux latéraux Turbo",
          "d": "Une sonorité fixe avec Riva, ou modulable avec les valves.",
          "rects": [
            [
              12.5,
              32,
              10.5,
              28
            ],
            [
              77,
              32,
              10.5,
              28
            ]
          ],
          "scale": [
            "Sonorité fixe",
            "Polyvalence à la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande",
          "products": [
            {
              "h": "silencieux-sport-riva",
              "g": "sound",
              "s": 1,
              "l": "Riva",
              "d": "Une signature sonore fixe, pensée pour rester vivante."
            },
            {
              "h": "silencieux-valves-commande-par-interrupteur",
              "g": "sound",
              "s": 2,
              "l": "Valves fermées / ouvertes",
              "d": "Deux caractères accessibles à la demande."
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "option-interrupteur-porsche",
          "title": "Option interrupteur - Porsche 911 (993)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "993 Turbo"
      ]
    },
    {
      "id": "porsche-928-s",
      "displayName": "928 S",
      "shortName": "928 S",
      "brand": "Porsche",
      "model": "928",
      "modelId": "928",
      "generation": "928",
      "generationId": "928",
      "generationLabel": "928 (1977-1995)",
      "period": "1980 - 1986",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-928-s",
      "drawingAsset": "scart-undercarriage-porsche-928-s.webp",
      "logoKey": "porsche-928-s",
      "logoAsset": "scart-logo-porsche-928-s.svg",
      "logoTitle": "928 S",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport",
          "title": "Silencieux sport - Porsche 928 S",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport",
              "l": "Silencieux sport - Porsche 928 S",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet « 928 » couvre 1978-1995 mais le seul produit actif vise la 928 S.",
      "anomalies": [],
      "aliases": [
        "928 S",
        "928"
      ]
    },
    {
      "id": "porsche-928-s4-gt-gts",
      "displayName": "928 S4 / GT / GTS",
      "shortName": "928 S4 / GT / GTS",
      "brand": "Porsche",
      "model": "928",
      "modelId": "928",
      "generation": "928",
      "generationId": "928",
      "generationLabel": "928 (1977-1995)",
      "period": "1987 - 1995",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-928-s4-gt-gts",
      "drawingAsset": "scart-undercarriage-porsche-928-s4-gt-gts.webp",
      "logoKey": "porsche-928-s4",
      "logoAsset": "scart-logo-porsche-928-s4.svg",
      "logoTitle": "928 S4",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-ultima-porsche-928-s4-gt-gts"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-ultima-porsche-928-s4-gt-gts",
          "title": "Échappement sport Ultima - Porsche 928 S4/GT/GTS",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-928-s4-gt-gts",
              "l": "Échappement sport Ultima - Porsche 928 S4/GT/GTS",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet (carte compat PDP vide).",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "928 S4/GT/GTS"
      ]
    },
    {
      "id": "porsche-944-turbo",
      "displayName": "944 Turbo",
      "shortName": "944 Turbo",
      "brand": "Porsche",
      "model": "944",
      "modelId": "944",
      "generation": "944",
      "generationId": "944",
      "generationLabel": "944 (1985-1991)",
      "period": "1985 - 1991",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-944-turbo",
      "drawingAsset": "scart-undercarriage-porsche-944-turbo.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valve-porsche-944-turbo",
        "echappement-sport-ultima-porsche-944-turbo"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valve-porsche-944-turbo",
          "title": "Échappement à valves - Porsche 944 Turbo",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-944-turbo",
          "title": "Échappement Sport Ultima - Porsche 944 Turbo",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-944-turbo",
              "l": "Échappement Sport Ultima - Porsche 944 Turbo",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valve-porsche-944-turbo",
              "l": "Échappement à valves - Porsche 944 Turbo",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet « 944 » déclare aussi 944, 944 S, 944 S2 sans aucun produit actif. `echappement-sport-ultima-porsche-944-turbo` rattaché par mod_le seulement.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : echappement-sport-ultima-porsche-944-turbo"
      ],
      "aliases": [
        "944 Turbo"
      ]
    },
    {
      "id": "porsche-968",
      "displayName": "968",
      "shortName": "968",
      "brand": "Porsche",
      "model": "968",
      "modelId": "968",
      "generation": "968",
      "generationId": "968",
      "generationLabel": "968 (1992-1995)",
      "period": "1992 - 1995",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-968",
      "drawingAsset": "scart-undercarriage-porsche-968.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-avec-silencieux",
        "catalyseur-sport-200cc-porsche-968",
        "echappement-a-valve-porsche-968",
        "silencieux-sport-avec-sortie"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-avec-silencieux",
          "title": "Catalyseur by-pass avec silencieux - Porsche 968",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-200cc-porsche-968",
          "title": "Catalyseur sport 200cc - Porsche 968",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valve-porsche-968",
          "title": "Échappement à valves - Porsche 968",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-sortie",
          "title": "Silencieux sport avec sortie - Porsche 968",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-avec-sortie",
              "l": "Silencieux sport avec sortie - Porsche 968",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valve-porsche-968",
              "l": "Échappement à valves - Porsche 968",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs & by-pass",
          "d": "Catalyseur sport 200 cellules ou by-pass avec silencieux intégré.",
          "rects": [
            [
              32,
              42,
              36,
              20
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseur-by-pass-avec-silencieux",
              "l": "Catalyseur by-pass avec silencieux - Porsche 968",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseur-sport-200cc-porsche-968",
              "l": "Catalyseur sport 200cc - Porsche 968",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "`catalyseur-sport-200cc-porsche-968` rattaché par mod_le seulement.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : catalyseur-sport-200cc-porsche-968"
      ],
      "aliases": [
        "968"
      ]
    },
    {
      "id": "porsche-boxster-986",
      "displayName": "Boxster 986",
      "shortName": "Boxster 986",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "986",
      "generationId": "986",
      "generationLabel": "986 (1996-2004)",
      "period": "1996 - 2004",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-986",
      "drawingAsset": "scart-undercarriage-porsche-boxster-986.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-200cc-2-7l-3-2l",
        "catalyseurs-200cc-pour-porsche-986-2-5l",
        "catalyseurs-by-pass-porsche-986-2-7l-3-2l",
        "filtre-air-sport-bmc-pour-986",
        "inter-pse-996-986",
        "paire-de-collecteurs-inox-scart-pour-porsche-boxster-986",
        "silencieux-sport-sortie-double",
        "silencieux-sport-valves-commande-par-interrupteur-sortie-double"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-200cc-2-7l-3-2l",
          "title": "Catalyseurs 200cc 2,7L & 3,2L - Porsche Boxster (986)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-200cc-pour-porsche-986-2-5l",
          "title": "Catalyseurs 200CC - 2.5L - Porsche Boxster (986)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-by-pass-porsche-986-2-7l-3-2l",
          "title": "Catalyseurs by-pass - 2,7L & 3.2L - Porsche Boxster (986)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-986",
          "title": "Filtre à air sport BMC - Porsche Boxster (986)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "inter-pse-996-986",
          "title": "Inter PSE 996/ - Porsche Boxster (986)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-collecteurs-inox-scart-pour-porsche-boxster-986",
          "title": "Paire de collecteurs Inox SCART - Porsche Boxster (986)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sortie-double",
          "title": "Échappement sport + sortie double - Porsche Boxster (986)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-valves-commande-par-interrupteur-sortie-double",
          "title": "Silencieux sport à valves (commande par interrupteur) + sortie double - Porsche Boxster (986)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 8,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-sortie-double",
              "l": "Échappement sport + sortie double - Porsche Boxster (986)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-valves-commande-par-interrupteur-sortie-double",
              "l": "Silencieux sport à valves (commande par interrupteur) + sortie double - Porsche Boxster (986)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-200cc-2-7l-3-2l",
              "l": "Catalyseurs 200cc 2,7L & 3,2L - Porsche Boxster (986)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-200cc-pour-porsche-986-2-5l",
              "l": "Catalyseurs 200CC - 2.5L - Porsche Boxster (986)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-by-pass-porsche-986-2-7l-3-2l",
              "l": "Catalyseurs by-pass - 2,7L & 3.2L - Porsche Boxster (986)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "paire-de-collecteurs-inox-scart-pour-porsche-boxster-986",
              "l": "Paire de collecteurs Inox SCART - Porsche Boxster (986)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-986",
          "title": "Filtre à air sport BMC - Porsche Boxster (986)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "inter-pse-996-986",
          "title": "Inter PSE 996/ - Porsche Boxster (986)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "986",
        "Boxster 986"
      ]
    },
    {
      "id": "porsche-boxster-987-1",
      "displayName": "Boxster / Cayman 987 phase 1",
      "shortName": "Boxster/Cayman 987.1",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "987",
      "generationId": "987-1",
      "generationLabel": "987.1 (2004-2008)",
      "period": "2004 - 2008",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-987-1",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-1.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": true,
      "activeProductHandles": [
        "barrette-3-touches-pse-porsche-997",
        "collecteurs-catalyseurs-sport-200cc",
        "echappement-a-valves-porsche-987",
        "echappement-sport-ultima-porsche-987",
        "filtre-air-sport-bmc-pour-987",
        "kit-barrette-4-touches-pse-porsche-997",
        "kit-de-suppression-de-coupure-pse-1",
        "sortie-double-biseaut-e-2x88-chrom-e",
        "sorties-double-black-c-ramique-grand-diam-tre-2x88",
        "y"
      ],
      "activeProducts": [
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-catalyseurs-sport-200cc",
          "title": "Collecteurs + catalyseurs sport 200cc - Porsche Boxster (987)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valves-porsche-987",
          "title": "Échappement à valves - Porsche Boxster (987)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-987",
          "title": "Échappement sport Ultima - Porsche Boxster (987)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "sortie-double-biseaut-e-2x88-chrom-e",
          "title": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
          "title": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "y",
          "title": "Y - Porsche Boxster (987 / 987-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 10,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-987",
              "l": "Échappement sport Ultima - Porsche Boxster (987)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valves-porsche-987",
              "l": "Échappement à valves - Porsche Boxster (987)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "mid",
          "n": "Le tube Y intermédiaire",
          "d": "Tube de liaison en Y équilibrant les flux entre les bancs de cylindres.",
          "rects": [
            [
              34,
              22,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "y",
              "l": "Y - Porsche Boxster (987 / 987-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-200cc",
              "l": "Collecteurs + catalyseurs sport 200cc - Porsche Boxster (987)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              40,
              6,
              20,
              12
            ]
          ],
          "products": [
            {
              "h": "sortie-double-biseaut-e-2x88-chrom-e",
              "l": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            },
            {
              "h": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
              "l": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        }
      ],
      "accessoriesCount": 4,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "987",
        "Boxster 987",
        "Boxster 987-1"
      ]
    },
    {
      "id": "porsche-boxster-987-2",
      "displayName": "Boxster / Cayman 987 phase 2",
      "shortName": "Boxster/Cayman 987.2",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "987",
      "generationId": "987-2",
      "generationLabel": "987.2 (2009-2012)",
      "period": "2008 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-987-2",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-2.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": true,
      "activeProductHandles": [
        "collecteurs-catalyseurs-sport-porsche-987-2",
        "echappement-a-valves-porsche-987-2",
        "echappement-sport-ultima-porsche-987-2",
        "filtre-air-sport-bmc-pour-987",
        "kit-barrette-3-touches-porsche-987-2",
        "kit-barrette-4-touches-amortisseur-porsche-987-2",
        "kit-barrette-4-touches-sport-porsche-987-2",
        "kit-barrette-5-touches-amortisseur-porsche-987-2",
        "kit-barrette-5-touches-sport-porsche-987-2",
        "kit-barrette-6-touches-porsche-987-2",
        "kit-de-suppression-de-coupure-pse-1",
        "sortie-double-biseaut-e-2x88-chrom-e",
        "sorties-double-black-c-ramique-grand-diam-tre-2x88",
        "y"
      ],
      "activeProducts": [
        {
          "handle": "collecteurs-catalyseurs-sport-porsche-987-2",
          "title": "Collecteurs/Catalyseurs sport 200cc - 987-2 - Porsche Boxster (987-2)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valves-porsche-987-2",
          "title": "Échappement à valves - 987-2 - Porsche Boxster (987-2)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-987-2",
          "title": "Échappement sport Ultima - 987-2 - Porsche Boxster (987-2)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-3-touches-porsche-987-2",
          "title": "Kit Barrette 3 touches - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 4 touches Amortisseur - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-sport-porsche-987-2",
          "title": "Kit Barrette 4 touches sport - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-5-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 5 touches amortisseur - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-5-touches-sport-porsche-987-2",
          "title": "Kit Barrette 5 touches sport - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-6-touches-porsche-987-2",
          "title": "Kit Barrette 6 touches - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "sortie-double-biseaut-e-2x88-chrom-e",
          "title": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
          "title": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "y",
          "title": "Y - Porsche Boxster (987 / 987-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 14,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-987-2",
              "l": "Échappement sport Ultima - 987-2 - Porsche Boxster (987-2)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valves-porsche-987-2",
              "l": "Échappement à valves - 987-2 - Porsche Boxster (987-2)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "mid",
          "n": "Le tube Y intermédiaire",
          "d": "Tube de liaison en Y équilibrant les flux entre les bancs de cylindres.",
          "rects": [
            [
              34,
              22,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "y",
              "l": "Y - Porsche Boxster (987 / 987-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-porsche-987-2",
              "l": "Collecteurs/Catalyseurs sport 200cc - 987-2 - Porsche Boxster (987-2)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              40,
              6,
              20,
              12
            ]
          ],
          "products": [
            {
              "h": "sortie-double-biseaut-e-2x88-chrom-e",
              "l": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            },
            {
              "h": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
              "l": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-barrette-3-touches-porsche-987-2",
          "title": "Kit Barrette 3 touches - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-4-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 4 touches Amortisseur - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-4-touches-sport-porsche-987-2",
          "title": "Kit Barrette 4 touches sport - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-5-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 5 touches amortisseur - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-5-touches-sport-porsche-987-2",
          "title": "Kit Barrette 5 touches sport - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-6-touches-porsche-987-2",
          "title": "Kit Barrette 6 touches - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        }
      ],
      "accessoriesCount": 8,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "987-2",
        "Boxster 987-2"
      ]
    },
    {
      "id": "porsche-boxster-981",
      "displayName": "Boxster / Cayman 981",
      "shortName": "Boxster/Cayman 981",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "981",
      "generationId": "981",
      "generationLabel": "981 (2012-2016)",
      "period": "2012 - 2016",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-981",
      "drawingAsset": "scart-undercarriage-porsche-boxster-981.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-porsche-981",
        "filtres-air-sport-bmc-pour-981",
        "paire-de-collecteurs-catalyseurs-sport-200cc",
        "platine-pse-avec-raccord-scart",
        "sport-ultima-r-cital"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-porsche-981",
          "title": "Échappement à valves - Porsche Boxster (981)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtres-air-sport-bmc-pour-981",
          "title": "Filtres à air sport BMC - Porsche Boxster (981)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-collecteurs-catalyseurs-sport-200cc",
          "title": "Paire de collecteurs catalyseurs sport 200cc - Porsche Boxster (981)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sport-ultima-r-cital",
          "title": "Sport - Ultima Récital - Porsche Boxster (981)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 5,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "sport-ultima-r-cital",
              "l": "Sport - Ultima Récital - Porsche Boxster (981)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valves-porsche-981",
              "l": "Échappement à valves - Porsche Boxster (981)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "paire-de-collecteurs-catalyseurs-sport-200cc",
              "l": "Paire de collecteurs catalyseurs sport 200cc - Porsche Boxster (981)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtres-air-sport-bmc-pour-981",
          "title": "Filtres à air sport BMC - Porsche Boxster (981)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "category": "bracket",
          "description": "Platine support PSE avec raccord spécifique SCART."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "981",
        "Boxster 981"
      ]
    },
    {
      "id": "porsche-718-4-0",
      "displayName": "718 Spyder / Cayman GT4 4.0",
      "shortName": "718 4.0 L (Spyder/GT4)",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "718",
      "generationId": "718",
      "generationLabel": "718 (2016+)",
      "period": "2019 - 2024",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-718-4-0",
      "drawingAsset": "scart-undercarriage-porsche-718-4-0.webp",
      "logoKey": "porsche-718-spyder",
      "logoAsset": "scart-logo-porsche-718-spyder.svg",
      "logoTitle": "718 Spyder",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catback-ca-sent-la-poudre",
        "filtre-air-sport-bmc-pour-718",
        "xp"
      ],
      "activeProducts": [
        {
          "handle": "catback-ca-sent-la-poudre",
          "title": "Échappement sport à valves - Porsche Boxster 718 Spyder et GT4",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-718",
          "title": "Filtre à air sport BMC - Porsche Boxster (718)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "xp",
          "title": "X - Pipe - Porsche Boxster (718 4.0L)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "catback-ca-sent-la-poudre",
              "l": "Échappement sport à valves - Porsche Boxster 718 Spyder et GT4",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le X-Pipe intermédiaire",
          "d": "Liaison intermédiaire en X optimisant l’équilibre et la résonance des flux.",
          "rects": [
            [
              34,
              24,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "xp",
              "l": "X - Pipe - Porsche Boxster (718 4.0L)",
              "type": "Tube"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-718",
          "title": "Filtre à air sport BMC - Porsche Boxster (718)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le libellé `718` seul ne porte qu'un filtre à air BMC ; les deux produits d'échappement visent le 4.0 L atmosphérique (Spyder / GT4). Les 718 quatre cylindres turbo n'ont aucun échappement SCART : la famille visuelle est celle du 4.0 L.",
      "anomalies": [],
      "aliases": [
        "718 4.0L",
        "718",
        "Boxster 718",
        "Cayman 718"
      ]
    },
    {
      "id": "porsche-718-gt4-rs",
      "displayName": "718 Cayman GT4 RS",
      "shortName": "718 Cayman GT4 RS",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "718",
      "generationId": "718",
      "generationLabel": "718 (2016+)",
      "period": "2022 - 2024",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-718-gt4-rs",
      "drawingAsset": "scart-undercarriage-porsche-718-gt4-rs.webp",
      "logoKey": "porsche-718-gt4-rs",
      "logoAsset": "scart-logo-porsche-718-gt4-rs.svg",
      "logoTitle": "GT4 RS",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "x-pipe-porsche-718-gt4-rs"
      ],
      "activeProducts": [
        {
          "handle": "x-pipe-porsche-718-gt4-rs",
          "title": "X - pipe - Porsche Boxster (718 GT4 RS)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "mid",
          "n": "Le X-Pipe intermédiaire",
          "d": "Liaison intermédiaire en X optimisant l’équilibre et la résonance des flux.",
          "rects": [
            [
              34,
              24,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "x-pipe-porsche-718-gt4-rs",
              "l": "X - pipe - Porsche Boxster (718 GT4 RS)",
              "type": "Tube"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet (carte compat PDP vide). Ligne d'origine différente du GT4 4.0 (silencieux central, sorties), famille séparée.",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "718 GT4 RS"
      ]
    },
    {
      "id": "porsche-911-996-carrera",
      "displayName": "911 Carrera (996) 3.4 / 3.6",
      "shortName": "911 Carrera (996)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "996",
      "generationId": "996",
      "generationLabel": "996 (1997-2005)",
      "period": "1997 - 2005",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-996-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-996-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-sport-200cc-996-3-4l",
        "catalyseurs-sport-200cc-996-3-6l",
        "collier-silencieux-sortie",
        "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
        "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
        "filtre-air-sport-bmc-pour-996",
        "inter-pse-996-987",
        "manchon-catalyseur-porsche-996",
        "manchon-catalyseur-silencieux",
        "silencieux-avec-valves-996-3-4l-commande-par-interrupteur",
        "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
        "sorties-double-chrom-e-pour-996-4s"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-sport-200cc-996-3-4l",
          "title": "Catalyseurs sport 200cc - 3,4L - Porsche 911 (996)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-200cc-996-3-6l",
          "title": "Catalyseurs sport 200cc - 3,6L - Porsche 911 (996)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collier-silencieux-sortie",
          "title": "Collier Silencieux > Sortie - Porsche 911 (996)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
          "title": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
          "title": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-996",
          "title": "Filtre à air sport BMC - Porsche 911 (996)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "inter-pse-996-987",
          "title": "Inter PSE /986 - Porsche 911 (996)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-avec-valves-996-3-4l-commande-par-interrupteur",
          "title": "Échappement à valves - 3,4L - Porsche 911 (996)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
          "title": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-chrom-e-pour-996-4s",
          "title": "Sorties double chromée pour 4S - Porsche 911 (996)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 12,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux gauche et droit conférant la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
              "l": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 1,
              "g": "sound",
              "l_short": "Sonorité douce"
            },
            {
              "h": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
              "l": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-avec-valves-996-3-4l-commande-par-interrupteur",
              "l": "Échappement à valves - 3,4L - Porsche 911 (996)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
              "l": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport-200cc-996-3-4l",
              "l": "Catalyseurs sport 200cc - 3,4L - Porsche 911 (996)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-sport-200cc-996-3-6l",
              "l": "Catalyseurs sport 200cc - 3,6L - Porsche 911 (996)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-double-chrom-e-pour-996-4s",
              "l": "Sorties double chromée pour 4S - Porsche 911 (996)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "collier-silencieux-sortie",
          "title": "Collier Silencieux > Sortie - Porsche 911 (996)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-996",
          "title": "Filtre à air sport BMC - Porsche 911 (996)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "inter-pse-996-987",
          "title": "Inter PSE /986 - Porsche 911 (996)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        }
      ],
      "accessoriesCount": 5,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Split 3,4 L / 3,6 L uniquement sur les catalyseurs et les valves ; même dessous.",
      "anomalies": [],
      "aliases": [
        "996"
      ]
    },
    {
      "id": "porsche-911-996-gt3",
      "displayName": "911 GT3 (996)",
      "shortName": "911 GT3 (996)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "996",
      "generationId": "996",
      "generationLabel": "996 (1997-2005)",
      "period": "1999 - 2005",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-996-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-996-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-sport-200-cellules-pour-996-gt3-phase-1",
        "catalyseurs-sport-200-cellules-pour-996-gt3-phase-2",
        "collecteurs-inox-brides-forg-es",
        "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
        "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
        "filtre-air-sport-pour-996-gt3",
        "manchon-catalyseur-porsche-996",
        "silencieux-avec-valves-996-3-6l-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-1",
          "title": "Catalyseurs sport (200 cellules) pour phase 1 - Porsche 911 (996 GT3)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-2",
          "title": "Catalyseurs sport (200 cellules) pour phase 2 - Porsche 911 (996 GT3)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-inox-brides-forg-es",
          "title": "Collecteurs Inox - brides forgées - Porsche 911 (996 GT3)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
          "title": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
          "title": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-pour-996-gt3",
          "title": "Filtre à air sport - Porsche 911 (996 GT3)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
          "title": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 8,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux gauche et droit conférant la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
              "l": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 1,
              "g": "sound",
              "l_short": "Sonorité douce"
            },
            {
              "h": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
              "l": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
              "l": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-1",
              "l": "Catalyseurs sport (200 cellules) pour phase 1 - Porsche 911 (996 GT3)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-2",
              "l": "Catalyseurs sport (200 cellules) pour phase 2 - Porsche 911 (996 GT3)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-inox-brides-forg-es",
              "l": "Collecteurs Inox - brides forgées - Porsche 911 (996 GT3)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-pour-996-gt3",
          "title": "Filtre à air sport - Porsche 911 (996 GT3)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "996 GT3"
      ]
    },
    {
      "id": "porsche-911-996-turbo",
      "displayName": "911 Turbo (996)",
      "shortName": "911 Turbo (996)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "996",
      "generationId": "996",
      "generationLabel": "996 (1997-2005)",
      "period": "2000 - 2005",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-996-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-996-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-200-cellules-silencieux",
        "collecteurs-sport-brides-forg-es",
        "echappement-sport-interrupteur",
        "filtre-air-sport-bmc-pour-996-turbo"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-200-cellules-silencieux",
          "title": "Catalyseurs 200 cellules + Échappement sport - Porsche 911 (996 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-sport-brides-forg-es",
          "title": "Collecteurs inox sport - Porsche 911 (996 Turbo)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-interrupteur",
          "title": "Échappement à valves - Porsche 911 (996 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-996-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (996 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "L’échappement central",
          "d": "L’échappement central détermine la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "catalyseurs-200-cellules-silencieux",
              "l": "Catalyseurs 200 cellules + Échappement sport - Porsche 911 (996 Turbo)",
              "type": "Catalyseur",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-interrupteur",
              "l": "Échappement à valves - Porsche 911 (996 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-sport-brides-forg-es",
              "l": "Collecteurs inox sport - Porsche 911 (996 Turbo)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-996-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (996 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "996 Turbo"
      ]
    },
    {
      "id": "porsche-911-997-1-carrera",
      "displayName": "911 Carrera (997.1), PSE, Sport Classic",
      "shortName": "911 Carrera (997.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-1",
      "generationLabel": "997.1 (2004-2008)",
      "period": "2004 - 2008",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-1-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": true,
      "activeProductHandles": [
        "3-6l-valves-interrupteur",
        "3-8l-valves-interrupteur",
        "barrette-3-touches-pse-porsche-997",
        "catalyseurs-sport-200-cellules-pour-porsche-997",
        "catalyseurs-standard-300cc",
        "collecteurs-sport-pour-997",
        "filtre-air-sport-bmc-pour-997",
        "kit-barrette-4-touches-pse-porsche-997",
        "kit-de-suppression-de-coupure-pse",
        "manchon-catalyseur-silencieux",
        "paire-de-silencieux-pse",
        "paire-de-sorties-double-2x88-bross-e",
        "paire-de-sorties-double-2x88-chrom-e",
        "paire-de-sorties-double-2x88-noire",
        "silencieux-sport-classic",
        "silencieux-sport-ultima-r-cital",
        "valves-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "3-6l-valves-interrupteur",
          "title": "Échappement à valves - 3.6L - Porsche 911 (997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "3-8l-valves-interrupteur",
          "title": "Échappement à valves - 3.8L - Porsche 911 (997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-200-cellules-pour-porsche-997",
          "title": "Catalyseurs sport (200 cellules) - Porsche 911 (997)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-standard-300cc",
          "title": "Catalyseurs standard 300cc - Porsche 911 (997)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-sport-pour-997",
          "title": "Collecteurs sport pour - Porsche 911 (997)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997",
          "title": "Filtre à air sport BMC - Porsche 911 (997)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-silencieux-pse",
          "title": "Échappement sport à valves - équipée du - Porsche 911 (997 PSE / 997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-bross-e",
          "title": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-chrom-e",
          "title": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-noire",
          "title": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-classic",
          "title": "Silencieux sport Classic - Porsche 911 (997)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-ultima-r-cital",
          "title": "Silencieux sport Ultima Récital - Porsche 911 (997)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "valves-interrupteur",
          "title": "Échappement à valves - sport classic/Speedster - Porsche 911 (997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 17,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux gauche et droit conférant la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-classic",
              "l": "Silencieux sport Classic - Porsche 911 (997)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-ultima-r-cital",
              "l": "Silencieux sport Ultima Récital - Porsche 911 (997)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "3-6l-valves-interrupteur",
              "l": "Échappement à valves - 3.6L - Porsche 911 (997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "3-8l-valves-interrupteur",
              "l": "Échappement à valves - 3.8L - Porsche 911 (997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "paire-de-silencieux-pse",
              "l": "Échappement sport à valves - équipée du - Porsche 911 (997 PSE / 997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "valves-interrupteur",
              "l": "Échappement à valves - sport classic/Speedster - Porsche 911 (997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport-200-cellules-pour-porsche-997",
              "l": "Catalyseurs sport (200 cellules) - Porsche 911 (997)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-standard-300cc",
              "l": "Catalyseurs standard 300cc - Porsche 911 (997)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-sport-pour-997",
              "l": "Collecteurs sport pour - Porsche 911 (997)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "paire-de-sorties-double-2x88-bross-e",
              "l": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-chrom-e",
              "l": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-noire",
              "l": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997",
          "title": "Filtre à air sport BMC - Porsche 911 (997)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        }
      ],
      "accessoriesCount": 5,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "PSE et Sport Classic / Speedster : mêmes positions de zones, silencieux d'origine différents. Un seul dessin, branches produit distinctes (même décision que la 997.2).",
      "anomalies": [],
      "aliases": [
        "997",
        "997 PSE"
      ]
    },
    {
      "id": "porsche-911-997-1-gt3",
      "displayName": "911 GT3 (997.1)",
      "shortName": "911 GT3 (997.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-1",
      "generationLabel": "997.1 (2004-2008)",
      "period": "2006 - 2008",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-1-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              26,
              22,
              48,
              21
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997 GT3"
      ]
    },
    {
      "id": "porsche-911-997-1-turbo",
      "displayName": "911 Turbo (997.1)",
      "shortName": "911 Turbo (997.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-1",
      "generationLabel": "997.1 (2004-2008)",
      "period": "2006 - 2008",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-1-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "collecteurs-avec-brides-en-inox-forg-diam-45",
        "echappement-sport-a-valves-porsche-997-turbo",
        "echappements-sport-catalyseurs-silencieux",
        "filtre-air-sport-pour-997-turbo-1"
      ],
      "activeProducts": [
        {
          "handle": "collecteurs-avec-brides-en-inox-forg-diam-45",
          "title": "Collecteurs avec brides en Inox forgé (Diam 45) - Porsche 911 (997 Turbo)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valves-porsche-997-turbo",
          "title": "Échappement sport à valves - Porsche 911 (997 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-catalyseurs-silencieux",
          "title": "Échappements sport (Catalyseurs + silencieux) - Porsche 911 (997 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-pour-997-turbo-1",
          "title": "Filtre à air sport pour 1 - Porsche 911 (997 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "L’échappement central",
          "d": "L’échappement central détermine la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappements-sport-catalyseurs-silencieux",
              "l": "Échappements sport (Catalyseurs + silencieux) - Porsche 911 (997 Turbo)",
              "type": "Ligne complète",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-997-turbo",
              "l": "Échappement sport à valves - Porsche 911 (997 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-avec-brides-en-inox-forg-diam-45",
              "l": "Collecteurs avec brides en Inox forgé (Diam 45) - Porsche 911 (997 Turbo)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-pour-997-turbo-1",
          "title": "Filtre à air sport pour 1 - Porsche 911 (997 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997 Turbo"
      ]
    },
    {
      "id": "porsche-911-997-2-carrera",
      "displayName": "911 Carrera (997.2) sans PSE",
      "shortName": "911 Carrera 997.2 (sans PSE)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2008 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": true,
      "activeProductHandles": [
        "barrette-3-touches",
        "barrette-4-touches-amortisseurs",
        "barrette-4-touches-sport",
        "barrette-5-touches-amortisseurs",
        "barrette-5-touches-sport",
        "barrette-6-touches",
        "collecteurs-catalyseurs-sport-200-cc",
        "echappement-central-a-valves-porsche-997-2-3-6l",
        "echappement-central-a-valves-porsche-997-2-3-8l",
        "filtres-air-sport-bmc-pour-997-2",
        "kit-de-suppression-de-coupure-pse",
        "kit-interrupteur-pse-5-touches",
        "paire-de-sorties-double-2x88-bross-e",
        "paire-de-sorties-double-2x88-chrom-e",
        "paire-de-sorties-double-2x88-noire",
        "r-paration-fiabilisation-silencieux",
        "x-pipe-central"
      ],
      "activeProducts": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-catalyseurs-sport-200-cc",
          "title": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-central-a-valves-porsche-997-2-3-6l",
          "title": "Échappement central à valves - 997-2 3.6L - Porsche 911 (997-2)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-central-a-valves-porsche-997-2-3-8l",
          "title": "Échappement central à valves - 997-2 3.8L - Porsche 911 (997-2)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtres-air-sport-bmc-pour-997-2",
          "title": "Filtres à air sport BMC pour 997-2 - Porsche 911 (997-2)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-bross-e",
          "title": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-chrom-e",
          "title": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-noire",
          "title": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "r-paration-fiabilisation-silencieux",
          "title": "Réparation / Fiabilisation silencieux - Porsche 911 (997-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central",
          "title": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 17,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-a-valves-porsche-997-2-3-6l",
              "l": "Échappement central à valves - 997-2 3.6L - Porsche 911 (997-2)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-central-a-valves-porsche-997-2-3-8l",
              "l": "Échappement central à valves - 997-2 3.8L - Porsche 911 (997-2)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le X-Pipe central",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-central",
              "l": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-200-cc",
              "l": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "paire-de-sorties-double-2x88-bross-e",
              "l": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-chrom-e",
              "l": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-noire",
              "l": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtres-air-sport-bmc-pour-997-2",
          "title": "Filtres à air sport BMC pour 997-2 - Porsche 911 (997-2)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "r-paration-fiabilisation-silencieux",
          "title": "Réparation / Fiabilisation silencieux - Porsche 911 (997-2)",
          "category": "service",
          "description": "Prestation d’atelier de rénovation et fiabilisation des silencieux d’origine."
        }
      ],
      "accessoriesCount": 10,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997-2",
        "997-2 avec PSE"
      ]
    },
    {
      "id": "porsche-911-997-2-carrera-pse",
      "displayName": "911 Carrera (997.2) avec PSE",
      "shortName": "911 Carrera 997.2 (avec PSE)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2008 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-carrera.webp",
      "logoKey": "porsche-pse",
      "logoAsset": "scart-logo-porsche-carrera-pse.svg",
      "logoTitle": "Carrera + PSE",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "collecteurs-catalyseurs-sport-200-cc",
        "echappement-valves-3-6l-pse-interrupteur-on-off-inclus",
        "echappement-valves-3-8l-pour-997-2-quip-e-pse",
        "sorties-double-bross-es",
        "sorties-double-pse-noir-mat",
        "sorties-echappements-porsche-997-2-pse",
        "sorties-pse-double-chrom-e",
        "x-pipe-central"
      ],
      "activeProducts": [
        {
          "handle": "collecteurs-catalyseurs-sport-200-cc",
          "title": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-valves-3-6l-pse-interrupteur-on-off-inclus",
          "title": "Échappement à valves - 997-2 3,6L équipée - Porsche 911 (997-2 PSE)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-valves-3-8l-pour-997-2-quip-e-pse",
          "title": "Échappement à valves 3,8L - pour 997-2 équipée - Porsche 911 (997-2 PSE)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-bross-es",
          "title": "Sorties double brossées - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-pse-noir-mat",
          "title": "Sorties double noir mat - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-echappements-porsche-997-2-pse",
          "title": "Paire de sorties d'échappements - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-pse-double-chrom-e",
          "title": "Sorties double chromée - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central",
          "title": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 8,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-valves-3-6l-pse-interrupteur-on-off-inclus",
              "l": "Échappement à valves - 997-2 3,6L équipée - Porsche 911 (997-2 PSE)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-valves-3-8l-pour-997-2-quip-e-pse",
              "l": "Échappement à valves 3,8L - pour 997-2 équipée - Porsche 911 (997-2 PSE)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le X-Pipe central",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-central",
              "l": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-200-cc",
              "l": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-double-bross-es",
              "l": "Sorties double brossées - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            },
            {
              "h": "sorties-double-pse-noir-mat",
              "l": "Sorties double noir mat - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            },
            {
              "h": "sorties-echappements-porsche-997-2-pse",
              "l": "Paire de sorties d'échappements - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            },
            {
              "h": "sorties-pse-double-chrom-e",
              "l": "Sorties double chromée - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Décision Jérémie 04/09/2026 : réutilise le dessin C1 de la Carrera sans PSE ; branche produit distincte.",
      "anomalies": [],
      "aliases": [
        "997-2 PSE"
      ]
    },
    {
      "id": "porsche-911-997-2-gt3",
      "displayName": "911 GT3 / GT3 RS (997.2)",
      "shortName": "911 GT3 / RS (997.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2009 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "logoKey": "porsche-gt3-rs",
      "logoAsset": "scart-porsche-gt3-rs-wordmark.png",
      "logoTitle": "GT3 RS",
      "logoFormat": "png",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet contient les alias `997-2 GT3` et `997-2 GT2 RS` mais aucun alias `997-2 GT3 RS`. Ne pas corriger Shopify dans ce chantier.",
      "anomalies": [],
      "aliases": [
        "997-2 GT3"
      ]
    },
    {
      "id": "porsche-911-997-2-gt2-rs",
      "displayName": "911 GT2 RS (997.2)",
      "shortName": "911 GT2 RS (997.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2010 - 2011",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-gt2-rs",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt2-rs.webp",
      "logoKey": "porsche-gt2-rs",
      "logoAsset": "scart-porsche-gt2-rs-wordmark.png",
      "logoTitle": "GT2 RS",
      "logoFormat": "png",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappements-valves-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "echappements-valves-commande-par-interrupteur",
          "title": "Échappement à valves - 997-2 - Porsche 911 (997-2 GT2 RS)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappements-valves-commande-par-interrupteur",
              "l": "Échappement à valves - 997-2 - Porsche 911 (997-2 GT2 RS)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Rangée sous le métaobjet « 997-2 GT3 » (alias `997-2 GT2 RS`) alors que l'architecture est celle d'un Turbo : famille visuelle séparée, décision validée.",
      "anomalies": [],
      "aliases": [
        "997-2 GT2 RS"
      ]
    },
    {
      "id": "porsche-911-997-2-turbo",
      "displayName": "911 Turbo / Turbo S (997.2)",
      "shortName": "911 Turbo (997.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2010 - 2012",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "barrette-3-touches",
        "barrette-4-touches-amortisseurs",
        "barrette-4-touches-sport",
        "barrette-5-touches-amortisseurs",
        "barrette-5-touches-sport",
        "barrette-6-touches",
        "echappements-sport-valves-commande-par-interrupteur",
        "filtre-air-sport-bmc-pour-997-turbo-2",
        "kit-interrupteur-pse-5-touches",
        "sport-200-cc"
      ],
      "activeProducts": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-valves-commande-par-interrupteur",
          "title": "Échappement sport à valves - 997-2 /S - Porsche 911 (997-2 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997-turbo-2",
          "title": "Filtre à air sport BMC pour 997 2 - Porsche 911 (997-2 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sport-200-cc",
          "title": "Catalyseurs Sports 200 cc - 997.2 /S - Porsche 911 (997-2 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 10,
      "zones": [
        {
          "id": "muffler",
          "n": "L’échappement central",
          "d": "L’échappement central détermine la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappements-sport-valves-commande-par-interrupteur",
              "l": "Échappement sport à valves - 997-2 /S - Porsche 911 (997-2 Turbo)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "sport-200-cc",
              "l": "Catalyseurs Sports 200 cc - 997.2 /S - Porsche 911 (997-2 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997-turbo-2",
          "title": "Filtre à air sport BMC pour 997 2 - Porsche 911 (997-2 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 8,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997-2 Turbo"
      ]
    },
    {
      "id": "porsche-911-991-1-carrera",
      "displayName": "911 Carrera (991.1)",
      "shortName": "911 Carrera (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2011 - 2015",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-1-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re-valves-commande-par-interrupteur",
        "echappement-sport-ultima-porsche-991",
        "platine-pse-avec-raccord-scart",
        "sortie-echappement-noires-porsche-991"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re-valves-commande-par-interrupteur",
          "title": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-991",
          "title": "Échappement sport Ultima - Porsche 911 (991)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-echappement-noires-porsche-991",
          "title": "Paire de sortie Black - Porsche 911 (991)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-991",
              "l": "Échappement sport Ultima - Porsche 911 (991)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-central-arri-re-valves-commande-par-interrupteur",
              "l": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sortie-echappement-noires-porsche-991",
              "l": "Paire de sortie Black - Porsche 911 (991)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "category": "bracket",
          "description": "Platine support PSE avec raccord spécifique SCART."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991"
      ]
    },
    {
      "id": "porsche-911-991-1-carrera-pse",
      "displayName": "911 Carrera (991.1) avec PSE",
      "shortName": "911 Carrera (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2011 - 2015",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-1-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re-valves-commande-par-interrupteur",
        "paire-de-sortie-chrom",
        "paire-de-sorties-bross-es"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re-valves-commande-par-interrupteur",
          "title": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sortie-chrom",
          "title": "Paire de sortie Chromé - Porsche 911 (991 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-bross-es",
          "title": "Paire de sorties Brossées - Porsche 911 (991 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re-valves-commande-par-interrupteur",
              "l": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "paire-de-sortie-chrom",
              "l": "Paire de sortie Chromé - Porsche 911 (991 PSE)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-bross-es",
              "l": "Paire de sorties Brossées - Porsche 911 (991 PSE)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Même architecture que la Carrera sans PSE ; le silencieux central à valves SCART est le même produit pour les deux. Dessin partagé, branche produit distincte.",
      "anomalies": [],
      "aliases": [
        "991 PSE"
      ]
    },
    {
      "id": "porsche-911-991-1-gt3",
      "displayName": "911 GT3 (991.1)",
      "shortName": "911 GT3 (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2013 - 2015",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991 GT3"
      ]
    },
    {
      "id": "porsche-911-991-1-turbo",
      "displayName": "911 Turbo (991.1)",
      "shortName": "911 Turbo (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2013 - 2015",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-valves-pour-991-turbo-phase-1-interrupteur",
        "filtre-air-sport-bmc-pour-991"
      ],
      "activeProducts": [
        {
          "handle": "echappement-valves-pour-991-turbo-phase-1-interrupteur",
          "title": "Échappement à valves - Porsche 911 (991 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-991",
          "title": "Filtre à air sport BMC - Porsche 911 (991 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-valves-pour-991-turbo-phase-1-interrupteur",
              "l": "Échappement à valves - Porsche 911 (991 Turbo)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-991",
          "title": "Filtre à air sport BMC - Porsche 911 (991 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991 Turbo"
      ]
    },
    {
      "id": "porsche-911-991-2-carrera",
      "displayName": "911 Carrera (991.2)",
      "shortName": "911 Carrera (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2015 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "platine-pse-avec-raccord-scart",
        "x-pipe-pse",
        "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse"
      ],
      "activeProducts": [
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-pse",
          "title": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
          "title": "Paire de catalyseurs sport 200cc SCART pour 991-2 - Porsche 911 (991-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "mid",
          "n": "Le tube intermédiaire",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-pse",
              "l": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Paire de catalyseurs sport 200 cellules pour la Carrera 991.2 sans PSE.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
              "l": "Paire de catalyseurs sport 200 cellules",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "category": "bracket",
          "description": "Platine support PSE avec raccord spécifique SCART."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Alias `991-2` avec variantes d'espacement signalées dans la note de cartographie.",
      "anomalies": [],
      "aliases": [
        "991-2"
      ]
    },
    {
      "id": "porsche-911-991-2-carrera-pse",
      "displayName": "911 Carrera (991.2) avec PSE",
      "shortName": "911 Carrera (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2015 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-porsche-991-2-pse",
        "echappement-complet-valves",
        "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
        "x-pipe-pse"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-porsche-991-2-pse",
          "title": "Échappement à valves - 991-2 - Porsche 911 (991-2 PSE)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-complet-valves",
          "title": "Échappement complet à valves - Porsche 911 (991-2 PSE)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
          "title": "Paire de catalyseurs sport 200cc SCART pour 991-2 - Porsche 911 (991-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-pse",
          "title": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-porsche-991-2-pse",
              "l": "Échappement à valves - 991-2 - Porsche 911 (991-2 PSE)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-complet-valves",
              "l": "Échappement complet à valves - Porsche 911 (991-2 PSE)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le tube intermédiaire",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-pse",
              "l": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
              "l": "Paire de catalyseurs sport 200cc SCART pour 991-2 - Porsche 911 (991-2 PSE)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le X-pipe SCART est commun PSE / non-PSE ; mêmes positions. Dessin partagé, branche produit distincte.",
      "anomalies": [],
      "aliases": [
        "991-2 PSE"
      ]
    },
    {
      "id": "porsche-911-991-2-gt3",
      "displayName": "911 GT3 (991.2)",
      "shortName": "911 GT3 (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2017 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991-2 GT3"
      ]
    },
    {
      "id": "porsche-911-991-2-turbo",
      "displayName": "911 Turbo (991.2)",
      "shortName": "911 Turbo (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2016 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-valves-pour-991-turbo-mk2-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "echappement-valves-pour-991-turbo-mk2-interrupteur",
          "title": "Échappement à valves pour 991 MK2 - Interrupteur - Porsche 911 (991-2 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-valves-pour-991-turbo-mk2-interrupteur",
              "l": "Échappement à valves pour 991 MK2 - Interrupteur - Porsche 911 (991-2 Turbo)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991-2 Turbo"
      ]
    },
    {
      "id": "porsche-911-992-carrera",
      "displayName": "911 Carrera (992), avec ou sans PSE",
      "shortName": "911 Carrera (992)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "992",
      "generationId": "992",
      "generationLabel": "992 (2019+)",
      "period": "2019 - aujourd'hui",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-992-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-992-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "paire-de-calayseurs-sport-200cc",
        "x-pipe-central-porsche-992-pse",
        "x-pipe-central-porsche-992-sans-pse"
      ],
      "activeProducts": [
        {
          "handle": "paire-de-calayseurs-sport-200cc",
          "title": "Paire de Catalyseurs sport 200CC - Porsche 911 (992 / 992 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central-porsche-992-pse",
          "title": "X - pipe central - Porsche 911 (992 PSE)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central-porsche-992-sans-pse",
          "title": "X - Pipe central - sans PSE - Porsche 911 (992)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "mid",
          "n": "Le X-Pipe central",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-central-porsche-992-pse",
              "l": "X - pipe central - Porsche 911 (992 PSE)",
              "type": "Tube"
            },
            {
              "h": "x-pipe-central-porsche-992-sans-pse",
              "l": "X - Pipe central - sans PSE - Porsche 911 (992)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-calayseurs-sport-200cc",
              "l": "Paire de Catalyseurs sport 200CC - Porsche 911 (992 / 992 PSE)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Split PSE / non-PSE seulement pour le X-pipe central ; mêmes positions, un dessin.",
      "anomalies": [],
      "aliases": [
        "992",
        "992 PSE"
      ]
    },
    {
      "id": "porsche-cayenne-955-s",
      "displayName": "Cayenne S (955)",
      "shortName": "Cayenne S (955)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "955",
      "generationLabel": "Cayenne 955 (2002-2007)",
      "period": "2002 - 2007",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-955-s",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-s.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-955-s",
        "echappement-sport-a-valves-porsche-955-s",
        "echappement-sport-porsche-955-s"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-955-s",
          "title": "Catalyseurs by-pass - Porsche Cayenne (955 S)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valves-porsche-955-s",
          "title": "Échappement sport à valves - Porsche Cayenne (955 S)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-955-s",
          "title": "Échappement sport - Porsche Cayenne (955 S)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-955-s",
              "l": "Échappement sport - Porsche Cayenne (955 S)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-955-s",
              "l": "Échappement sport à valves - Porsche Cayenne (955 S)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-955-s",
              "l": "Catalyseurs by-pass - Porsche Cayenne (955 S)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "955 S",
        "955",
        "Cayenne 955"
      ]
    },
    {
      "id": "porsche-cayenne-955-turbo",
      "displayName": "Cayenne Turbo (955)",
      "shortName": "Cayenne Turbo (955)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "955",
      "generationLabel": "Cayenne 955 (2002-2007)",
      "period": "2002 - 2007",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-955-turbo",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-turbo.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-955-turbo",
        "echappements-sport-porsche-955-turbo",
        "silencieux-sport-avec-valves-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-955-turbo",
          "title": "Catalyseurs by-pass - Porsche Cayenne (955 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-porsche-955-turbo",
          "title": "Échappement sport - Porsche Cayenne (955 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valves-commande-par-interrupteur",
          "title": "Silencieux sport avec valves (commande par interrupteur) - Porsche Cayenne (955 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappements-sport-porsche-955-turbo",
              "l": "Échappement sport - Porsche Cayenne (955 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-avec-valves-commande-par-interrupteur",
              "l": "Silencieux sport avec valves (commande par interrupteur) - Porsche Cayenne (955 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-955-turbo",
              "l": "Catalyseurs by-pass - Porsche Cayenne (955 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Handles distincts S / Turbo pour by-pass et silencieux. Famille séparée tant que les photos n'ont pas prouvé que les zones vendues occupent la même position sur les deux moteurs.",
      "anomalies": [],
      "aliases": [
        "955 Turbo"
      ]
    },
    {
      "id": "porsche-cayenne-957-s",
      "displayName": "Cayenne S (957)",
      "shortName": "Cayenne S (957)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "957",
      "generationLabel": "Cayenne 957 (2007-2010)",
      "period": "2007 - 2010",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-957-s",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-s.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-957-s",
        "echappement-sport-a-valves-porsche-957-s",
        "echappement-sport-porsche-cayenne-957-s"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-957-s",
          "title": "Catalyseurs by-pass - Porsche Cayenne (957 S)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valves-porsche-957-s",
          "title": "Échappement sport à valves - Porsche Cayenne (957 S)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-cayenne-957-s",
          "title": "Échappement sport - Porsche Cayenne (957 S)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-cayenne-957-s",
              "l": "Échappement sport - Porsche Cayenne (957 S)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-957-s",
              "l": "Échappement sport à valves - Porsche Cayenne (957 S)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-957-s",
              "l": "Catalyseurs by-pass - Porsche Cayenne (957 S)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "957 S",
        "957",
        "Cayenne 957"
      ]
    },
    {
      "id": "porsche-cayenne-957-turbo",
      "displayName": "Cayenne Turbo (957)",
      "shortName": "Cayenne Turbo (957)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "957",
      "generationLabel": "Cayenne 957 (2007-2010)",
      "period": "2007 - 2010",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-957-turbo",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-turbo.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-957-turbo",
        "echappement-sport-porsche-957-turbo",
        "echappements-a-valves-porsche-957"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-957-turbo",
          "title": "Catalyseurs by-pass - Porsche Cayenne (957 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-957-turbo",
          "title": "Échappement sport - Porsche Cayenne (957 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-a-valves-porsche-957",
          "title": "Échappement à valves - Porsche Cayenne (957 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-957-turbo",
              "l": "Échappement sport - Porsche Cayenne (957 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappements-a-valves-porsche-957",
              "l": "Échappement à valves - Porsche Cayenne (957 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-957-turbo",
              "l": "Catalyseurs by-pass - Porsche Cayenne (957 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Même règle que 955 : famille séparée jusqu'à preuve photo d'un dessous identique.",
      "anomalies": [],
      "aliases": [
        "957 Turbo"
      ]
    },
    {
      "id": "porsche-cayenne-958",
      "displayName": "Cayenne (958) atmosphérique",
      "shortName": "Cayenne 958 Atmo",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "958",
      "generationLabel": "Cayenne 958 (2010-2017)",
      "period": "2010 - 2017",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-958",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-porsche-958",
        "echappement-sport-porsche-958",
        "echappements-sport-a-valves-porsche-958",
        "sorties-doubles-noires-peinture-c-ramique"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-porsche-958",
          "title": "Catalyseurs by-pass - Porsche Cayenne (958)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-958",
          "title": "Échappement sport - Porsche Cayenne (958)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-a-valves-porsche-958",
          "title": "Échappement sport à valves - Porsche Cayenne (958)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-doubles-noires-peinture-c-ramique",
          "title": "Sorties doubles noires peinture céramique - Porsche Cayenne (958)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-958",
              "l": "Échappement sport - Porsche Cayenne (958)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappements-sport-a-valves-porsche-958",
              "l": "Échappement sport à valves - Porsche Cayenne (958)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseur-by-pass-porsche-958",
              "l": "Catalyseurs by-pass - Porsche Cayenne (958)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              10,
              4,
              16,
              12
            ],
            [
              74,
              4,
              16,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-doubles-noires-peinture-c-ramique",
              "l": "Sorties doubles noires peinture céramique - Porsche Cayenne (958)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "958",
        "Cayenne 958"
      ]
    },
    {
      "id": "porsche-cayenne-958-turbo",
      "displayName": "Cayenne Turbo (958)",
      "shortName": "Cayenne Turbo (958)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "958",
      "generationLabel": "Cayenne 958 (2010-2017)",
      "period": "2010 - 2017",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-958-turbo",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958-turbo.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass",
        "echappement-sport-porsche-958-turbo",
        "silencieux-sport-avec-valve-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass",
          "title": "Catalyseurs by-pass - Porsche Cayenne (958 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-958-turbo",
          "title": "Échappement sport - Porsche Cayenne (958 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-commande-par-interrupteur",
          "title": "Silencieux sport avec valve (commande par interrupteur) - Porsche Cayenne (958 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-958-turbo",
              "l": "Échappement sport - Porsche Cayenne (958 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-avec-valve-commande-par-interrupteur",
              "l": "Silencieux sport avec valve (commande par interrupteur) - Porsche Cayenne (958 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass",
              "l": "Catalyseurs by-pass - Porsche Cayenne (958 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "958 Turbo"
      ]
    },
    {
      "id": "porsche-cayenne-9ya-v6",
      "displayName": "Cayenne V6 (PO536 / 9YA)",
      "shortName": "Cayenne V6 (9YA)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "9ya",
      "generationLabel": "Cayenne 9YA (2017+)",
      "period": "2017 - aujourd'hui",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-9ya-v6",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-9ya-v6.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-sport-200cc",
        "catalyseurs-sport-porsche-cayenne-p0536-v6",
        "echappement-a-valve-porsche-cayenne-p0536"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-sport-200cc",
          "title": "Catalyseur sport 200CC - Porsche Cayenne (PO536)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-porsche-cayenne-p0536-v6",
          "title": "Catalyseurs sport - V6 - Porsche Cayenne (V6)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valve-porsche-cayenne-p0536",
          "title": "Échappement à valves - V6 - Porsche Cayenne (V6)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valve-porsche-cayenne-p0536",
              "l": "Échappement à valves - V6 - Porsche Cayenne (V6)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseur-sport-200cc",
              "l": "Catalyseur sport 200CC - Porsche Cayenne (PO536)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-sport-porsche-cayenne-p0536-v6",
              "l": "Catalyseurs sport - V6 - Porsche Cayenne (V6)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Alias `P0536` (zéro) et `PO536` (lettre O) coexistent.",
      "anomalies": [],
      "aliases": [
        "P0536",
        "PO536"
      ]
    },
    {
      "id": "porsche-panamera-970",
      "displayName": "Panamera (970) hors Turbo",
      "shortName": "Panamera 970",
      "brand": "Porsche",
      "model": "Panamera",
      "modelId": "panamera",
      "generation": "Panamera",
      "generationId": "970",
      "generationLabel": "Panamera 970 (2009-2016)",
      "period": "2009 - 2016",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-panamera-970",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970.webp",
      "logoKey": "porsche-panamera",
      "logoAsset": "scart-logo-porsche-panamera.svg",
      "logoTitle": "Panamera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "filtre-air-sport-bmc-pour-panamera",
        "paire-de-tubes-interm-daires",
        "silencieux-sport-valves",
        "tubes-interm-diaires"
      ],
      "activeProducts": [
        {
          "handle": "filtre-air-sport-bmc-pour-panamera",
          "title": "Filtre à air sport BMC - Porsche Panamera",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-tubes-interm-daires",
          "title": "Paire de tubes intermédiaires - Porsche Panamera",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-valves",
          "title": "Silencieux sport à valves - Porsche Panamera (970)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tubes-interm-diaires",
          "title": "Tubes intermédiaires - Porsche Panamera",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-valves",
              "l": "Silencieux sport à valves - Porsche Panamera (970)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Les tubes intermédiaires",
          "d": "Tubes intermédiaires de liaison reliant les catalyseurs aux silencieux arrière.",
          "rects": [
            [
              34,
              34,
              32,
              28
            ]
          ],
          "products": [
            {
              "h": "paire-de-tubes-interm-daires",
              "l": "Paire de tubes intermédiaires - Porsche Panamera",
              "type": "Tube"
            },
            {
              "h": "tubes-interm-diaires",
              "l": "Tubes intermédiaires - Porsche Panamera",
              "type": "Tube"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-panamera",
          "title": "Filtre à air sport BMC - Porsche Panamera",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Statut no-go dans la cartographie : deux fiches de tubes intermédiaires semblent décrire la même paire, moteurs compatibles non confirmés. La source visuelle est recherchée quand même.",
      "anomalies": [],
      "aliases": [
        "Panamera",
        "panamera",
        "970"
      ]
    },
    {
      "id": "porsche-panamera-970-turbo",
      "displayName": "Panamera Turbo (970)",
      "shortName": "Panamera Turbo 970",
      "brand": "Porsche",
      "model": "Panamera",
      "modelId": "panamera",
      "generation": "Panamera",
      "generationId": "970",
      "generationLabel": "Panamera 970 (2009-2016)",
      "period": "2009 - 2016",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-panamera-970-turbo",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970-turbo.webp",
      "logoKey": "porsche-panamera",
      "logoAsset": "scart-logo-porsche-panamera.svg",
      "logoTitle": "Panamera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-a-valves-porsche-panamera-970-turbo",
        "silencieux-sport-panamera-970-turbo"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-a-valves-porsche-panamera-970-turbo",
          "title": "Échappement sport à valves - Porsche Panamera (970 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-panamera-970-turbo",
          "title": "Silencieux sport - Porsche Panamera (970 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-panamera-970-turbo",
              "l": "Silencieux sport - Porsche Panamera (970 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-panamera-970-turbo",
              "l": "Échappement sport à valves - Porsche Panamera (970 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "970 Turbo",
        "Panamera 970 Turbo"
      ]
    },
    {
      "id": "ferrari-f430",
      "displayName": "Ferrari F430",
      "shortName": "Ferrari F430",
      "brand": "Ferrari",
      "model": "F430",
      "modelId": "f430",
      "generation": "F430",
      "generationId": "f430",
      "generationLabel": "F430 (2004-2009)",
      "period": "2004 - 2009",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-f430",
      "drawingAsset": "scart-undercarriage-ferrari-f430.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-sport",
        "collecteurs-catalyseurs-sport",
        "echappement-sport-ferrari-f430",
        "silencieux-racing",
        "silencieux-valves"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-sport",
          "title": "Catalyseurs sport - Ferrari F430",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-catalyseurs-sport",
          "title": "Collecteurs catalyseurs sport - Ferrari F430",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ferrari-f430",
          "title": "Échappement sport - Ferrari F430",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-racing",
          "title": "Silencieux Racing - Ferrari F430",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves",
          "title": "Silencieux à valves - Ferrari F430",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 5,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ferrari-f430",
              "l": "Échappement sport - Ferrari F430",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-racing",
              "l": "Silencieux Racing - Ferrari F430",
              "type": "Silencieux",
              "s": 5,
              "g": "sound",
              "l_short": "Racing / Ultima"
            },
            {
              "h": "silencieux-valves",
              "l": "Silencieux à valves - Ferrari F430",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport",
              "l": "Catalyseurs sport - Ferrari F430",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport",
              "l": "Collecteurs catalyseurs sport - Ferrari F430",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "F430"
      ]
    },
    {
      "id": "ferrari-456",
      "displayName": "Ferrari 456 / 456 M",
      "shortName": "Ferrari 456 / 456 M",
      "brand": "Ferrari",
      "model": "456",
      "modelId": "456",
      "generation": "456",
      "generationId": "456",
      "generationLabel": "456 / 456 M (1992-2003)",
      "period": "1992 - 2003",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-456",
      "drawingAsset": "scart-undercarriage-ferrari-456.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-primaire-pour-ferrari-456",
        "paire-de-silencieux-sport-ultima-pour-ferrari-456"
      ],
      "activeProducts": [
        {
          "handle": "echappement-primaire-pour-ferrari-456",
          "title": "Échappement primaire - Ferrari 456",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-silencieux-sport-ultima-pour-ferrari-456",
          "title": "Paire de silencieux sport Ultima - Ferrari 456",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux arrière Ultima",
          "d": "Paire de silencieux arrière sport Ultima pour moteur V12.",
          "rects": [
            [
              12,
              14,
              18,
              24
            ],
            [
              70,
              14,
              18,
              24
            ]
          ],
          "products": [
            {
              "h": "paire-de-silencieux-sport-ultima-pour-ferrari-456",
              "l": "Paire de silencieux sport Ultima - Ferrari 456",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        },
        {
          "id": "mid",
          "n": "L’échappement primaire central",
          "d": "Silencieux intermédiaire primaire situé dans le tunnel central.",
          "rects": [
            [
              30,
              40,
              40,
              20
            ]
          ],
          "products": [
            {
              "h": "echappement-primaire-pour-ferrari-456",
              "l": "Échappement primaire - Ferrari 456",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "456"
      ]
    },
    {
      "id": "ferrari-testarossa",
      "displayName": "Ferrari Testarossa",
      "shortName": "Ferrari Testarossa",
      "brand": "Ferrari",
      "model": "Testarossa",
      "modelId": "testarossa",
      "generation": "Testarossa",
      "generationId": "testarossa",
      "generationLabel": "Testarossa (1984-1996)",
      "period": "1984 - 1996",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-testarossa",
      "drawingAsset": "scart-undercarriage-ferrari-testarossa.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-ferrari-testarossa"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-ferrari-testarossa",
          "title": "Échappement à valves - Ferrari Testarossa",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-ferrari-testarossa",
              "l": "Échappement à valves - Ferrari Testarossa",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "Testarossa"
      ]
    },
    {
      "id": "ferrari-360",
      "displayName": "Ferrari 360 Modena",
      "shortName": "Ferrari 360 Modena",
      "brand": "Ferrari",
      "model": "360",
      "modelId": "360",
      "generation": "360",
      "generationId": "360",
      "generationLabel": "360 Modena (1999-2005)",
      "period": "1999 - 2005",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-360",
      "drawingAsset": "scart-undercarriage-ferrari-360.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-ferrari-350-modena"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-ferrari-350-modena",
          "title": "Échappement sport - Modena - Ferrari 360",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ferrari-350-modena",
              "l": "Échappement sport - Modena - Ferrari 360",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet « 360 » (carte compat PDP vide). Handle `echappement-sport-ferrari-350-modena` (faute : 350).",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "360"
      ]
    },
    {
      "id": "ferrari-512-bb",
      "displayName": "Ferrari 512 BB / BBi",
      "shortName": "Ferrari 512 BB / BBi",
      "brand": "Ferrari",
      "model": "512 BB",
      "modelId": "512-bb",
      "generation": "512 BB",
      "generationId": "512-bb",
      "generationLabel": "512 BB / BBi (1976-1984)",
      "period": "1976 - 1984",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-512-bb",
      "drawingAsset": "scart-undercarriage-ferrari-512-bb.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "paire-d-chappement-sport-pour-ferrari-512-bb"
      ],
      "activeProducts": [
        {
          "handle": "paire-d-chappement-sport-pour-ferrari-512-bb",
          "title": "Paire d'échappement sport - Ferrari 512 BB",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "paire-d-chappement-sport-pour-ferrari-512-bb",
              "l": "Paire d'échappement sport - Ferrari 512 BB",
              "type": "Ligne complète",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet « 512 BB » (carte compat PDP vide).",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "512 BB"
      ]
    },
    {
      "id": "audi-r8-v8",
      "displayName": "Audi R8 V8 (type 42)",
      "shortName": "Audi R8 V8",
      "brand": "Audi",
      "model": "R8",
      "modelId": "r8",
      "generation": "R8",
      "generationId": "r8-type-42",
      "generationLabel": "R8 Type 42 (2006-2015)",
      "period": "2007 - 2012",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "audi-r8-v8",
      "drawingAsset": "scart-undercarriage-audi-r8-v8.webp",
      "logoKey": "audi-v8",
      "logoAsset": "scart-logo-audi-v8.svg",
      "logoTitle": "V8",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport-pour-audi-r8-v8",
        "silencieux-valves-pour-audi-r8-v8"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport-pour-audi-r8-v8",
          "title": "Silencieux sport - Audi R8 V8",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves-pour-audi-r8-v8",
          "title": "Silencieux à valves - Audi R8 V8",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-pour-audi-r8-v8",
              "l": "Silencieux sport - Audi R8 V8",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-valves-pour-audi-r8-v8",
              "l": "Silencieux à valves - Audi R8 V8",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "R8 V8"
      ]
    },
    {
      "id": "audi-r8-v10",
      "displayName": "Audi R8 V10 (type 42)",
      "shortName": "Audi R8 V10",
      "brand": "Audi",
      "model": "R8",
      "modelId": "r8",
      "generation": "R8",
      "generationId": "r8-type-42",
      "generationLabel": "R8 Type 42 (2006-2015)",
      "period": "2009 - 2015",
      "architecture": "Moteur V10",
      "description": "Architecture moteur v10 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "audi-r8-v10",
      "drawingAsset": "scart-undercarriage-audi-r8-v10.webp",
      "logoKey": "audi-v10",
      "logoAsset": "scart-logo-audi-v10.svg",
      "logoTitle": "V10",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-pour-audi-r8-v10",
        "silencieux-valves-pour-audi-r8-v10",
        "sorties-echappement-audi-r8-v10-2009-2012"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-pour-audi-r8-v10",
          "title": "Échappement sport - Audi R8 V10",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves-pour-audi-r8-v10",
          "title": "Silencieux à valves - Audi R8 V10",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-echappement-audi-r8-v10-2009-2012",
          "title": "Sorties échappements - 2009 - 2012 - Audi R8 V10",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-pour-audi-r8-v10",
              "l": "Échappement sport - Audi R8 V10",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-valves-pour-audi-r8-v10",
              "l": "Silencieux à valves - Audi R8 V10",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-echappement-audi-r8-v10-2009-2012",
              "l": "Sorties échappements - 2009 - 2012 - Audi R8 V10",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Sorties 2009-2012 = zone spécifique ; même dessous que le V8 côté arrière mais silencieux distincts : familles séparées.",
      "anomalies": [],
      "aliases": [
        "R8 V10"
      ]
    },
    {
      "id": "alpine-a110",
      "displayName": "Alpine A110 / A110 S / A110 GT",
      "shortName": "Alpine A110",
      "brand": "Alpine",
      "model": "A110",
      "modelId": "a110",
      "generation": "A110",
      "generationId": "a110-2017",
      "generationLabel": "A110 (2017+)",
      "period": "2017 - aujourd'hui",
      "architecture": "4 cylindres turbo",
      "description": "Architecture 4 cylindres turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "alpine-a110",
      "drawingAsset": "scart-undercarriage-alpine-a110.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-a-valve",
        "echappement-sport-a-valve-copie",
        "kit-telecommande"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-a-valve",
          "title": "Échappement sport à valve - Alpine A110",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valve-copie",
          "title": "Échappement sport à valve + Downpipe - Alpine A110",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-telecommande",
          "title": "Kit télécommande - Alpine A110 / A110R",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-a-valve",
              "l": "Échappement sport à valve - Alpine A110",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-sport-a-valve-copie",
              "l": "Échappement sport à valve + Downpipe - Alpine A110",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "kit-telecommande",
          "title": "Kit télécommande - Alpine A110 / A110R",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "`A110R` n'existe que sur le kit télécommande (accessoire) et n'a pas de métaobjet : aucun échappement SCART pour l'A110 R.",
      "anomalies": [],
      "aliases": [
        "A110",
        "A110R"
      ]
    },
    {
      "id": "aston-martin-db7-v12",
      "displayName": "Aston Martin DB7 V12 Vantage",
      "shortName": "Aston Martin DB7 V12",
      "brand": "Aston Martin",
      "model": "DB7",
      "modelId": "db7",
      "generation": "DB7",
      "generationId": "db7-v12",
      "generationLabel": "DB7 Vantage (1999-2004)",
      "period": "1999 - 2004",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "aston-martin-db7-v12",
      "drawingAsset": "scart-undercarriage-aston-martin-db7-v12.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-aston-martin-db7-v12-vantage",
        "paire-de-catalyseurs-sport-200-cc-aston-marin-db7-v12-vantage"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-aston-martin-db7-v12-vantage",
          "title": "Échappement SCART à valves - V12 Vantage - Aston Martin DB7",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-catalyseurs-sport-200-cc-aston-marin-db7-v12-vantage",
          "title": "Paire de catalyseurs sport 200 cc - Aston Martin V12 Vantage - Aston Martin DB7",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-aston-martin-db7-v12-vantage",
              "l": "Échappement SCART à valves - V12 Vantage - Aston Martin DB7",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport 200 cc",
          "d": "Catalyseurs sport haute perméabilité libérant débit et timbre.",
          "rects": [
            [
              28,
              48,
              14,
              20
            ],
            [
              58,
              48,
              14,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-catalyseurs-sport-200-cc-aston-marin-db7-v12-vantage",
              "l": "Paire de catalyseurs sport 200 cc - Aston Martin V12 Vantage - Aston Martin DB7",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "La fiche catalyseur annonce V12 ou i6 ; le silencieux vise la V12 Vantage. Le métaobjet « V12 Vantage » (2009-2018) existe mais n'a aucun produit : ne pas le confondre avec la DB7 V12 Vantage.",
      "anomalies": [],
      "aliases": [
        "DB7"
      ]
    },
    {
      "id": "mercedes-amg-gt-black-series",
      "displayName": "Mercedes-AMG GT Black Series",
      "shortName": "Mercedes-AMG GT Black Series",
      "brand": "Mercedes-AMG",
      "model": "AMG GT",
      "modelId": "amg-gt",
      "generation": "AMG GT",
      "generationId": "c190",
      "generationLabel": "AMG GT C190 (2020-2022)",
      "period": "2020 - 2021",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "mercedes-amg-gt-black-series",
      "drawingAsset": "scart-undercarriage-mercedes-amg-gt-black-series.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-amg-gt-black-series"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-amg-gt-black-series",
          "title": "Échappement à valves - Mercedes AMG GT Black series",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière à valves",
          "d": "Échappement arrière à valves actives pour moteur V8 biturbo.",
          "rects": [
            [
              18,
              14,
              64,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-amg-gt-black-series",
              "l": "Échappement à valves - Mercedes AMG GT Black series",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet « AMG GT » n'a pas de collection_handle ; Mercedes est absente de la hiérarchie du configurateur.",
      "anomalies": [],
      "aliases": [
        "AMG GT Black series",
        "AMG GT"
      ]
    }
  ],
  "vehicleMap": {
    "porsche-356": {
      "id": "porsche-356",
      "displayName": "Porsche 356",
      "shortName": "Porsche 356",
      "brand": "Porsche",
      "model": "356",
      "modelId": "356",
      "generation": "356",
      "generationId": "356",
      "generationLabel": "356 (1948-1965)",
      "period": "1948 - 1965",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-356",
      "drawingAsset": "scart-undercarriage-porsche-356.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-super-sound-porsche-356"
      ],
      "activeProducts": [
        {
          "handle": "echappement-super-sound-porsche-356",
          "title": "Échappement super sound - Porsche 911 (356)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-super-sound-porsche-356",
              "l": "Échappement super sound - Porsche 911 (356)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet vehicle_compat_label « 356 » (carte compat PDP vide). Le titre produit dit « Porsche 911 (356) », erreur de nommage.",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "356"
      ]
    },
    "porsche-911-type-f": {
      "id": "porsche-911-type-f",
      "displayName": "911 Type F (1963-1973)",
      "shortName": "911 2.0 / 2.2 / 2.4",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type F",
      "generationId": "type-f",
      "generationLabel": "Type F (1963-1973)",
      "period": "1963 - 1973",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-f",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "logoKey": "porsche-911-simple",
      "logoAsset": "scart-logo-porsche-911.svg",
      "logoTitle": "911",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons",
        "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons-1",
        "silencieux-2-entr-es-1-sortie-sonorit-riva",
        "silencieux-2-entr-es-2-sorties-d-g-sonorit-sport",
        "silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound",
        "silencieux-2-entrees-1-sortie-sonorite-sport",
        "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound",
        "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound-copie",
        "silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport",
        "silencieux-2-entrees-2-sorties-droite-gauche-sonorite-sport-copie",
        "silencieux-monte-carlo-2-entr-es-2-sorties-sonorit-super-sound"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons",
          "title": "Silencieux 3,0L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons-1",
          "title": "Silencieux 2,8L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entr-es-1-sortie-sonorit-riva",
          "title": "Silencieux 2 entrées, 1 sortie - sonorité Riva - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entr-es-2-sorties-d-g-sonorit-sport",
          "title": "Silencieux 2 entrées, 2 sorties D/G - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound",
          "title": "Silencieux 2 entrées, 2 sorties D/G - sonorité super sound - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-1-sortie-sonorite-sport",
          "title": "Silencieux 2 entrées, 1 sortie - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound",
          "title": "Silencieux 2 entrées, 2 sorties arrières 70mm - sonorité super sound - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound-copie",
          "title": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport",
          "title": "Silencieux 2 entrées, 2 sorties centrées 70mm - sonorité sport - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-2-sorties-droite-gauche-sonorite-sport-copie",
          "title": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité super sound - Porsche 911 Type F (1963-1973)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-monte-carlo-2-entr-es-2-sorties-sonorit-super-sound",
          "title": "Silencieux Monte Carlo 2 entrées, 2 sorties - Sonorité super sound - Porsche 911 (Type F)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 11,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-2-entr-es-2-sorties-d-g-sonorit-sport",
              "l": "Silencieux 2 entrées, 2 sorties D/G - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entrees-1-sortie-sonorite-sport",
              "l": "Silencieux 2 entrées, 1 sortie - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound-copie",
              "l": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport",
              "l": "Silencieux 2 entrées, 2 sorties centrées 70mm - sonorité sport - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-2-entr-es-1-sortie-sonorit-riva",
              "l": "Silencieux 2 entrées, 1 sortie - sonorité Riva - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            },
            {
              "h": "silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound",
              "l": "Silencieux 2 entrées, 2 sorties D/G - sonorité super sound - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound",
              "l": "Silencieux 2 entrées, 2 sorties arrières 70mm - sonorité super sound - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-2-entrees-2-sorties-droite-gauche-sonorite-sport-copie",
              "l": "Silencieux 2 entrées, 2 sorties Droite/Gauche - sonorité super sound - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-monte-carlo-2-entr-es-2-sorties-sonorit-super-sound",
              "l": "Silencieux Monte Carlo 2 entrées, 2 sorties - Sonorité super sound - Porsche 911 (Type F)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons",
              "l": "Silencieux 3,0L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux"
            },
            {
              "h": "silencieux-2-8l-rsr-3-sorties-longues-a-bouchons-1",
              "l": "Silencieux 2,8L RSR - 3 sorties longues à bouchons - Porsche 911 Type F (1963-1973)",
              "type": "Silencieux"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [
        "ACTIVE mais non publié(s) : silencieux-2-entr-es-1-sortie-valve-command-e-par-interrupteur"
      ],
      "aliases": [
        "Type F",
        "Type F (1963-1973)"
      ]
    },
    "porsche-911-type-f-1973-1976": {
      "id": "porsche-911-type-f-1973-1976",
      "displayName": "911 « Type F » 1973-1976",
      "shortName": "911 (1973-1976)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type F",
      "generationId": "type-f",
      "generationLabel": "Type F (1963-1973)",
      "period": "1973 - 1976",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-f",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "logoKey": "porsche-911-simple",
      "logoAsset": "scart-logo-porsche-911.svg",
      "logoTitle": "911",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "paire-de-collecteurs-racing-courts-diam-tre-38-5mm",
        "silencieux-2-entrees-1-sortie-riva-sound"
      ],
      "activeProducts": [
        {
          "handle": "paire-de-collecteurs-racing-courts-diam-tre-38-5mm",
          "title": "Paire de collecteurs racing courts - Diamètre 38,5mm - Porsche 911 Type F (1973-1976)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-2-entrees-1-sortie-riva-sound",
          "title": "Silencieux 2 entrées, 1 sortie - Riva Sound - Porsche 911 Type F (1973-1976)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-2-entrees-1-sortie-riva-sound",
              "l": "Silencieux 2 entrées, 1 sortie - Riva Sound - Porsche 911 Type F (1973-1976)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "paire-de-collecteurs-racing-courts-diam-tre-38-5mm",
              "l": "Paire de collecteurs racing courts - Diamètre 38,5mm - Porsche 911 Type F (1973-1976)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé hérité ambigu : la Type F s'arrête en 1973, 1973-1976 correspond à la Type G 2,7 L. Deux produits (collecteurs racing courts 38,5 mm, silencieux 1 sortie Riva Sound). Rattaché provisoirement au dessin Type F car la zone vendue (silencieux arrière 2 entrées / 1 sortie) est celle de la Type F ; à confirmer avec Martin.",
      "anomalies": [],
      "aliases": [
        "Type F (1973-1976)"
      ]
    },
    "porsche-911-carrera-rs-2-7": {
      "id": "porsche-911-carrera-rs-2-7",
      "displayName": "911 Carrera RS 2.7",
      "shortName": "911 Carrera RS 2.7",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type F",
      "generationId": "type-f",
      "generationLabel": "Type F (1963-1973)",
      "period": "1973",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-f",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "logoKey": "porsche-carrera-rs-27",
      "logoAsset": "scart-logo-porsche-carrera-rs.svg",
      "logoTitle": "Carrera RS",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport-pour-911-2-7l-rs",
        "silencieux-sport-pour-911-2-7l-rs-3-sorties-courtes-bouchons",
        "silencieux-sport-pour-911-2-7l-rs-3-sorties-longues-bouchons",
        "silencieux-super-sound-pour-911-2-7l-rs"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport-pour-911-2-7l-rs",
          "title": "Silencieux sport - 2,7L - Porsche 911 (2.7L RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-pour-911-2-7l-rs-3-sorties-courtes-bouchons",
          "title": "Silencieux sport pour 2,7L - 3 sorties courtes à bouchons - Porsche 911 (2.7L RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-pour-911-2-7l-rs-3-sorties-longues-bouchons",
          "title": "Silencieux sport pour 2,7L - 3 sorties longues à bouchons - Porsche 911 (2.7 RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound-pour-911-2-7l-rs",
          "title": "Silencieux super sound - Porsche 911 (2,7L RS)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-pour-911-2-7l-rs",
              "l": "Silencieux sport - 2,7L - Porsche 911 (2.7L RS)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-pour-911-2-7l-rs-3-sorties-courtes-bouchons",
              "l": "Silencieux sport pour 2,7L - 3 sorties courtes à bouchons - Porsche 911 (2.7L RS)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-pour-911-2-7l-rs-3-sorties-longues-bouchons",
              "l": "Silencieux sport pour 2,7L - 3 sorties longues à bouchons - Porsche 911 (2.7 RS)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-super-sound-pour-911-2-7l-rs",
              "l": "Silencieux super sound - Porsche 911 (2,7L RS)",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Trois alias non normalisés (`2.7L RS`, `2,7L RS`, `2.7 RS`). La RS 2.7 est une Type F 1973 : même architecture arrière (échangeurs + silencieux transversal), mêmes zones vendues.",
      "anomalies": [],
      "aliases": [
        "2.7L RS",
        "2,7L RS",
        "2.7 RS"
      ]
    },
    "porsche-912": {
      "id": "porsche-912",
      "displayName": "912 (1965-1969)",
      "shortName": "912 Classic (1965-1969)",
      "brand": "Porsche",
      "model": "912",
      "modelId": "912",
      "generation": "912",
      "generationId": "912",
      "generationLabel": "912 (1965-1976)",
      "period": "1965 - 1969",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-912",
      "drawingAsset": "scart-undercarriage-porsche-912.webp",
      "logoKey": "porsche-912",
      "logoAsset": "scart-logo-porsche-912.jpg",
      "logoTitle": "912",
      "logoFormat": "jpg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-porsche-912",
        "echappement-sport-porsche-913",
        "echappement-sport-super-sound-type-riva-porsche-912",
        "echappement-super-sound-type-riva-porsche-912"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-porsche-912",
          "title": "Échappement sport - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-913",
          "title": "Échappement sport - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-super-sound-type-riva-porsche-912",
          "title": "Échappement sport super sound type Riva - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-super-sound-type-riva-porsche-912",
          "title": "Échappement super sound type Riva - Porsche 911 (912)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-912",
              "l": "Échappement sport - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-porsche-913",
              "l": "Échappement sport - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-super-sound-type-riva-porsche-912",
              "l": "Échappement sport super sound type Riva - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            },
            {
              "h": "echappement-super-sound-type-riva-porsche-912",
              "l": "Échappement super sound type Riva - Porsche 911 (912)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Quatre fiches actives pour deux propositions (Sport et Riva dupliqués sous `echappement-sport-porsche-913` et `echappement-sport-super-sound-type-riva-porsche-912`). Doublons à réconcilier.",
      "anomalies": [],
      "aliases": [
        "912"
      ]
    },
    "porsche-912e": {
      "id": "porsche-912e",
      "displayName": "912E (1976)",
      "shortName": "912E (1976)",
      "brand": "Porsche",
      "model": "912",
      "modelId": "912",
      "generation": "912",
      "generationId": "912",
      "generationLabel": "912 (1965-1976)",
      "period": "1976",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-912e",
      "drawingAsset": "scart-undercarriage-porsche-912e.webp",
      "logoKey": "porsche-912e",
      "logoAsset": "scart-logo-porsche-912e.svg",
      "logoTitle": "912E",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-porsche-912e",
        "echappement-super-sound-type-riva-porsche-912e"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-porsche-912e",
          "title": "Échappement sport - Porsche 911 (912E)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-super-sound-type-riva-porsche-912e",
          "title": "Échappement super sound type Riva - Porsche 911 (912E)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-912e",
              "l": "Échappement sport - Porsche 911 (912E)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-super-sound-type-riva-porsche-912e",
              "l": "Échappement super sound type Riva - Porsche 911 (912E)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "912E"
      ]
    },
    "porsche-914-4-1-7": {
      "id": "porsche-914-4-1-7",
      "displayName": "914/4 1.7 L",
      "shortName": "914/4 1.7 L",
      "brand": "Porsche",
      "model": "914",
      "modelId": "914",
      "generation": "914",
      "generationId": "914",
      "generationLabel": "914 (1969-1976)",
      "period": "1969 - 1973",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-914-4",
      "drawingAsset": "scart-undercarriage-porsche-914-4.webp",
      "logoKey": "porsche-914",
      "logoAsset": "scart-logo-porsche-914.svg",
      "logoTitle": "914",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport-1-7l",
        "silencieux-super-sound-1-7l"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport-1-7l",
          "title": "Silencieux sport 1,7L - Porsche 914/4 1.7L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound-1-7l",
          "title": "Silencieux super sound 1,7L - Porsche 914/4 1.7",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-1-7l",
              "l": "Silencieux sport 1,7L - Porsche 914/4 1.7L",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-super-sound-1-7l",
              "l": "Silencieux super sound 1,7L - Porsche 914/4 1.7",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "914/4 1.7L",
        "914/4 1.7"
      ]
    },
    "porsche-914-4-2-0": {
      "id": "porsche-914-4-2-0",
      "displayName": "914/4 2.0 L",
      "shortName": "914/4 2.0 L",
      "brand": "Porsche",
      "model": "914",
      "modelId": "914",
      "generation": "914",
      "generationId": "914",
      "generationLabel": "914 (1969-1976)",
      "period": "1973 - 1976",
      "architecture": "Flat-4 atmosphérique",
      "description": "Architecture flat-4 atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-914-4",
      "drawingAsset": "scart-undercarriage-porsche-914-4.webp",
      "logoKey": "porsche-914",
      "logoAsset": "scart-logo-porsche-914.svg",
      "logoTitle": "914",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-avec-2-sorties-arri-re-pour-914-4-2-0l-super-sound",
        "silencieux-sport-2-0l",
        "silencieux-super-sound-2-0l"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-avec-2-sorties-arri-re-pour-914-4-2-0l-super-sound",
          "title": "Silencieux avec 2 sorties arrière pour /4 2,0L - super sound - Porsche 914/4 2.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-2-0l",
          "title": "Silencieux sport 2,0L - Porsche 914/4 2.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound-2-0l",
          "title": "Silencieux super sound 2,0L - Porsche 914/4 2.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-2-0l",
              "l": "Silencieux sport 2,0L - Porsche 914/4 2.0L",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-avec-2-sorties-arri-re-pour-914-4-2-0l-super-sound",
              "l": "Silencieux avec 2 sorties arrière pour /4 2,0L - super sound - Porsche 914/4 2.0L",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            },
            {
              "h": "silencieux-super-sound-2-0l",
              "l": "Silencieux super sound 2,0L - Porsche 914/4 2.0L",
              "type": "Silencieux",
              "s": 4,
              "g": "sound",
              "l_short": "Super Sound"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "914/4 2.0L"
      ]
    },
    "porsche-911-type-g-2-7": {
      "id": "porsche-911-type-g-2-7",
      "displayName": "Porsche 911 Type G 2,7 L / 3,0 L",
      "shortName": "911 2.7 L",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type G",
      "generationId": "type-g",
      "generationLabel": "Type G (1974-1989)",
      "period": "1974 - 1977",
      "architecture": "Atmosphérique",
      "description": "Ligne atmosphérique classique : tube de liaison, pré-silencieux, silencieux arrière et sortie.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-g",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "logoKey": "porsche-911-simple",
      "logoAsset": "scart-logo-porsche-911.svg",
      "logoTitle": "911",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "bmc-sport-air-filter-for-911-3-0l",
        "pr-silencieux-2-en-1-catalys-sport-100cc",
        "pr-silencieux-2-en-1-catalys-standard-300cc",
        "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
        "pr-silencieux-2-en-1-racing-sonorit-super-sound",
        "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
        "pr-silencieux-valve",
        "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
        "silencieux-sport-avec-valve-command-par-interrupteur",
        "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
        "sortie-chrom-e-origine-porsche",
        "sortie-noire-origine",
        "tube-interm-diaire-r-glable"
      ],
      "activeProducts": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-sport-100cc",
          "title": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-standard-300cc",
          "title": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
          "title": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
          "title": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
          "title": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-valve",
          "title": "Présilencieux à valve - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
          "title": "Silencieux pour 2,7L & 3,0L - sonorité super sound type Riva - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-command-par-interrupteur",
          "title": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
          "title": "Silencieux sport type banane pour 2,7 & 3,0L - sonorité sport - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-chrom-e-origine-porsche",
          "title": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-noire-origine",
          "title": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-interm-diaire-r-glable",
          "title": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 13,
      "zones": [
        {
          "id": "rear",
          "n": "Le silencieux arrière",
          "d": "La pièce principale qui donne sa voix à la voiture.",
          "rects": [
            [
              14.7,
              19.1,
              60.1,
              20.6
            ]
          ],
          "scale": [
            "Sport",
            "Riva"
          ],
          "journeyTitle": "La même pièce, deux sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
              "g": "sound",
              "l": "Sport",
              "s": 1
            },
            {
              "h": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "silencieux-sport-avec-valve-command-par-interrupteur",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "pre",
          "n": "Le pré-silencieux ou catalyseur",
          "d": "En amont, il prépare le son et libère le débit.",
          "rects": [
            [
              20.2,
              31.6,
              9.7,
              61.7
            ]
          ],
          "scale": [
            "Sonorité douce",
            "Riva",
            "Racing"
          ],
          "journeyTitle": "La même pièce, trois sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
              "g": "sound",
              "l": "Sonorité douce",
              "s": 1
            },
            {
              "h": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
              "g": "sound",
              "l": "Racing",
              "s": 3
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-sport-100cc",
              "g": "catalyst",
              "l": "Catalysé sport 100 cc"
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-standard-300cc",
              "g": "catalyst",
              "l": "Catalysé standard 300 cc"
            },
            {
              "h": "pr-silencieux-valve",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "link",
          "n": "Le tube de liaison",
          "d": "Il relie l’échangeur droit au pré-silencieux.",
          "rects": [
            [
              26.5,
              74,
              12,
              18
            ]
          ],
          "products": [
            {
              "h": "tube-interm-diaire-r-glable",
              "l": "Tube intermédiaire réglable"
            }
          ]
        },
        {
          "id": "outlet",
          "n": "La sortie d’échappement",
          "d": "Deux finitions d’origine, sans hiérarchie sonore entre elles.",
          "rects": [
            [
              7.5,
              12.5,
              14,
              14
            ]
          ],
          "products": [
            {
              "h": "sortie-chrom-e-origine-porsche",
              "l": "Chromée d’origine"
            },
            {
              "h": "sortie-noire-origine",
              "l": "Noire d’origine"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "2.7L (Type G)",
        "2.7L"
      ]
    },
    "porsche-911-sc-3-0": {
      "id": "porsche-911-sc-3-0",
      "displayName": "Porsche 911 Type G 2,7 L / 3,0 L",
      "shortName": "911 SC 3.0 L",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type G",
      "generationId": "type-g",
      "generationLabel": "Type G (1974-1989)",
      "period": "1978 - 1983",
      "architecture": "Atmosphérique",
      "description": "Ligne atmosphérique classique : tube de liaison, pré-silencieux, silencieux arrière et sortie.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-g",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "logoKey": "porsche-911-sc",
      "logoAsset": "scart-badge-911-sc.svg",
      "logoTitle": "911 SC",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "bmc-sport-air-filter-for-911-3-0l",
        "pr-silencieux-2-en-1-catalys-sport-100cc",
        "pr-silencieux-2-en-1-catalys-standard-300cc",
        "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
        "pr-silencieux-2-en-1-racing-sonorit-super-sound",
        "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
        "pr-silencieux-valve",
        "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
        "silencieux-sport-avec-valve-command-par-interrupteur",
        "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
        "sonde-lambda-pour-911-3-2l",
        "sortie-chrom-e-origine-porsche",
        "sortie-noire-origine",
        "tube-interm-diaire-r-glable"
      ],
      "activeProducts": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-sport-100cc",
          "title": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-standard-300cc",
          "title": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
          "title": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
          "title": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
          "title": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-valve",
          "title": "Présilencieux à valve - Porsche 911 3.0L / 2.7L (Type G)",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
          "title": "Silencieux pour 2,7L & 3,0L - sonorité super sound type Riva - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-command-par-interrupteur",
          "title": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
          "title": "Silencieux sport type banane pour 2,7 & 3,0L - sonorité sport - Porsche 911 2.7L (Type G) / 3.0L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sonde-lambda-pour-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.0L)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-chrom-e-origine-porsche",
          "title": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-noire-origine",
          "title": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-interm-diaire-r-glable",
          "title": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 14,
      "zones": [
        {
          "id": "rear",
          "n": "Le silencieux arrière",
          "d": "La pièce principale qui donne sa voix à la voiture.",
          "rects": [
            [
              14.7,
              19.1,
              60.1,
              20.6
            ]
          ],
          "scale": [
            "Sport",
            "Riva"
          ],
          "journeyTitle": "La même pièce, deux sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport",
              "g": "sound",
              "l": "Sport",
              "s": 1
            },
            {
              "h": "silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "silencieux-sport-avec-valve-command-par-interrupteur",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "pre",
          "n": "Le pré-silencieux ou catalyseur",
          "d": "En amont, il prépare le son et libère le débit.",
          "rects": [
            [
              20.2,
              31.6,
              9.7,
              61.7
            ]
          ],
          "scale": [
            "Sonorité douce",
            "Riva",
            "Racing"
          ],
          "journeyTitle": "La même pièce, trois sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
              "g": "sound",
              "l": "Sonorité douce",
              "s": 1
            },
            {
              "h": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
              "g": "sound",
              "l": "Riva",
              "s": 2
            },
            {
              "h": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
              "g": "sound",
              "l": "Racing",
              "s": 3
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-sport-100cc",
              "g": "catalyst",
              "l": "Catalysé sport 100 cc"
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-standard-300cc",
              "g": "catalyst",
              "l": "Catalysé standard 300 cc"
            },
            {
              "h": "pr-silencieux-valve",
              "g": "valve",
              "l": "Avec valves"
            }
          ]
        },
        {
          "id": "link",
          "n": "Le tube de liaison",
          "d": "Il relie l’échangeur droit au pré-silencieux.",
          "rects": [
            [
              26.5,
              74,
              12,
              18
            ]
          ],
          "products": [
            {
              "h": "tube-interm-diaire-r-glable",
              "l": "Tube intermédiaire réglable"
            }
          ]
        },
        {
          "id": "outlet",
          "n": "La sortie d’échappement",
          "d": "Deux finitions d’origine, sans hiérarchie sonore entre elles.",
          "rects": [
            [
              7.5,
              12.5,
              14,
              14
            ]
          ],
          "products": [
            {
              "h": "sortie-chrom-e-origine-porsche",
              "l": "Chromée d’origine"
            },
            {
              "h": "sortie-noire-origine",
              "l": "Noire d’origine"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "bmc-sport-air-filter-for-911-3-0l",
          "title": "Filtre à air sport BMC - Porsche 911 3.0L / 2.7L (Type G)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "sonde-lambda-pour-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.0L)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "3.0L"
      ]
    },
    "porsche-911-carrera-3-2": {
      "id": "porsche-911-carrera-3-2",
      "displayName": "911 Carrera 3.2 L",
      "shortName": "911 SC 3.0 L",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "Type G",
      "generationId": "type-g",
      "generationLabel": "Type G (1974-1989)",
      "period": "1984 - 1989",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-type-g",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "logoKey": "porsche-911-sc",
      "logoAsset": "scart-badge-911-sc.svg",
      "logoTitle": "911 SC",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "filtre-air-sport-bmc-pour-911-3-2l",
        "o2-sensor-for-911-3-2l",
        "pr-silencieux-2-en-1-catalys-sport-100cc",
        "pr-silencieux-2-en-1-catalys-standard-300cc",
        "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
        "pr-silencieux-2-en-1-racing-sonorit-super-sound",
        "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
        "rear-dual-tail-pipe-skurt",
        "rear-dual-tail-pipes",
        "silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller",
        "silencieux-sport-avec-valve-command-par-interrupteur",
        "silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport",
        "sortie-chrom-e-origine-porsche",
        "sortie-noire-origine",
        "tube-interm-diaire-r-glable"
      ],
      "activeProducts": [
        {
          "handle": "filtre-air-sport-bmc-pour-911-3-2l",
          "title": "Filtre à air sport BMC pour 3,2L - Porsche 911 (3.2L)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "o2-sensor-for-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.2L)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-sport-100cc",
          "title": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-catalys-standard-300cc",
          "title": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
          "title": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
          "title": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
          "title": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Pré-Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "rear-dual-tail-pipe-skurt",
          "title": "Échappement sortie double arrière + jupe Riva - Porsche 911 3.2L",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "rear-dual-tail-pipes",
          "title": "Échappement sortie double arrière + jupe - Porsche 911 (3.2L)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller",
          "title": "Silencieux pour 3,2L - sonorité super sound type Riva - Porsche 911 (3.2L)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-command-par-interrupteur",
          "title": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport",
          "title": "Silencieux sport type banane pour 3,2L - sonorité sport - Porsche 911 (3.2L)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-chrom-e-origine-porsche",
          "title": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-noire-origine",
          "title": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-interm-diaire-r-glable",
          "title": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 15,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport",
              "l": "Silencieux sport type banane pour 3,2L - sonorité sport - Porsche 911 (3.2L)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller",
              "l": "Silencieux pour 3,2L - sonorité super sound type Riva - Porsche 911 (3.2L)",
              "type": "Silencieux",
              "s": 3,
              "g": "sound",
              "l_short": "Riva"
            },
            {
              "h": "silencieux-sport-avec-valve-command-par-interrupteur",
              "l": "Silencieux sport avec valve commandé par interrupteur - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "mid",
          "n": "Le tube intermédiaire",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "pr-silencieux-2-en-1-flux-optimis-sonorit-douce",
              "l": "Pré-silencieux 2 en 1 à flux optimisé - sonorité douce - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "pr-silencieux-2-en-1-racing-sonorit-super-sound",
              "l": "Pré-silencieux 2 en 1 Racing - sonorité super sound - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller",
              "l": "Pré-silencieux 2 en 1 - sonorité sport (type Riva) - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "tube-interm-diaire-r-glable",
              "l": "Tube intermédiaire réglable - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "pr-silencieux-2-en-1-catalys-sport-100cc",
              "l": "Pré-silencieux 2 en 1 catalysé - sport 100cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            },
            {
              "h": "pr-silencieux-2-en-1-catalys-standard-300cc",
              "l": "Pré-silencieux 2 en 1 catalysé - standard 300cc - Porsche 911 2.7L (Type G) / 3.0L / 3.2L",
              "type": "Pré-Silencieux"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "rear-dual-tail-pipe-skurt",
              "l": "Échappement sortie double arrière + jupe Riva - Porsche 911 3.2L",
              "type": "Silencieux"
            },
            {
              "h": "rear-dual-tail-pipes",
              "l": "Échappement sortie double arrière + jupe - Porsche 911 (3.2L)",
              "type": "Silencieux"
            },
            {
              "h": "sortie-chrom-e-origine-porsche",
              "l": "Sortie chromée origine - Porsche 911 3.2L / 3.0L / 2.7L (Type G)",
              "type": "Sortie"
            },
            {
              "h": "sortie-noire-origine",
              "l": "Sortie noire origine - Porsche 911 2.7L (Type G) / 3.2L / 3.0L",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-911-3-2l",
          "title": "Filtre à air sport BMC pour 3,2L - Porsche 911 (3.2L)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "o2-sensor-for-911-3-2l",
          "title": "Sonde Lambda pour 3,2L - Porsche 911 (3.2L)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "3.2L"
      ]
    },
    "porsche-911-930-turbo": {
      "id": "porsche-911-930-turbo",
      "displayName": "Porsche 911 Turbo 930",
      "shortName": "911 Turbo (930)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "930",
      "generationId": "930",
      "generationLabel": "930 Turbo (1975-1989)",
      "period": "1975 - 1989",
      "architecture": "Simple turbo et wastegate",
      "description": "La ligne Turbo suit un chemin propre, avec alimentation du turbo et wastegate.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-930-turbo",
      "drawingAsset": "porsche-911-930-turbo-undercarriage-exhaust.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-sport-100-cc-930-turbo",
        "catalyseur-standard-400-cellules",
        "muffler-super-sound",
        "pipe-from-headers-to-turbo-wg",
        "silencieux-sport-sonorit-sport",
        "silencieux-sport-sonorit-super-sound",
        "silencieux-sport-sorties-jointes",
        "silencieux-super-sound",
        "silencieux-type-934-une-sortie-centrale-arri-re-90mm",
        "silencieux-type-934-une-sortie-centrale-arriere-90mm",
        "silencieux-us-super-sound",
        "tube-de-wastegate"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-sport-100-cc-930-turbo",
          "title": "Catalyseur sport 100 cc - Turbo - Porsche 911 (930)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-400-cellules",
          "title": "Catalyseur standard (400 cellules) - Porsche 911 (930)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "muffler-super-sound",
          "title": "Silencieux sport 3.0L - sonorité super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "pipe-from-headers-to-turbo-wg",
          "title": "Tube de liaison collecteurs > turbo - Porsche 911 (930)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sonorit-sport",
          "title": "Silencieux sport - sonorité sport - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sonorit-super-sound",
          "title": "Silencieux sport - sonorité super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sorties-jointes",
          "title": "Silencieux sport - sorties jointes - 3.3L - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-super-sound",
          "title": "Silencieux super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-type-934-une-sortie-centrale-arri-re-90mm",
          "title": "Silencieux type 934 (une sortie centrale arrière 90mm) - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-type-934-une-sortie-centrale-arriere-90mm",
          "title": "Silencieux type 934 (une sortie centrale arrière 90mm) - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-us-super-sound",
          "title": "Silencieux US - super sound - Porsche 911 (930)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-de-wastegate",
          "title": "Tube de wastegate - Porsche 911 (930)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 12,
      "zones": [
        {
          "id": "link",
          "n": "Le tube d’alimentation du turbo",
          "d": "Le conduit d’alimentation du turbo et de la wastegate.",
          "rects": [
            [
              21.5,
              26,
              29,
              49
            ]
          ],
          "products": [
            {
              "h": "pipe-from-headers-to-turbo-wg",
              "l": "Tube collecteurs vers turbo et wastegate"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Le catalyseur ou by-pass",
          "d": "Pour les 930 3,3 L US : préserve l’origine en 400 cellules ou libère flux et son en 100 cellules.",
          "rects": [
            [
              42,
              24,
              12,
              13
            ]
          ],
          "scale": [
            "Standard 400 c",
            "Sport 100 c"
          ],
          "journeyTitle": "La même pièce, deux caractères",
          "journeyHint": "La densité du catalyseur change le résultat",
          "products": [
            {
              "h": "catalyseur-standard-400-cellules",
              "s": 1,
              "l": "Standard 400 cellules"
            },
            {
              "h": "catalyseur-sport-100-cc-930-turbo",
              "s": 2,
              "l": "Sport 100 cellules"
            }
          ]
        },
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Choisissez la cylindrée et, pour la 3,3 L, la configuration Europe ou US catalysée.",
          "rects": [
            [
              40.5,
              17,
              34,
              15
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Super Sound"
          ],
          "journeyTitle": "Le même silencieux, deux sonorités",
          "journeyHint": "La forme fait le son",
          "filter": {
            "label": "Quelle configuration équipe votre 930 ?",
            "options": [
              {
                "id": "all",
                "l": "Toutes configurations"
              },
              {
                "id": "30",
                "l": "3,0 L"
              },
              {
                "id": "33",
                "l": "3,3 L Europe"
              },
              {
                "id": "33-us",
                "l": "3,3 L US · catalysée"
              }
            ]
          },
          "products": [
            {
              "h": "silencieux-sport-sonorit-sport",
              "f": [
                "30"
              ],
              "g": "sound",
              "s": 1,
              "l": "Sport · sortie simple (3.0 L)"
            },
            {
              "h": "silencieux-sport-sonorit-super-sound",
              "f": [
                "30"
              ],
              "g": "sound",
              "s": 2,
              "l": "Super Sound · sortie simple (3.0 L)"
            },
            {
              "h": "silencieux-sport-sorties-jointes",
              "f": [
                "33"
              ],
              "g": "sound",
              "s": 1,
              "l": "Sport · sorties jointes (3.3 L)"
            },
            {
              "h": "silencieux-super-sound",
              "f": [
                "33"
              ],
              "g": "sound",
              "s": 2,
              "l": "Super Sound · sorties jointes (3.3 L)"
            },
            {
              "h": "silencieux-type-934-une-sortie-centrale-arriere-90mm",
              "f": [
                "30",
                "33"
              ],
              "l": "Type 934 · sortie centrale"
            },
            {
              "h": "silencieux-us-super-sound",
              "f": [
                "33-us"
              ],
              "l": "Version US · Super Sound"
            }
          ]
        },
        {
          "id": "wastegate",
          "n": "Le tube de wastegate",
          "d": "La sortie dédiée de régulation du turbo.",
          "rects": [
            [
              25,
              29,
              18,
              30
            ]
          ],
          "products": [
            {
              "h": "tube-de-wastegate",
              "l": "Tube de wastegate"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "Alias `930` et `930 ` (espace final) coexistent dans le métaobjet.",
      "anomalies": [],
      "aliases": [
        "930",
        "930 "
      ]
    },
    "porsche-911-964-carrera": {
      "id": "porsche-911-964-carrera",
      "displayName": "Porsche 911 Carrera 964",
      "shortName": "911 Carrera (964)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "964",
      "generationId": "964",
      "generationLabel": "964 (1989-1994)",
      "period": "1989 - 1994",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique à catalyseur transversal et deux étages de silencieux.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-964-carrera",
      "drawingAsset": "porsche-911-964-carrera-undercarriage-exhaust.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-racing",
        "catalyseur-by-pass-sport-porsche-964",
        "catalyseur-sport-100cc-porsche-964",
        "catalyseur-standard-300-cc-porsche-964",
        "col-de-cygne",
        "collier-964",
        "echappement-a-valve-porsche-964",
        "echappement-sport-riva",
        "filtre-air-sport-bmc-pour-964",
        "kit-montage-964",
        "ligne-d-chappements-1-sortie-sonorit-sport",
        "ligne-d-chappements-2-sorties-sonorit-sport",
        "ligne-d-chappements-racing-1-sortie-sonorit-super-sound",
        "ligne-d-chappements-racing-2-sorties-sonorit-super-sound",
        "olive-964",
        "silencieux-arri-re-droit-version-sport",
        "silencieux-arri-re-droit-version-super-sound",
        "sonde-lambda-964",
        "sortie-avec-ourlet-90mm-insert",
        "sortie-ovale",
        "syst-me-cup-1-sortie-sonorit-sport",
        "syst-me-cup-2-sorties-sonorit-sport",
        "syst-me-cup-2-sorties-super-sound",
        "tube-cup"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-racing",
          "title": "Catalyseur by-pass racing - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-by-pass-sport-porsche-964",
          "title": "Catalyseur by-pass sport - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100cc-porsche-964",
          "title": "Catalyseur sport 100cc - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cc-porsche-964",
          "title": "Catalyseur standard 300 cc - Porsche 911 (964)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "col-de-cygne",
          "title": "Col de cygne - Porsche 911 (964 / 964 Turbo)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collier-964",
          "title": "Collier - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valve-porsche-964",
          "title": "Échappement à valves - Porsche 911 (964)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-riva",
          "title": "Échappement sport Riva - Porsche 911 (964)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-964",
          "title": "Filtre à air sport BMC - Porsche 911 (964)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-montage-964",
          "title": "Kit montage - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-1-sortie-sonorit-sport",
          "title": "Ligne d’échappements à 1 sortie - Sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-2-sorties-sonorit-sport",
          "title": "Ligne d’échappements à 2 sorties - Sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-racing-1-sortie-sonorit-super-sound",
          "title": "Ligne d’échappements Racing à 1 sortie - Sonorité super sound - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "ligne-d-chappements-racing-2-sorties-sonorit-super-sound",
          "title": "Ligne d’échappements racing à 2 sorties - Sonorité super sound - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "olive-964",
          "title": "Olive - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-sport",
          "title": "Silencieux arrière droit - Version sport - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-super-sound",
          "title": "Silencieux arrière droit - Version super sound - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sonde-lambda-964",
          "title": "Sonde Lambda - Porsche 911 (964)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-avec-ourlet-90mm-insert",
          "title": "Sortie avec ourlet (90mm) + insert - Porsche 911 (964)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-ovale",
          "title": "Sortie ovale - Porsche 911 (964)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "syst-me-cup-1-sortie-sonorit-sport",
          "title": "Système Cup 1 sortie - sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "syst-me-cup-2-sorties-sonorit-sport",
          "title": "Système Cup 2 sorties - sonorité sport - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "syst-me-cup-2-sorties-super-sound",
          "title": "Système Cup 2 sorties - super sound - Porsche 911 (964)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-cup",
          "title": "Tube CUP - Porsche 911 (964)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 24,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le catalyseur ou by-pass",
          "d": "L’emplacement de dépollution peut recevoir un catalyseur standard, sport ou un by-pass lorsque disponible.",
          "rects": [
            [
              16.8,
              29.5,
              11.8,
              44.2
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Le plus radical"
          ],
          "journeyTitle": "La même pièce, quatre niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage hors route ouverte.",
          "products": [
            {
              "h": "catalyseur-standard-300-cc-porsche-964",
              "s": 1,
              "l": "Standard 300 cc",
              "d": "Le plus proche du comportement d’origine."
            },
            {
              "h": "catalyseur-sport-100cc-porsche-964",
              "s": 2,
              "l": "Sport 100 cc",
              "d": "Plus libre et plus sportif."
            },
            {
              "h": "catalyseur-by-pass-sport-porsche-964",
              "s": 3,
              "l": "By-pass Sport",
              "d": "Sans catalyseur, avec silencieux intégré."
            },
            {
              "h": "catalyseur-by-pass-racing",
              "s": 4,
              "l": "By-pass Racing",
              "d": "Tube direct sans silencieux."
            }
          ]
        },
        {
          "id": "primary",
          "n": "Le silencieux primaire transversal",
          "d": "Section transversale propre à la Carrera. Le Tube Cup et la solution à valve compatible sont proposés ici.",
          "rects": [
            [
              28.2,
              17.5,
              44.5,
              15.5
            ]
          ],
          "scale": [
            "Direct",
            "Progressif",
            "Pilotable"
          ],
          "journeyTitle": "Le même emplacement, trois réponses",
          "journeyHint": "Direct, progressif ou pilotable",
          "products": [
            {
              "h": "tube-cup",
              "s": 1,
              "l": "Tube CUP",
              "d": "Tube direct en inox fin, sans commande."
            },
            {
              "h": "echappement-sport-riva",
              "s": 2,
              "l": "Riva",
              "d": "Doux à régime stabilisé, agressif à l’accélération."
            },
            {
              "h": "echappement-a-valve-porsche-964",
              "s": 3,
              "l": "Valves fermées / ouvertes",
              "d": "Discret ou très sport à la demande."
            }
          ]
        },
        {
          "id": "secondary",
          "n": "Le silencieux secondaire droit",
          "d": "La dernière section de contrôle sonore avant la sortie unique.",
          "rects": [
            [
              71.8,
              35.2,
              15.2,
              42.8
            ]
          ],
          "scale": [
            "Son proche de l’origine",
            "Puissant et profond"
          ],
          "journeyTitle": "La même pièce, trois sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-arri-re-droit-version-sport",
              "s": 1,
              "l": "Sport",
              "d": "Une présence légèrement renforcée."
            },
            {
              "h": "silencieux-arri-re-droit-version-super-sound",
              "s": 2,
              "l": "Super Sound",
              "d": "Un niveau intermédiaire plus expressif."
            },
            {
              "h": "col-de-cygne",
              "s": 3,
              "l": "Col de cygne",
              "d": "Le choix le plus puissant et profond."
            }
          ]
        },
        {
          "id": "outlet",
          "n": "La sortie d’échappement",
          "d": "La pièce de finition visible à l’arrière de la voiture.",
          "rects": [
            [
              77.5,
              9.2,
              9.2,
              27.5
            ]
          ],
          "scale": [
            "Finition d’origine",
            "Atténuation amovible"
          ],
          "journeyTitle": "La même pièce, deux usages",
          "journeyHint": "Finition ou atténuation amovible",
          "products": [
            {
              "h": "sortie-ovale",
              "s": 1,
              "l": "Sortie ovale",
              "d": "Une finition fidèle à l’origine."
            },
            {
              "h": "sortie-avec-ourlet-90mm-insert",
              "s": 2,
              "l": "Sortie 90 mm avec insert",
              "d": "Insert amovible pour atténuer le son."
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "collier-964",
          "title": "Collier - Porsche 911 (964)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-964",
          "title": "Filtre à air sport BMC - Porsche 911 (964)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-montage-964",
          "title": "Kit montage - Porsche 911 (964)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "olive-964",
          "title": "Olive - Porsche 911 (964)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "sonde-lambda-964",
          "title": "Sonde Lambda - Porsche 911 (964)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 5,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [
        "ACTIVE mais non publié(s) : syst-me-cup-1-sortie-sonorit-super-sound"
      ],
      "aliases": [
        "964"
      ]
    },
    "porsche-911-964-turbo": {
      "id": "porsche-911-964-turbo",
      "displayName": "Porsche 911 Turbo 964",
      "shortName": "911 Turbo (964)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "964",
      "generationId": "964",
      "generationLabel": "964 (1989-1994)",
      "period": "1990 - 1994",
      "architecture": "Simple turbo et wastegate",
      "description": "Architecture spécifique à simple turbo, distincte de la Carrera.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-964-turbo",
      "drawingAsset": "porsche-911-964-turbo-undercarriage-exhaust.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-racing-porsche-964-turbo",
        "catalyseur-sport-100-cellules",
        "catalyseur-standard-300-cellules",
        "col-de-cygne",
        "filtre-a-air-sport-bmc-porsche-964-turbo",
        "paire-de-sorties-ovales",
        "silencieux-arri-re-droit-version-sport",
        "silencieux-arri-re-droit-version-super-sound",
        "tube-de-waste-gate"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-racing-porsche-964-turbo",
          "title": "Catalyseur By-Pass Racing - Porsche 964 Turbo",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100-cellules",
          "title": "Catalyseur sport (100 cellules) - Porsche 911 (964 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cellules",
          "title": "Catalyseur standard (300 cellules) - Porsche 911 (964 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "col-de-cygne",
          "title": "Col de cygne - Porsche 911 (964 / 964 Turbo)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-a-air-sport-bmc-porsche-964-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (964 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-ovales",
          "title": "Paire de sorties ovales - Porsche 911 (964 Turbo)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-sport",
          "title": "Silencieux arrière droit - Version sport - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-arri-re-droit-version-super-sound",
          "title": "Silencieux arrière droit - Version super sound - Porsche 911 (964 / 964 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tube-de-waste-gate",
          "title": "Tube de waste - gate - Porsche 911 (964 Turbo)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 9,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le catalyseur ou by-pass",
          "d": "Du remplacement proche de l’origine au by-pass le plus libre.",
          "rects": [
            [
              20,
              50,
              13,
              27
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Le plus radical"
          ],
          "journeyTitle": "La même pièce, trois niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Le by-pass est réservé à un usage hors route ouverte.",
          "products": [
            {
              "h": "catalyseur-standard-300-cellules",
              "s": 1,
              "l": "Standard 300 cellules"
            },
            {
              "h": "catalyseur-sport-100-cellules",
              "s": 2,
              "l": "Sport 100 cellules"
            },
            {
              "h": "catalyseur-by-pass-racing-porsche-964-turbo",
              "s": 3,
              "l": "By-pass Racing"
            }
          ]
        },
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Il détermine le niveau et la profondeur du son.",
          "rects": [
            [
              69,
              26,
              16,
              50
            ]
          ],
          "scale": [
            "Son proche de l’origine",
            "Puissant et profond"
          ],
          "journeyTitle": "La même pièce, deux sonorités",
          "journeyHint": "La forme fait le son",
          "products": [
            {
              "h": "silencieux-arri-re-droit-version-sport",
              "s": 1,
              "l": "Sport"
            },
            {
              "h": "silencieux-arri-re-droit-version-super-sound",
              "s": 2,
              "l": "Super Sound"
            }
          ]
        },
        {
          "id": "link",
          "n": "Le tube de liaison",
          "d": "Il relie le silencieux principal à la sortie d’échappement.",
          "rects": [
            [
              76,
              20,
              6,
              15
            ]
          ],
          "products": [
            {
              "h": "col-de-cygne",
              "l": "Col de cygne"
            }
          ]
        },
        {
          "id": "wastegate",
          "n": "La branche de wastegate",
          "d": "La sortie dédiée de régulation du turbo.",
          "rects": [
            [
              13,
              13,
              19,
              22
            ]
          ],
          "products": [
            {
              "h": "tube-de-waste-gate",
              "l": "Tube de wastegate"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties Turbo",
          "d": "La paire de sorties adaptée à cette architecture.",
          "rects": [
            [
              12,
              9,
              11,
              20
            ],
            [
              82,
              8,
              7,
              14
            ]
          ],
          "products": [
            {
              "h": "paire-de-sorties-ovales",
              "l": "Paire de sorties ovales Turbo"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-a-air-sport-bmc-porsche-964-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (964 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "`catalyseur-by-pass-racing-porsche-964-turbo` n'est rattaché que par mod_le (vehicle_compat absent) : relancer sync_vehicle_compat.py.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : catalyseur-by-pass-racing-porsche-964-turbo"
      ],
      "aliases": [
        "964 Turbo"
      ]
    },
    "porsche-911-993-carrera": {
      "id": "porsche-911-993-carrera",
      "displayName": "Porsche 911 Carrera 993",
      "shortName": "911 Carrera (993)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "993",
      "generationId": "993",
      "generationLabel": "993 (1994-1998)",
      "period": "1994 - 1998",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique avec catalyseur transversal et silencieux latéraux.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-993-carrera",
      "drawingAsset": "porsche-911-993-carrera-undercarriage-exhaust.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-racing-by-pass-bischoff",
        "catalyseur-racing-by-pass-gillet",
        "catalyseur-sport-100-cc-bischoff",
        "catalyseur-sport-100-cc-gillet",
        "catalyseur-standard-300-cc-bischoff",
        "catalyseur-standard-300-cc-gillet",
        "echappement-a-valves-porsche-993",
        "filtre-air-sport-bmc-pour-993",
        "kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
        "option-interrupteur-porsche",
        "silencieux-riva",
        "sonde-lambda-pour-porsche-993"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-racing-by-pass-bischoff",
          "title": "Catalyseur racing by-pass - Bischoff - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-racing-by-pass-gillet",
          "title": "Catalyseur racing by-pass - Gillet - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100-cc-bischoff",
          "title": "Catalyseur sport 100 cc - Bischoff - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-100-cc-gillet",
          "title": "Catalyseur sport 100 cc - Gillet - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cc-bischoff",
          "title": "Catalyseur standard 300 cc - Bischoff - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-standard-300-cc-gillet",
          "title": "Catalyseur standard 300 cc - Gillet - Porsche 911 (993)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valves-porsche-993",
          "title": "Échappement à valves - Porsche 911 (993)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-993",
          "title": "Filtre à air sport BMC - Porsche 911 (993)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
          "title": "Kit de colliers et d'olives pour sorties de silencieux – Porsche 993",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "option-interrupteur-porsche",
          "title": "Option interrupteur - Porsche 911 (993)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-riva",
          "title": "Échappement super sound Type Riva - Porsche 911 (993)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sonde-lambda-pour-porsche-993",
          "title": "Sonde Lambda - Porsche 911 (993)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 12,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le catalyseur transversal double voie",
          "d": "La bonne référence Scart dépend du fournisseur d’origine, Bischoff ou Gillet.",
          "rects": [
            [
              20.5,
              11.8,
              59,
              15.2
            ]
          ],
          "journeyTitle": "La même pièce, trois niveaux",
          "journeyHint": "Selon votre fournisseur d’origine",
          "filter": {
            "label": "Quel est le fournisseur du catalyseur d’origine ?",
            "options": [
              {
                "id": "all",
                "l": "Tous"
              },
              {
                "id": "bischoff",
                "l": "Bischoff"
              },
              {
                "id": "gillet",
                "l": "Gillet"
              }
            ]
          },
          "products": [
            {
              "h": "catalyseur-standard-300-cc-bischoff",
              "f": [
                "bischoff"
              ],
              "s": 1,
              "l": "Standard 300 cc (Bischoff)"
            },
            {
              "h": "catalyseur-sport-100-cc-bischoff",
              "f": [
                "bischoff"
              ],
              "s": 2,
              "l": "Sport 100 cc (Bischoff)"
            },
            {
              "h": "catalyseur-racing-by-pass-bischoff",
              "f": [
                "bischoff"
              ],
              "s": 3,
              "l": "By-pass Racing (Bischoff)"
            },
            {
              "h": "catalyseur-standard-300-cc-gillet",
              "f": [
                "gillet"
              ],
              "s": 1,
              "l": "Standard 300 cc (Gillet)"
            },
            {
              "h": "catalyseur-sport-100-cc-gillet",
              "f": [
                "gillet"
              ],
              "s": 2,
              "l": "Sport 100 cc (Gillet)"
            },
            {
              "h": "catalyseur-racing-by-pass-gillet",
              "f": [
                "gillet"
              ],
              "s": 3,
              "l": "By-pass Racing (Gillet)"
            }
          ]
        },
        {
          "id": "mufflers",
          "n": "Les silencieux gauche et droit",
          "d": "Une paire assortie contrôle le son des deux côtés. Le système à valves apparaît uniquement comme option de cette pièce.",
          "rects": [
            [
              9.5,
              27.5,
              13.5,
              24.5
            ],
            [
              77,
              27.5,
              13.5,
              24.5
            ]
          ],
          "scale": [
            "Sonorité douce",
            "Riva",
            "Valves"
          ],
          "journeyTitle": "Le même emplacement, trois réponses",
          "journeyHint": "Trois signatures acoustiques distinctes",
          "products": [
            {
              "h": "silencieux",
              "g": "sound",
              "s": 1,
              "l": "Sonorité douce",
              "d": "Une présence légèrement renforcée mais très civilisée."
            },
            {
              "h": "silencieux-riva",
              "g": "sound",
              "s": 2,
              "l": "Riva",
              "d": "Une signature sonore fixe, pensée pour rester vivante."
            },
            {
              "h": "echappement-a-valves-porsche-993",
              "g": "valve",
              "s": 3,
              "l": "Valves fermées / ouvertes",
              "d": "Deux caractères accessibles à la demande."
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-993",
          "title": "Filtre à air sport BMC - Porsche 911 (993)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
          "title": "Kit de colliers et d'olives pour sorties de silencieux – Porsche 993",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "option-interrupteur-porsche",
          "title": "Option interrupteur - Porsche 911 (993)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "sonde-lambda-pour-porsche-993",
          "title": "Sonde Lambda - Porsche 911 (993)",
          "category": "sensor",
          "description": "Sonde Lambda pour régulation optimale du mélange et compatibilité catalyseur."
        }
      ],
      "accessoriesCount": 4,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "`kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993` rattaché par mod_le seulement.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : kit-de-colliers-et-dolives-pour-sorties-de-silencieux-porsche-993",
        "ACTIVE mais non publié(s) : silencieux"
      ],
      "aliases": [
        "993"
      ]
    },
    "porsche-911-993-turbo": {
      "id": "porsche-911-993-turbo",
      "displayName": "Porsche 911 Turbo 993",
      "shortName": "911 Turbo (993)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "993",
      "generationId": "993",
      "generationLabel": "993 (1994-1998)",
      "period": "1995 - 1998",
      "architecture": "Deux turbos",
      "description": "Architecture à deux turbos avec catalyseurs et silencieux latéraux spécifiques.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-993-turbo",
      "drawingAsset": "porsche-911-993-turbo-undercarriage-exhaust.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-sport-200-cellules",
        "silencieux-sport-riva",
        "silencieux-valves-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-sport-200-cellules",
          "title": "Catalyseur sport (200 cellules) - Porsche 911 (993 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-riva",
          "title": "Échappement super sound Type Riva - Porsche 911 (993 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves-commande-par-interrupteur",
          "title": "Échappement à valves - Porsche 911 (993 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "catalyst",
          "n": "Le bloc catalytique Turbo",
          "d": "La paire de catalyseurs sport propre à cette architecture.",
          "rects": [
            [
              20,
              18,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "catalyseur-sport-200-cellules",
              "l": "Catalyseurs Sport 200 cellules"
            }
          ]
        },
        {
          "id": "mufflers",
          "n": "Les silencieux latéraux Turbo",
          "d": "Une sonorité fixe avec Riva, ou modulable avec les valves.",
          "rects": [
            [
              12.5,
              32,
              10.5,
              28
            ],
            [
              77,
              32,
              10.5,
              28
            ]
          ],
          "scale": [
            "Sonorité fixe",
            "Polyvalence à la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande",
          "products": [
            {
              "h": "silencieux-sport-riva",
              "g": "sound",
              "s": 1,
              "l": "Riva",
              "d": "Une signature sonore fixe, pensée pour rester vivante."
            },
            {
              "h": "silencieux-valves-commande-par-interrupteur",
              "g": "sound",
              "s": 2,
              "l": "Valves fermées / ouvertes",
              "d": "Deux caractères accessibles à la demande."
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "option-interrupteur-porsche",
          "title": "Option interrupteur - Porsche 911 (993)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": true,
      "zoneCalibration": "production",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "993 Turbo"
      ]
    },
    "porsche-928-s": {
      "id": "porsche-928-s",
      "displayName": "928 S",
      "shortName": "928 S",
      "brand": "Porsche",
      "model": "928",
      "modelId": "928",
      "generation": "928",
      "generationId": "928",
      "generationLabel": "928 (1977-1995)",
      "period": "1980 - 1986",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-928-s",
      "drawingAsset": "scart-undercarriage-porsche-928-s.webp",
      "logoKey": "porsche-928-s",
      "logoAsset": "scart-logo-porsche-928-s.svg",
      "logoTitle": "928 S",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport",
          "title": "Silencieux sport - Porsche 928 S",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport",
              "l": "Silencieux sport - Porsche 928 S",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet « 928 » couvre 1978-1995 mais le seul produit actif vise la 928 S.",
      "anomalies": [],
      "aliases": [
        "928 S",
        "928"
      ]
    },
    "porsche-928-s4-gt-gts": {
      "id": "porsche-928-s4-gt-gts",
      "displayName": "928 S4 / GT / GTS",
      "shortName": "928 S4 / GT / GTS",
      "brand": "Porsche",
      "model": "928",
      "modelId": "928",
      "generation": "928",
      "generationId": "928",
      "generationLabel": "928 (1977-1995)",
      "period": "1987 - 1995",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-928-s4-gt-gts",
      "drawingAsset": "scart-undercarriage-porsche-928-s4-gt-gts.webp",
      "logoKey": "porsche-928-s4",
      "logoAsset": "scart-logo-porsche-928-s4.svg",
      "logoTitle": "928 S4",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-ultima-porsche-928-s4-gt-gts"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-ultima-porsche-928-s4-gt-gts",
          "title": "Échappement sport Ultima - Porsche 928 S4/GT/GTS",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-928-s4-gt-gts",
              "l": "Échappement sport Ultima - Porsche 928 S4/GT/GTS",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet (carte compat PDP vide).",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "928 S4/GT/GTS"
      ]
    },
    "porsche-944-turbo": {
      "id": "porsche-944-turbo",
      "displayName": "944 Turbo",
      "shortName": "944 Turbo",
      "brand": "Porsche",
      "model": "944",
      "modelId": "944",
      "generation": "944",
      "generationId": "944",
      "generationLabel": "944 (1985-1991)",
      "period": "1985 - 1991",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-944-turbo",
      "drawingAsset": "scart-undercarriage-porsche-944-turbo.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valve-porsche-944-turbo",
        "echappement-sport-ultima-porsche-944-turbo"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valve-porsche-944-turbo",
          "title": "Échappement à valves - Porsche 944 Turbo",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-944-turbo",
          "title": "Échappement Sport Ultima - Porsche 944 Turbo",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-944-turbo",
              "l": "Échappement Sport Ultima - Porsche 944 Turbo",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valve-porsche-944-turbo",
              "l": "Échappement à valves - Porsche 944 Turbo",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet « 944 » déclare aussi 944, 944 S, 944 S2 sans aucun produit actif. `echappement-sport-ultima-porsche-944-turbo` rattaché par mod_le seulement.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : echappement-sport-ultima-porsche-944-turbo"
      ],
      "aliases": [
        "944 Turbo"
      ]
    },
    "porsche-968": {
      "id": "porsche-968",
      "displayName": "968",
      "shortName": "968",
      "brand": "Porsche",
      "model": "968",
      "modelId": "968",
      "generation": "968",
      "generationId": "968",
      "generationLabel": "968 (1992-1995)",
      "period": "1992 - 1995",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-968",
      "drawingAsset": "scart-undercarriage-porsche-968.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-avec-silencieux",
        "catalyseur-sport-200cc-porsche-968",
        "echappement-a-valve-porsche-968",
        "silencieux-sport-avec-sortie"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-avec-silencieux",
          "title": "Catalyseur by-pass avec silencieux - Porsche 968",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseur-sport-200cc-porsche-968",
          "title": "Catalyseur sport 200cc - Porsche 968",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valve-porsche-968",
          "title": "Échappement à valves - Porsche 968",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-sortie",
          "title": "Silencieux sport avec sortie - Porsche 968",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière",
          "d": "Silencieux arrière inox libérant la sonorité.",
          "rects": [
            [
              58,
              14,
              28,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-avec-sortie",
              "l": "Silencieux sport avec sortie - Porsche 968",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valve-porsche-968",
              "l": "Échappement à valves - Porsche 968",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs & by-pass",
          "d": "Catalyseur sport 200 cellules ou by-pass avec silencieux intégré.",
          "rects": [
            [
              32,
              42,
              36,
              20
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseur-by-pass-avec-silencieux",
              "l": "Catalyseur by-pass avec silencieux - Porsche 968",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseur-sport-200cc-porsche-968",
              "l": "Catalyseur sport 200cc - Porsche 968",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "`catalyseur-sport-200cc-porsche-968` rattaché par mod_le seulement.",
      "anomalies": [
        "Produit(s) rattaché(s) uniquement via custom.mod_le, custom.vehicle_compat absent : catalyseur-sport-200cc-porsche-968"
      ],
      "aliases": [
        "968"
      ]
    },
    "porsche-boxster-986": {
      "id": "porsche-boxster-986",
      "displayName": "Boxster 986",
      "shortName": "Boxster 986",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "986",
      "generationId": "986",
      "generationLabel": "986 (1996-2004)",
      "period": "1996 - 2004",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-986",
      "drawingAsset": "scart-undercarriage-porsche-boxster-986.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-200cc-2-7l-3-2l",
        "catalyseurs-200cc-pour-porsche-986-2-5l",
        "catalyseurs-by-pass-porsche-986-2-7l-3-2l",
        "filtre-air-sport-bmc-pour-986",
        "inter-pse-996-986",
        "paire-de-collecteurs-inox-scart-pour-porsche-boxster-986",
        "silencieux-sport-sortie-double",
        "silencieux-sport-valves-commande-par-interrupteur-sortie-double"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-200cc-2-7l-3-2l",
          "title": "Catalyseurs 200cc 2,7L & 3,2L - Porsche Boxster (986)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-200cc-pour-porsche-986-2-5l",
          "title": "Catalyseurs 200CC - 2.5L - Porsche Boxster (986)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-by-pass-porsche-986-2-7l-3-2l",
          "title": "Catalyseurs by-pass - 2,7L & 3.2L - Porsche Boxster (986)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-986",
          "title": "Filtre à air sport BMC - Porsche Boxster (986)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "inter-pse-996-986",
          "title": "Inter PSE 996/ - Porsche Boxster (986)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-collecteurs-inox-scart-pour-porsche-boxster-986",
          "title": "Paire de collecteurs Inox SCART - Porsche Boxster (986)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-sortie-double",
          "title": "Échappement sport + sortie double - Porsche Boxster (986)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-valves-commande-par-interrupteur-sortie-double",
          "title": "Silencieux sport à valves (commande par interrupteur) + sortie double - Porsche Boxster (986)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 8,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-sortie-double",
              "l": "Échappement sport + sortie double - Porsche Boxster (986)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-valves-commande-par-interrupteur-sortie-double",
              "l": "Silencieux sport à valves (commande par interrupteur) + sortie double - Porsche Boxster (986)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-200cc-2-7l-3-2l",
              "l": "Catalyseurs 200cc 2,7L & 3,2L - Porsche Boxster (986)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-200cc-pour-porsche-986-2-5l",
              "l": "Catalyseurs 200CC - 2.5L - Porsche Boxster (986)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-by-pass-porsche-986-2-7l-3-2l",
              "l": "Catalyseurs by-pass - 2,7L & 3.2L - Porsche Boxster (986)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "paire-de-collecteurs-inox-scart-pour-porsche-boxster-986",
              "l": "Paire de collecteurs Inox SCART - Porsche Boxster (986)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-986",
          "title": "Filtre à air sport BMC - Porsche Boxster (986)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "inter-pse-996-986",
          "title": "Inter PSE 996/ - Porsche Boxster (986)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "986",
        "Boxster 986"
      ]
    },
    "porsche-boxster-987-1": {
      "id": "porsche-boxster-987-1",
      "displayName": "Boxster / Cayman 987 phase 1",
      "shortName": "Boxster/Cayman 987.1",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "987",
      "generationId": "987-1",
      "generationLabel": "987.1 (2004-2008)",
      "period": "2004 - 2008",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-987-1",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-1.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": true,
      "activeProductHandles": [
        "barrette-3-touches-pse-porsche-997",
        "collecteurs-catalyseurs-sport-200cc",
        "echappement-a-valves-porsche-987",
        "echappement-sport-ultima-porsche-987",
        "filtre-air-sport-bmc-pour-987",
        "kit-barrette-4-touches-pse-porsche-997",
        "kit-de-suppression-de-coupure-pse-1",
        "sortie-double-biseaut-e-2x88-chrom-e",
        "sorties-double-black-c-ramique-grand-diam-tre-2x88",
        "y"
      ],
      "activeProducts": [
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-catalyseurs-sport-200cc",
          "title": "Collecteurs + catalyseurs sport 200cc - Porsche Boxster (987)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valves-porsche-987",
          "title": "Échappement à valves - Porsche Boxster (987)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-987",
          "title": "Échappement sport Ultima - Porsche Boxster (987)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "sortie-double-biseaut-e-2x88-chrom-e",
          "title": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
          "title": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "y",
          "title": "Y - Porsche Boxster (987 / 987-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 10,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-987",
              "l": "Échappement sport Ultima - Porsche Boxster (987)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valves-porsche-987",
              "l": "Échappement à valves - Porsche Boxster (987)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "mid",
          "n": "Le tube Y intermédiaire",
          "d": "Tube de liaison en Y équilibrant les flux entre les bancs de cylindres.",
          "rects": [
            [
              34,
              22,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "y",
              "l": "Y - Porsche Boxster (987 / 987-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-200cc",
              "l": "Collecteurs + catalyseurs sport 200cc - Porsche Boxster (987)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              40,
              6,
              20,
              12
            ]
          ],
          "products": [
            {
              "h": "sortie-double-biseaut-e-2x88-chrom-e",
              "l": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            },
            {
              "h": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
              "l": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        }
      ],
      "accessoriesCount": 4,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "987",
        "Boxster 987",
        "Boxster 987-1"
      ]
    },
    "porsche-boxster-987-2": {
      "id": "porsche-boxster-987-2",
      "displayName": "Boxster / Cayman 987 phase 2",
      "shortName": "Boxster/Cayman 987.2",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "987",
      "generationId": "987-2",
      "generationLabel": "987.2 (2009-2012)",
      "period": "2008 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-987-2",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-2.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": true,
      "activeProductHandles": [
        "collecteurs-catalyseurs-sport-porsche-987-2",
        "echappement-a-valves-porsche-987-2",
        "echappement-sport-ultima-porsche-987-2",
        "filtre-air-sport-bmc-pour-987",
        "kit-barrette-3-touches-porsche-987-2",
        "kit-barrette-4-touches-amortisseur-porsche-987-2",
        "kit-barrette-4-touches-sport-porsche-987-2",
        "kit-barrette-5-touches-amortisseur-porsche-987-2",
        "kit-barrette-5-touches-sport-porsche-987-2",
        "kit-barrette-6-touches-porsche-987-2",
        "kit-de-suppression-de-coupure-pse-1",
        "sortie-double-biseaut-e-2x88-chrom-e",
        "sorties-double-black-c-ramique-grand-diam-tre-2x88",
        "y"
      ],
      "activeProducts": [
        {
          "handle": "collecteurs-catalyseurs-sport-porsche-987-2",
          "title": "Collecteurs/Catalyseurs sport 200cc - 987-2 - Porsche Boxster (987-2)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valves-porsche-987-2",
          "title": "Échappement à valves - 987-2 - Porsche Boxster (987-2)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-987-2",
          "title": "Échappement sport Ultima - 987-2 - Porsche Boxster (987-2)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-3-touches-porsche-987-2",
          "title": "Kit Barrette 3 touches - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 4 touches Amortisseur - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-sport-porsche-987-2",
          "title": "Kit Barrette 4 touches sport - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-5-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 5 touches amortisseur - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-5-touches-sport-porsche-987-2",
          "title": "Kit Barrette 5 touches sport - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-6-touches-porsche-987-2",
          "title": "Kit Barrette 6 touches - 987-2 - Porsche Boxster (987-2)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "sortie-double-biseaut-e-2x88-chrom-e",
          "title": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
          "title": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "y",
          "title": "Y - Porsche Boxster (987 / 987-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 14,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-987-2",
              "l": "Échappement sport Ultima - 987-2 - Porsche Boxster (987-2)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valves-porsche-987-2",
              "l": "Échappement à valves - 987-2 - Porsche Boxster (987-2)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "mid",
          "n": "Le tube Y intermédiaire",
          "d": "Tube de liaison en Y équilibrant les flux entre les bancs de cylindres.",
          "rects": [
            [
              34,
              22,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "y",
              "l": "Y - Porsche Boxster (987 / 987-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-porsche-987-2",
              "l": "Collecteurs/Catalyseurs sport 200cc - 987-2 - Porsche Boxster (987-2)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              40,
              6,
              20,
              12
            ]
          ],
          "products": [
            {
              "h": "sortie-double-biseaut-e-2x88-chrom-e",
              "l": "Sortie double biseautée - 2X88 Chromée - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            },
            {
              "h": "sorties-double-black-c-ramique-grand-diam-tre-2x88",
              "l": "Sorties double black céramique grand diamètre (2X88) - Porsche Boxster (987 / 987-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-987",
          "title": "Filtre à air sport BMC - Porsche Boxster (987 / 987-2)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-barrette-3-touches-porsche-987-2",
          "title": "Kit Barrette 3 touches - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-4-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 4 touches Amortisseur - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-4-touches-sport-porsche-987-2",
          "title": "Kit Barrette 4 touches sport - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-5-touches-amortisseur-porsche-987-2",
          "title": "Kit Barrette 5 touches amortisseur - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-5-touches-sport-porsche-987-2",
          "title": "Kit Barrette 5 touches sport - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-barrette-6-touches-porsche-987-2",
          "title": "Kit Barrette 6 touches - 987-2 - Porsche Boxster (987-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse-1",
          "title": "Kit de suppression de coupure PSE - Porsche Boxster (987 / 987-2)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        }
      ],
      "accessoriesCount": 8,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "987-2",
        "Boxster 987-2"
      ]
    },
    "porsche-boxster-981": {
      "id": "porsche-boxster-981",
      "displayName": "Boxster / Cayman 981",
      "shortName": "Boxster/Cayman 981",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "981",
      "generationId": "981",
      "generationLabel": "981 (2012-2016)",
      "period": "2012 - 2016",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-boxster-981",
      "drawingAsset": "scart-undercarriage-porsche-boxster-981.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-porsche-981",
        "filtres-air-sport-bmc-pour-981",
        "paire-de-collecteurs-catalyseurs-sport-200cc",
        "platine-pse-avec-raccord-scart",
        "sport-ultima-r-cital"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-porsche-981",
          "title": "Échappement à valves - Porsche Boxster (981)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtres-air-sport-bmc-pour-981",
          "title": "Filtres à air sport BMC - Porsche Boxster (981)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-collecteurs-catalyseurs-sport-200cc",
          "title": "Paire de collecteurs catalyseurs sport 200cc - Porsche Boxster (981)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sport-ultima-r-cital",
          "title": "Sport - Ultima Récital - Porsche Boxster (981)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 5,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "sport-ultima-r-cital",
              "l": "Sport - Ultima Récital - Porsche Boxster (981)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-a-valves-porsche-981",
              "l": "Échappement à valves - Porsche Boxster (981)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "paire-de-collecteurs-catalyseurs-sport-200cc",
              "l": "Paire de collecteurs catalyseurs sport 200cc - Porsche Boxster (981)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtres-air-sport-bmc-pour-981",
          "title": "Filtres à air sport BMC - Porsche Boxster (981)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "category": "bracket",
          "description": "Platine support PSE avec raccord spécifique SCART."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "981",
        "Boxster 981"
      ]
    },
    "porsche-718-4-0": {
      "id": "porsche-718-4-0",
      "displayName": "718 Spyder / Cayman GT4 4.0",
      "shortName": "718 4.0 L (Spyder/GT4)",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "718",
      "generationId": "718",
      "generationLabel": "718 (2016+)",
      "period": "2019 - 2024",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-718-4-0",
      "drawingAsset": "scart-undercarriage-porsche-718-4-0.webp",
      "logoKey": "porsche-718-spyder",
      "logoAsset": "scart-logo-porsche-718-spyder.svg",
      "logoTitle": "718 Spyder",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catback-ca-sent-la-poudre",
        "filtre-air-sport-bmc-pour-718",
        "xp"
      ],
      "activeProducts": [
        {
          "handle": "catback-ca-sent-la-poudre",
          "title": "Échappement sport à valves - Porsche Boxster 718 Spyder et GT4",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-718",
          "title": "Filtre à air sport BMC - Porsche Boxster (718)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "xp",
          "title": "X - Pipe - Porsche Boxster (718 4.0L)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux latéraux enveloppant le train arrière pour sculpter le timbre.",
          "rects": [
            [
              10,
              18,
              16,
              26
            ],
            [
              74,
              18,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "catback-ca-sent-la-poudre",
              "l": "Échappement sport à valves - Porsche Boxster 718 Spyder et GT4",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le X-Pipe intermédiaire",
          "d": "Liaison intermédiaire en X optimisant l’équilibre et la résonance des flux.",
          "rects": [
            [
              34,
              24,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "xp",
              "l": "X - Pipe - Porsche Boxster (718 4.0L)",
              "type": "Tube"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-718",
          "title": "Filtre à air sport BMC - Porsche Boxster (718)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le libellé `718` seul ne porte qu'un filtre à air BMC ; les deux produits d'échappement visent le 4.0 L atmosphérique (Spyder / GT4). Les 718 quatre cylindres turbo n'ont aucun échappement SCART : la famille visuelle est celle du 4.0 L.",
      "anomalies": [],
      "aliases": [
        "718 4.0L",
        "718",
        "Boxster 718",
        "Cayman 718"
      ]
    },
    "porsche-718-gt4-rs": {
      "id": "porsche-718-gt4-rs",
      "displayName": "718 Cayman GT4 RS",
      "shortName": "718 Cayman GT4 RS",
      "brand": "Porsche",
      "model": "Boxster / Cayman",
      "modelId": "boxster-cayman",
      "generation": "718",
      "generationId": "718",
      "generationLabel": "718 (2016+)",
      "period": "2022 - 2024",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-718-gt4-rs",
      "drawingAsset": "scart-undercarriage-porsche-718-gt4-rs.webp",
      "logoKey": "porsche-718-gt4-rs",
      "logoAsset": "scart-logo-porsche-718-gt4-rs.svg",
      "logoTitle": "GT4 RS",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "x-pipe-porsche-718-gt4-rs"
      ],
      "activeProducts": [
        {
          "handle": "x-pipe-porsche-718-gt4-rs",
          "title": "X - pipe - Porsche Boxster (718 GT4 RS)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "mid",
          "n": "Le X-Pipe intermédiaire",
          "d": "Liaison intermédiaire en X optimisant l’équilibre et la résonance des flux.",
          "rects": [
            [
              34,
              24,
              32,
              16
            ]
          ],
          "products": [
            {
              "h": "x-pipe-porsche-718-gt4-rs",
              "l": "X - pipe - Porsche Boxster (718 GT4 RS)",
              "type": "Tube"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet (carte compat PDP vide). Ligne d'origine différente du GT4 4.0 (silencieux central, sorties), famille séparée.",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "718 GT4 RS"
      ]
    },
    "porsche-911-996-carrera": {
      "id": "porsche-911-996-carrera",
      "displayName": "911 Carrera (996) 3.4 / 3.6",
      "shortName": "911 Carrera (996)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "996",
      "generationId": "996",
      "generationLabel": "996 (1997-2005)",
      "period": "1997 - 2005",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-996-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-996-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-sport-200cc-996-3-4l",
        "catalyseurs-sport-200cc-996-3-6l",
        "collier-silencieux-sortie",
        "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
        "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
        "filtre-air-sport-bmc-pour-996",
        "inter-pse-996-987",
        "manchon-catalyseur-porsche-996",
        "manchon-catalyseur-silencieux",
        "silencieux-avec-valves-996-3-4l-commande-par-interrupteur",
        "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
        "sorties-double-chrom-e-pour-996-4s"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-sport-200cc-996-3-4l",
          "title": "Catalyseurs sport 200cc - 3,4L - Porsche 911 (996)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-200cc-996-3-6l",
          "title": "Catalyseurs sport 200cc - 3,6L - Porsche 911 (996)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collier-silencieux-sortie",
          "title": "Collier Silencieux > Sortie - Porsche 911 (996)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
          "title": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
          "title": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-996",
          "title": "Filtre à air sport BMC - Porsche 911 (996)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "inter-pse-996-987",
          "title": "Inter PSE /986 - Porsche 911 (996)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-avec-valves-996-3-4l-commande-par-interrupteur",
          "title": "Échappement à valves - 3,4L - Porsche 911 (996)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
          "title": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-chrom-e-pour-996-4s",
          "title": "Sorties double chromée pour 4S - Porsche 911 (996)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 12,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux gauche et droit conférant la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
              "l": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 1,
              "g": "sound",
              "l_short": "Sonorité douce"
            },
            {
              "h": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
              "l": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-avec-valves-996-3-4l-commande-par-interrupteur",
              "l": "Échappement à valves - 3,4L - Porsche 911 (996)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
              "l": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport-200cc-996-3-4l",
              "l": "Catalyseurs sport 200cc - 3,4L - Porsche 911 (996)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-sport-200cc-996-3-6l",
              "l": "Catalyseurs sport 200cc - 3,6L - Porsche 911 (996)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-double-chrom-e-pour-996-4s",
              "l": "Sorties double chromée pour 4S - Porsche 911 (996)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "collier-silencieux-sortie",
          "title": "Collier Silencieux > Sortie - Porsche 911 (996)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-996",
          "title": "Filtre à air sport BMC - Porsche 911 (996)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "inter-pse-996-987",
          "title": "Inter PSE /986 - Porsche 911 (996)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        }
      ],
      "accessoriesCount": 5,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Split 3,4 L / 3,6 L uniquement sur les catalyseurs et les valves ; même dessous.",
      "anomalies": [],
      "aliases": [
        "996"
      ]
    },
    "porsche-911-996-gt3": {
      "id": "porsche-911-996-gt3",
      "displayName": "911 GT3 (996)",
      "shortName": "911 GT3 (996)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "996",
      "generationId": "996",
      "generationLabel": "996 (1997-2005)",
      "period": "1999 - 2005",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-996-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-996-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-sport-200-cellules-pour-996-gt3-phase-1",
        "catalyseurs-sport-200-cellules-pour-996-gt3-phase-2",
        "collecteurs-inox-brides-forg-es",
        "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
        "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
        "filtre-air-sport-pour-996-gt3",
        "manchon-catalyseur-porsche-996",
        "silencieux-avec-valves-996-3-6l-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-1",
          "title": "Catalyseurs sport (200 cellules) pour phase 1 - Porsche 911 (996 GT3)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-2",
          "title": "Catalyseurs sport (200 cellules) pour phase 2 - Porsche 911 (996 GT3)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-inox-brides-forg-es",
          "title": "Collecteurs Inox - brides forgées - Porsche 911 (996 GT3)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
          "title": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
          "title": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-pour-996-gt3",
          "title": "Filtre à air sport - Porsche 911 (996 GT3)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
          "title": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 8,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux gauche et droit conférant la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3",
              "l": "Échappement sport sonorité douce - 3.4L et 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 1,
              "g": "sound",
              "l_short": "Sonorité douce"
            },
            {
              "h": "echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3",
              "l": "Échappement sport Ultima récital - 3.4L 3.6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-avec-valves-996-3-6l-commande-par-interrupteur",
              "l": "Échappement à valves - 3,6L - Porsche 911 (996 / 996 GT3)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-1",
              "l": "Catalyseurs sport (200 cellules) pour phase 1 - Porsche 911 (996 GT3)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-sport-200-cellules-pour-996-gt3-phase-2",
              "l": "Catalyseurs sport (200 cellules) pour phase 2 - Porsche 911 (996 GT3)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-inox-brides-forg-es",
              "l": "Collecteurs Inox - brides forgées - Porsche 911 (996 GT3)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-pour-996-gt3",
          "title": "Filtre à air sport - Porsche 911 (996 GT3)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "manchon-catalyseur-porsche-996",
          "title": "Paire de manchons catalyseurs - Porsche 911 (996 / 996 GT3)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        }
      ],
      "accessoriesCount": 2,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "996 GT3"
      ]
    },
    "porsche-911-996-turbo": {
      "id": "porsche-911-996-turbo",
      "displayName": "911 Turbo (996)",
      "shortName": "911 Turbo (996)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "996",
      "generationId": "996",
      "generationLabel": "996 (1997-2005)",
      "period": "2000 - 2005",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-996-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-996-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-200-cellules-silencieux",
        "collecteurs-sport-brides-forg-es",
        "echappement-sport-interrupteur",
        "filtre-air-sport-bmc-pour-996-turbo"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-200-cellules-silencieux",
          "title": "Catalyseurs 200 cellules + Échappement sport - Porsche 911 (996 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-sport-brides-forg-es",
          "title": "Collecteurs inox sport - Porsche 911 (996 Turbo)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-interrupteur",
          "title": "Échappement à valves - Porsche 911 (996 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-996-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (996 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "L’échappement central",
          "d": "L’échappement central détermine la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "catalyseurs-200-cellules-silencieux",
              "l": "Catalyseurs 200 cellules + Échappement sport - Porsche 911 (996 Turbo)",
              "type": "Catalyseur",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-interrupteur",
              "l": "Échappement à valves - Porsche 911 (996 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-sport-brides-forg-es",
              "l": "Collecteurs inox sport - Porsche 911 (996 Turbo)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-996-turbo",
          "title": "Filtre à air sport BMC - Porsche 911 (996 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "996 Turbo"
      ]
    },
    "porsche-911-997-1-carrera": {
      "id": "porsche-911-997-1-carrera",
      "displayName": "911 Carrera (997.1), PSE, Sport Classic",
      "shortName": "911 Carrera (997.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-1",
      "generationLabel": "997.1 (2004-2008)",
      "period": "2004 - 2008",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-1-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": true,
      "activeProductHandles": [
        "3-6l-valves-interrupteur",
        "3-8l-valves-interrupteur",
        "barrette-3-touches-pse-porsche-997",
        "catalyseurs-sport-200-cellules-pour-porsche-997",
        "catalyseurs-standard-300cc",
        "collecteurs-sport-pour-997",
        "filtre-air-sport-bmc-pour-997",
        "kit-barrette-4-touches-pse-porsche-997",
        "kit-de-suppression-de-coupure-pse",
        "manchon-catalyseur-silencieux",
        "paire-de-silencieux-pse",
        "paire-de-sorties-double-2x88-bross-e",
        "paire-de-sorties-double-2x88-chrom-e",
        "paire-de-sorties-double-2x88-noire",
        "silencieux-sport-classic",
        "silencieux-sport-ultima-r-cital",
        "valves-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "3-6l-valves-interrupteur",
          "title": "Échappement à valves - 3.6L - Porsche 911 (997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "3-8l-valves-interrupteur",
          "title": "Échappement à valves - 3.8L - Porsche 911 (997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-200-cellules-pour-porsche-997",
          "title": "Catalyseurs sport (200 cellules) - Porsche 911 (997)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-standard-300cc",
          "title": "Catalyseurs standard 300cc - Porsche 911 (997)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-sport-pour-997",
          "title": "Collecteurs sport pour - Porsche 911 (997)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997",
          "title": "Filtre à air sport BMC - Porsche 911 (997)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-silencieux-pse",
          "title": "Échappement sport à valves - équipée du - Porsche 911 (997 PSE / 997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-bross-e",
          "title": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-chrom-e",
          "title": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-noire",
          "title": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-classic",
          "title": "Silencieux sport Classic - Porsche 911 (997)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-ultima-r-cital",
          "title": "Silencieux sport Ultima Récital - Porsche 911 (997)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "valves-interrupteur",
          "title": "Échappement à valves - sport classic/Speedster - Porsche 911 (997)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 17,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux",
          "d": "Silencieux gauche et droit conférant la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-classic",
              "l": "Silencieux sport Classic - Porsche 911 (997)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-ultima-r-cital",
              "l": "Silencieux sport Ultima Récital - Porsche 911 (997)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "3-6l-valves-interrupteur",
              "l": "Échappement à valves - 3.6L - Porsche 911 (997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "3-8l-valves-interrupteur",
              "l": "Échappement à valves - 3.8L - Porsche 911 (997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "paire-de-silencieux-pse",
              "l": "Échappement sport à valves - équipée du - Porsche 911 (997 PSE / 997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "valves-interrupteur",
              "l": "Échappement à valves - sport classic/Speedster - Porsche 911 (997)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport-200-cellules-pour-porsche-997",
              "l": "Catalyseurs sport (200 cellules) - Porsche 911 (997)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-standard-300cc",
              "l": "Catalyseurs standard 300cc - Porsche 911 (997)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-sport-pour-997",
              "l": "Collecteurs sport pour - Porsche 911 (997)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "paire-de-sorties-double-2x88-bross-e",
              "l": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-chrom-e",
              "l": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-noire",
              "l": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches-pse-porsche-997",
          "title": "Barrette 3 touches PSE - Porsche 911 (997 / 987)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997",
          "title": "Filtre à air sport BMC - Porsche 911 (997)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-barrette-4-touches-pse-porsche-997",
          "title": "Kit barrette 4 touches PSE - Porsche 911 (997) et Boxster (987-1)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        },
        {
          "handle": "manchon-catalyseur-silencieux",
          "title": "Manchon catalyseur > silencieux - Porsche 911 (996 / 997)",
          "category": "hardware",
          "description": "Visserie, colliers inox et bagues d’étanchéité pour montage étanche et durable."
        }
      ],
      "accessoriesCount": 5,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "PSE et Sport Classic / Speedster : mêmes positions de zones, silencieux d'origine différents. Un seul dessin, branches produit distinctes (même décision que la 997.2).",
      "anomalies": [],
      "aliases": [
        "997",
        "997 PSE"
      ]
    },
    "porsche-911-997-1-gt3": {
      "id": "porsche-911-997-1-gt3",
      "displayName": "911 GT3 (997.1)",
      "shortName": "911 GT3 (997.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-1",
      "generationLabel": "997.1 (2004-2008)",
      "period": "2006 - 2008",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-1-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              26,
              22,
              48,
              21
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997 GT3"
      ]
    },
    "porsche-911-997-1-turbo": {
      "id": "porsche-911-997-1-turbo",
      "displayName": "911 Turbo (997.1)",
      "shortName": "911 Turbo (997.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-1",
      "generationLabel": "997.1 (2004-2008)",
      "period": "2006 - 2008",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-1-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "collecteurs-avec-brides-en-inox-forg-diam-45",
        "echappement-sport-a-valves-porsche-997-turbo",
        "echappements-sport-catalyseurs-silencieux",
        "filtre-air-sport-pour-997-turbo-1"
      ],
      "activeProducts": [
        {
          "handle": "collecteurs-avec-brides-en-inox-forg-diam-45",
          "title": "Collecteurs avec brides en Inox forgé (Diam 45) - Porsche 911 (997 Turbo)",
          "type": "Collecteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valves-porsche-997-turbo",
          "title": "Échappement sport à valves - Porsche 911 (997 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-catalyseurs-silencieux",
          "title": "Échappements sport (Catalyseurs + silencieux) - Porsche 911 (997 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-pour-997-turbo-1",
          "title": "Filtre à air sport pour 1 - Porsche 911 (997 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "L’échappement central",
          "d": "L’échappement central détermine la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappements-sport-catalyseurs-silencieux",
              "l": "Échappements sport (Catalyseurs + silencieux) - Porsche 911 (997 Turbo)",
              "type": "Ligne complète",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-997-turbo",
              "l": "Échappement sport à valves - Porsche 911 (997 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "headers",
          "n": "Les collecteurs d’échappement",
          "d": "Tubulures inox primaires équilibrées pour optimiser la vidange des cylindres.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-avec-brides-en-inox-forg-diam-45",
              "l": "Collecteurs avec brides en Inox forgé (Diam 45) - Porsche 911 (997 Turbo)",
              "type": "Collecteur",
              "is_cat": false
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-pour-997-turbo-1",
          "title": "Filtre à air sport pour 1 - Porsche 911 (997 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997 Turbo"
      ]
    },
    "porsche-911-997-2-carrera": {
      "id": "porsche-911-997-2-carrera",
      "displayName": "911 Carrera (997.2) sans PSE",
      "shortName": "911 Carrera 997.2 (sans PSE)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2008 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": true,
      "activeProductHandles": [
        "barrette-3-touches",
        "barrette-4-touches-amortisseurs",
        "barrette-4-touches-sport",
        "barrette-5-touches-amortisseurs",
        "barrette-5-touches-sport",
        "barrette-6-touches",
        "collecteurs-catalyseurs-sport-200-cc",
        "echappement-central-a-valves-porsche-997-2-3-6l",
        "echappement-central-a-valves-porsche-997-2-3-8l",
        "filtres-air-sport-bmc-pour-997-2",
        "kit-de-suppression-de-coupure-pse",
        "kit-interrupteur-pse-5-touches",
        "paire-de-sorties-double-2x88-bross-e",
        "paire-de-sorties-double-2x88-chrom-e",
        "paire-de-sorties-double-2x88-noire",
        "r-paration-fiabilisation-silencieux",
        "x-pipe-central"
      ],
      "activeProducts": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-catalyseurs-sport-200-cc",
          "title": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-central-a-valves-porsche-997-2-3-6l",
          "title": "Échappement central à valves - 997-2 3.6L - Porsche 911 (997-2)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-central-a-valves-porsche-997-2-3-8l",
          "title": "Échappement central à valves - 997-2 3.8L - Porsche 911 (997-2)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtres-air-sport-bmc-pour-997-2",
          "title": "Filtres à air sport BMC pour 997-2 - Porsche 911 (997-2)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": true
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-bross-e",
          "title": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-chrom-e",
          "title": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-double-2x88-noire",
          "title": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "r-paration-fiabilisation-silencieux",
          "title": "Réparation / Fiabilisation silencieux - Porsche 911 (997-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central",
          "title": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 17,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-a-valves-porsche-997-2-3-6l",
              "l": "Échappement central à valves - 997-2 3.6L - Porsche 911 (997-2)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-central-a-valves-porsche-997-2-3-8l",
              "l": "Échappement central à valves - 997-2 3.8L - Porsche 911 (997-2)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le X-Pipe central",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-central",
              "l": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-200-cc",
              "l": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "paire-de-sorties-double-2x88-bross-e",
              "l": "Paire de sorties double (2X88) brossée - Porsche 911 (997-2 / 997)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-chrom-e",
              "l": "Paire de sorties double (2X88) chromée - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-double-2x88-noire",
              "l": "Paire de sorties double (2X88) noire - Porsche 911 (997 / 997-2)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtres-air-sport-bmc-pour-997-2",
          "title": "Filtres à air sport BMC pour 997-2 - Porsche 911 (997-2)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-de-suppression-de-coupure-pse",
          "title": "Kit de suppression de coupure PSE - Porsche 911 (997-2 / 997)",
          "category": "pse",
          "description": "Boîtier électronique de maintien des valves 100 % ouvertes en continu (suppression de coupure)."
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "r-paration-fiabilisation-silencieux",
          "title": "Réparation / Fiabilisation silencieux - Porsche 911 (997-2)",
          "category": "service",
          "description": "Prestation d’atelier de rénovation et fiabilisation des silencieux d’origine."
        }
      ],
      "accessoriesCount": 10,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997-2",
        "997-2 avec PSE"
      ]
    },
    "porsche-911-997-2-carrera-pse": {
      "id": "porsche-911-997-2-carrera-pse",
      "displayName": "911 Carrera (997.2) avec PSE",
      "shortName": "911 Carrera 997.2 (avec PSE)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2008 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-carrera.webp",
      "logoKey": "porsche-pse",
      "logoAsset": "scart-logo-porsche-carrera-pse.svg",
      "logoTitle": "Carrera + PSE",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "collecteurs-catalyseurs-sport-200-cc",
        "echappement-valves-3-6l-pse-interrupteur-on-off-inclus",
        "echappement-valves-3-8l-pour-997-2-quip-e-pse",
        "sorties-double-bross-es",
        "sorties-double-pse-noir-mat",
        "sorties-echappements-porsche-997-2-pse",
        "sorties-pse-double-chrom-e",
        "x-pipe-central"
      ],
      "activeProducts": [
        {
          "handle": "collecteurs-catalyseurs-sport-200-cc",
          "title": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-valves-3-6l-pse-interrupteur-on-off-inclus",
          "title": "Échappement à valves - 997-2 3,6L équipée - Porsche 911 (997-2 PSE)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-valves-3-8l-pour-997-2-quip-e-pse",
          "title": "Échappement à valves 3,8L - pour 997-2 équipée - Porsche 911 (997-2 PSE)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-bross-es",
          "title": "Sorties double brossées - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-double-pse-noir-mat",
          "title": "Sorties double noir mat - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-echappements-porsche-997-2-pse",
          "title": "Paire de sorties d'échappements - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-pse-double-chrom-e",
          "title": "Sorties double chromée - 997-2 - Porsche 911 (997-2 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central",
          "title": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 8,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-valves-3-6l-pse-interrupteur-on-off-inclus",
              "l": "Échappement à valves - 997-2 3,6L équipée - Porsche 911 (997-2 PSE)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-valves-3-8l-pour-997-2-quip-e-pse",
              "l": "Échappement à valves 3,8L - pour 997-2 équipée - Porsche 911 (997-2 PSE)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le X-Pipe central",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-central",
              "l": "X - pipe central - 997-2 - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              20,
              50,
              18,
              20
            ],
            [
              62,
              50,
              18,
              20
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport-200-cc",
              "l": "Collecteurs + catalyseurs sport 200 cc - Porsche 911 (997-2 / 997-2 PSE)",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-double-bross-es",
              "l": "Sorties double brossées - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            },
            {
              "h": "sorties-double-pse-noir-mat",
              "l": "Sorties double noir mat - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            },
            {
              "h": "sorties-echappements-porsche-997-2-pse",
              "l": "Paire de sorties d'échappements - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            },
            {
              "h": "sorties-pse-double-chrom-e",
              "l": "Sorties double chromée - 997-2 - Porsche 911 (997-2 PSE)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Décision Jérémie 04/09/2026 : réutilise le dessin C1 de la Carrera sans PSE ; branche produit distincte.",
      "anomalies": [],
      "aliases": [
        "997-2 PSE"
      ]
    },
    "porsche-911-997-2-gt3": {
      "id": "porsche-911-997-2-gt3",
      "displayName": "911 GT3 / GT3 RS (997.2)",
      "shortName": "911 GT3 / RS (997.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2009 - 2012",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "logoKey": "porsche-gt3-rs",
      "logoAsset": "scart-porsche-gt3-rs-wordmark.png",
      "logoTitle": "GT3 RS",
      "logoFormat": "png",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet contient les alias `997-2 GT3` et `997-2 GT2 RS` mais aucun alias `997-2 GT3 RS`. Ne pas corriger Shopify dans ce chantier.",
      "anomalies": [],
      "aliases": [
        "997-2 GT3"
      ]
    },
    "porsche-911-997-2-gt2-rs": {
      "id": "porsche-911-997-2-gt2-rs",
      "displayName": "911 GT2 RS (997.2)",
      "shortName": "911 GT2 RS (997.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2010 - 2011",
      "architecture": "Simple turbo",
      "description": "Architecture simple turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-gt2-rs",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt2-rs.webp",
      "logoKey": "porsche-gt2-rs",
      "logoAsset": "scart-porsche-gt2-rs-wordmark.png",
      "logoTitle": "GT2 RS",
      "logoFormat": "png",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappements-valves-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "echappements-valves-commande-par-interrupteur",
          "title": "Échappement à valves - 997-2 - Porsche 911 (997-2 GT2 RS)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappements-valves-commande-par-interrupteur",
              "l": "Échappement à valves - 997-2 - Porsche 911 (997-2 GT2 RS)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Rangée sous le métaobjet « 997-2 GT3 » (alias `997-2 GT2 RS`) alors que l'architecture est celle d'un Turbo : famille visuelle séparée, décision validée.",
      "anomalies": [],
      "aliases": [
        "997-2 GT2 RS"
      ]
    },
    "porsche-911-997-2-turbo": {
      "id": "porsche-911-997-2-turbo",
      "displayName": "911 Turbo / Turbo S (997.2)",
      "shortName": "911 Turbo (997.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "997",
      "generationId": "997-2",
      "generationLabel": "997.2 (2008-2012)",
      "period": "2010 - 2012",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-997-2-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "barrette-3-touches",
        "barrette-4-touches-amortisseurs",
        "barrette-4-touches-sport",
        "barrette-5-touches-amortisseurs",
        "barrette-5-touches-sport",
        "barrette-6-touches",
        "echappements-sport-valves-commande-par-interrupteur",
        "filtre-air-sport-bmc-pour-997-turbo-2",
        "kit-interrupteur-pse-5-touches",
        "sport-200-cc"
      ],
      "activeProducts": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-valves-commande-par-interrupteur",
          "title": "Échappement sport à valves - 997-2 /S - Porsche 911 (997-2 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997-turbo-2",
          "title": "Filtre à air sport BMC pour 997 2 - Porsche 911 (997-2 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sport-200-cc",
          "title": "Catalyseurs Sports 200 cc - 997.2 /S - Porsche 911 (997-2 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 10,
      "zones": [
        {
          "id": "muffler",
          "n": "L’échappement central",
          "d": "L’échappement central détermine la voix et le caractère acoustique.",
          "rects": [
            [
              9,
              22,
              16,
              26
            ],
            [
              75,
              22,
              16,
              26
            ]
          ],
          "products": [
            {
              "h": "echappements-sport-valves-commande-par-interrupteur",
              "l": "Échappement sport à valves - 997-2 /S - Porsche 911 (997-2 Turbo)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "sport-200-cc",
              "l": "Catalyseurs Sports 200 cc - 997.2 /S - Porsche 911 (997-2 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "barrette-3-touches",
          "title": "Barrette 3 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-amortisseurs",
          "title": "Barrette 4 touches amortisseurs - Porsche 911 (997-2 Turbo / 997-2)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-4-touches-sport",
          "title": "Barrette 4 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-amortisseurs",
          "title": "Barrette 5 touches Amortisseurs - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-5-touches-sport",
          "title": "Barrette 5 touches sport - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "barrette-6-touches",
          "title": "Barrette 6 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        },
        {
          "handle": "filtre-air-sport-bmc-pour-997-turbo-2",
          "title": "Filtre à air sport BMC pour 997 2 - Porsche 911 (997-2 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        },
        {
          "handle": "kit-interrupteur-pse-5-touches",
          "title": "Kit interrupteur PSE à 5 touches - Porsche 911 (997-2 / 997-2 Turbo)",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 8,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "997-2 Turbo"
      ]
    },
    "porsche-911-991-1-carrera": {
      "id": "porsche-911-991-1-carrera",
      "displayName": "911 Carrera (991.1)",
      "shortName": "911 Carrera (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2011 - 2015",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-1-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re-valves-commande-par-interrupteur",
        "echappement-sport-ultima-porsche-991",
        "platine-pse-avec-raccord-scart",
        "sortie-echappement-noires-porsche-991"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re-valves-commande-par-interrupteur",
          "title": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ultima-porsche-991",
          "title": "Échappement sport Ultima - Porsche 911 (991)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sortie-echappement-noires-porsche-991",
          "title": "Paire de sortie Black - Porsche 911 (991)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ultima-porsche-991",
              "l": "Échappement sport Ultima - Porsche 911 (991)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-central-arri-re-valves-commande-par-interrupteur",
              "l": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sortie-echappement-noires-porsche-991",
              "l": "Paire de sortie Black - Porsche 911 (991)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "category": "bracket",
          "description": "Platine support PSE avec raccord spécifique SCART."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991"
      ]
    },
    "porsche-911-991-1-carrera-pse": {
      "id": "porsche-911-991-1-carrera-pse",
      "displayName": "911 Carrera (991.1) avec PSE",
      "shortName": "911 Carrera (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2011 - 2015",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-1-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re-valves-commande-par-interrupteur",
        "paire-de-sortie-chrom",
        "paire-de-sorties-bross-es"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re-valves-commande-par-interrupteur",
          "title": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sortie-chrom",
          "title": "Paire de sortie Chromé - Porsche 911 (991 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-sorties-bross-es",
          "title": "Paire de sorties Brossées - Porsche 911 (991 PSE)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re-valves-commande-par-interrupteur",
              "l": "Échappement central arrière à valves - .1 - Porsche 911 (991 PSE / 991)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "paire-de-sortie-chrom",
              "l": "Paire de sortie Chromé - Porsche 911 (991 PSE)",
              "type": "Sortie"
            },
            {
              "h": "paire-de-sorties-bross-es",
              "l": "Paire de sorties Brossées - Porsche 911 (991 PSE)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Même architecture que la Carrera sans PSE ; le silencieux central à valves SCART est le même produit pour les deux. Dessin partagé, branche produit distincte.",
      "anomalies": [],
      "aliases": [
        "991 PSE"
      ]
    },
    "porsche-911-991-1-gt3": {
      "id": "porsche-911-991-1-gt3",
      "displayName": "911 GT3 (991.1)",
      "shortName": "911 GT3 (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2013 - 2015",
      "architecture": "Atmosphérique",
      "description": "Architecture atmosphérique et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991 GT3"
      ]
    },
    "porsche-911-991-1-turbo": {
      "id": "porsche-911-991-1-turbo",
      "displayName": "911 Turbo (991.1)",
      "shortName": "911 Turbo (991.1)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-1",
      "generationLabel": "991.1 (2011-2015)",
      "period": "2013 - 2015",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-1-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-valves-pour-991-turbo-phase-1-interrupteur",
        "filtre-air-sport-bmc-pour-991"
      ],
      "activeProducts": [
        {
          "handle": "echappement-valves-pour-991-turbo-phase-1-interrupteur",
          "title": "Échappement à valves - Porsche 911 (991 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "filtre-air-sport-bmc-pour-991",
          "title": "Filtre à air sport BMC - Porsche 911 (991 Turbo)",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-valves-pour-991-turbo-phase-1-interrupteur",
              "l": "Échappement à valves - Porsche 911 (991 Turbo)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-991",
          "title": "Filtre à air sport BMC - Porsche 911 (991 Turbo)",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991 Turbo"
      ]
    },
    "porsche-911-991-2-carrera": {
      "id": "porsche-911-991-2-carrera",
      "displayName": "911 Carrera (991.2)",
      "shortName": "911 Carrera (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2015 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "platine-pse-avec-raccord-scart",
        "x-pipe-pse",
        "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse"
      ],
      "activeProducts": [
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "type": "Pièce annexe",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-pse",
          "title": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
          "title": "Paire de catalyseurs sport 200cc SCART pour 991-2 - Porsche 911 (991-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "mid",
          "n": "Le tube intermédiaire",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-pse",
              "l": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Paire de catalyseurs sport 200 cellules pour la Carrera 991.2 sans PSE.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
              "l": "Paire de catalyseurs sport 200 cellules",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "platine-pse-avec-raccord-scart",
          "title": "Platine PSE avec raccord SCART - Porsche 911 (981 / 991 / 991-2)",
          "category": "bracket",
          "description": "Platine support PSE avec raccord spécifique SCART."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Alias `991-2` avec variantes d'espacement signalées dans la note de cartographie.",
      "anomalies": [],
      "aliases": [
        "991-2"
      ]
    },
    "porsche-911-991-2-carrera-pse": {
      "id": "porsche-911-991-2-carrera-pse",
      "displayName": "911 Carrera (991.2) avec PSE",
      "shortName": "911 Carrera (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2015 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-porsche-991-2-pse",
        "echappement-complet-valves",
        "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
        "x-pipe-pse"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-porsche-991-2-pse",
          "title": "Échappement à valves - 991-2 - Porsche 911 (991-2 PSE)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-complet-valves",
          "title": "Échappement complet à valves - Porsche 911 (991-2 PSE)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
          "title": "Paire de catalyseurs sport 200cc SCART pour 991-2 - Porsche 911 (991-2 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-pse",
          "title": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-porsche-991-2-pse",
              "l": "Échappement à valves - 991-2 - Porsche 911 (991-2 PSE)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-complet-valves",
              "l": "Échappement complet à valves - Porsche 911 (991-2 PSE)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Le tube intermédiaire",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-pse",
              "l": "X pipe - Porsche 911 (991-2 PSE / 991-2)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-catalyseurs-sport-200cc-scart-pour-porsche-991-2-pse",
              "l": "Paire de catalyseurs sport 200cc SCART pour 991-2 - Porsche 911 (991-2 PSE)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le X-pipe SCART est commun PSE / non-PSE ; mêmes positions. Dessin partagé, branche produit distincte.",
      "anomalies": [],
      "aliases": [
        "991-2 PSE"
      ]
    },
    "porsche-911-991-2-gt3": {
      "id": "porsche-911-991-2-gt3",
      "displayName": "911 GT3 (991.2)",
      "shortName": "911 GT3 (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2017 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-gt3",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-gt3.webp",
      "logoKey": "porsche-gt3",
      "logoAsset": "scart-porsche-gt3-wordmark.svg",
      "logoTitle": "GT3",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-central-arri-re"
      ],
      "activeProducts": [
        {
          "handle": "echappement-central-arri-re",
          "title": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux central arrière",
          "d": "Le silencieux central placé sous les deux sorties arrière de la GT3.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-central-arri-re",
              "l": "Échappement central arrière - / /RS - Porsche 911 (997 GT3 / 991 GT3 / 997-2 GT3 / 991-2 GT3)",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991-2 GT3"
      ]
    },
    "porsche-911-991-2-turbo": {
      "id": "porsche-911-991-2-turbo",
      "displayName": "911 Turbo (991.2)",
      "shortName": "911 Turbo (991.2)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "991",
      "generationId": "991-2",
      "generationLabel": "991.2 (2015-2019)",
      "period": "2016 - 2019",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-991-2-turbo",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "logoKey": "porsche-turbo",
      "logoAsset": "scart-porsche-turbo-wordmark.svg",
      "logoTitle": "Turbo",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-valves-pour-991-turbo-mk2-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "echappement-valves-pour-991-turbo-mk2-interrupteur",
          "title": "Échappement à valves pour 991 MK2 - Interrupteur - Porsche 911 (991-2 Turbo)",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "La pièce maîtresse sculptant le timbre et la voix du moteur.",
          "rects": [
            [
              22,
              16,
              56,
              22
            ]
          ],
          "products": [
            {
              "h": "echappement-valves-pour-991-turbo-mk2-interrupteur",
              "l": "Échappement à valves pour 991 MK2 - Interrupteur - Porsche 911 (991-2 Turbo)",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "991-2 Turbo"
      ]
    },
    "porsche-911-992-carrera": {
      "id": "porsche-911-992-carrera",
      "displayName": "911 Carrera (992), avec ou sans PSE",
      "shortName": "911 Carrera (992)",
      "brand": "Porsche",
      "model": "911",
      "modelId": "911",
      "generation": "992",
      "generationId": "992",
      "generationLabel": "992 (2019+)",
      "period": "2019 - aujourd'hui",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-911-992-carrera",
      "drawingAsset": "scart-undercarriage-porsche-911-992-carrera.webp",
      "logoKey": "porsche-carrera",
      "logoAsset": "scart-porsche-carrera-wordmark.svg",
      "logoTitle": "Carrera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "paire-de-calayseurs-sport-200cc",
        "x-pipe-central-porsche-992-pse",
        "x-pipe-central-porsche-992-sans-pse"
      ],
      "activeProducts": [
        {
          "handle": "paire-de-calayseurs-sport-200cc",
          "title": "Paire de Catalyseurs sport 200CC - Porsche 911 (992 / 992 PSE)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central-porsche-992-pse",
          "title": "X - pipe central - Porsche 911 (992 PSE)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "x-pipe-central-porsche-992-sans-pse",
          "title": "X - Pipe central - sans PSE - Porsche 911 (992)",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "mid",
          "n": "Le X-Pipe central",
          "d": "Section centrale optimisant le croisement des ondes acoustiques et le flux.",
          "rects": [
            [
              30,
              22,
              40,
              18
            ]
          ],
          "products": [
            {
              "h": "x-pipe-central-porsche-992-pse",
              "l": "X - pipe central - Porsche 911 (992 PSE)",
              "type": "Tube"
            },
            {
              "h": "x-pipe-central-porsche-992-sans-pse",
              "l": "X - Pipe central - sans PSE - Porsche 911 (992)",
              "type": "Tube"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport 100/200 cellules haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-calayseurs-sport-200cc",
              "l": "Paire de Catalyseurs sport 200CC - Porsche 911 (992 / 992 PSE)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Split PSE / non-PSE seulement pour le X-pipe central ; mêmes positions, un dessin.",
      "anomalies": [],
      "aliases": [
        "992",
        "992 PSE"
      ]
    },
    "porsche-cayenne-955-s": {
      "id": "porsche-cayenne-955-s",
      "displayName": "Cayenne S (955)",
      "shortName": "Cayenne S (955)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "955",
      "generationLabel": "Cayenne 955 (2002-2007)",
      "period": "2002 - 2007",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-955-s",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-s.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-955-s",
        "echappement-sport-a-valves-porsche-955-s",
        "echappement-sport-porsche-955-s"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-955-s",
          "title": "Catalyseurs by-pass - Porsche Cayenne (955 S)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valves-porsche-955-s",
          "title": "Échappement sport à valves - Porsche Cayenne (955 S)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-955-s",
          "title": "Échappement sport - Porsche Cayenne (955 S)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-955-s",
              "l": "Échappement sport - Porsche Cayenne (955 S)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-955-s",
              "l": "Échappement sport à valves - Porsche Cayenne (955 S)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-955-s",
              "l": "Catalyseurs by-pass - Porsche Cayenne (955 S)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "955 S",
        "955",
        "Cayenne 955"
      ]
    },
    "porsche-cayenne-955-turbo": {
      "id": "porsche-cayenne-955-turbo",
      "displayName": "Cayenne Turbo (955)",
      "shortName": "Cayenne Turbo (955)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "955",
      "generationLabel": "Cayenne 955 (2002-2007)",
      "period": "2002 - 2007",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-955-turbo",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-turbo.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-955-turbo",
        "echappements-sport-porsche-955-turbo",
        "silencieux-sport-avec-valves-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-955-turbo",
          "title": "Catalyseurs by-pass - Porsche Cayenne (955 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-porsche-955-turbo",
          "title": "Échappement sport - Porsche Cayenne (955 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valves-commande-par-interrupteur",
          "title": "Silencieux sport avec valves (commande par interrupteur) - Porsche Cayenne (955 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappements-sport-porsche-955-turbo",
              "l": "Échappement sport - Porsche Cayenne (955 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-avec-valves-commande-par-interrupteur",
              "l": "Silencieux sport avec valves (commande par interrupteur) - Porsche Cayenne (955 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-955-turbo",
              "l": "Catalyseurs by-pass - Porsche Cayenne (955 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Handles distincts S / Turbo pour by-pass et silencieux. Famille séparée tant que les photos n'ont pas prouvé que les zones vendues occupent la même position sur les deux moteurs.",
      "anomalies": [],
      "aliases": [
        "955 Turbo"
      ]
    },
    "porsche-cayenne-957-s": {
      "id": "porsche-cayenne-957-s",
      "displayName": "Cayenne S (957)",
      "shortName": "Cayenne S (957)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "957",
      "generationLabel": "Cayenne 957 (2007-2010)",
      "period": "2007 - 2010",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-957-s",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-s.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-957-s",
        "echappement-sport-a-valves-porsche-957-s",
        "echappement-sport-porsche-cayenne-957-s"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-957-s",
          "title": "Catalyseurs by-pass - Porsche Cayenne (957 S)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valves-porsche-957-s",
          "title": "Échappement sport à valves - Porsche Cayenne (957 S)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-cayenne-957-s",
          "title": "Échappement sport - Porsche Cayenne (957 S)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-cayenne-957-s",
              "l": "Échappement sport - Porsche Cayenne (957 S)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-957-s",
              "l": "Échappement sport à valves - Porsche Cayenne (957 S)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-957-s",
              "l": "Catalyseurs by-pass - Porsche Cayenne (957 S)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "957 S",
        "957",
        "Cayenne 957"
      ]
    },
    "porsche-cayenne-957-turbo": {
      "id": "porsche-cayenne-957-turbo",
      "displayName": "Cayenne Turbo (957)",
      "shortName": "Cayenne Turbo (957)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "957",
      "generationLabel": "Cayenne 957 (2007-2010)",
      "period": "2007 - 2010",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-957-turbo",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-turbo.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass-porsche-957-turbo",
        "echappement-sport-porsche-957-turbo",
        "echappements-a-valves-porsche-957"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass-porsche-957-turbo",
          "title": "Catalyseurs by-pass - Porsche Cayenne (957 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-957-turbo",
          "title": "Échappement sport - Porsche Cayenne (957 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-a-valves-porsche-957",
          "title": "Échappement à valves - Porsche Cayenne (957 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-957-turbo",
              "l": "Échappement sport - Porsche Cayenne (957 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappements-a-valves-porsche-957",
              "l": "Échappement à valves - Porsche Cayenne (957 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass-porsche-957-turbo",
              "l": "Catalyseurs by-pass - Porsche Cayenne (957 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Même règle que 955 : famille séparée jusqu'à preuve photo d'un dessous identique.",
      "anomalies": [],
      "aliases": [
        "957 Turbo"
      ]
    },
    "porsche-cayenne-958": {
      "id": "porsche-cayenne-958",
      "displayName": "Cayenne (958) atmosphérique",
      "shortName": "Cayenne 958 Atmo",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "958",
      "generationLabel": "Cayenne 958 (2010-2017)",
      "period": "2010 - 2017",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-958",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-by-pass-porsche-958",
        "echappement-sport-porsche-958",
        "echappements-sport-a-valves-porsche-958",
        "sorties-doubles-noires-peinture-c-ramique"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-by-pass-porsche-958",
          "title": "Catalyseurs by-pass - Porsche Cayenne (958)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-958",
          "title": "Échappement sport - Porsche Cayenne (958)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappements-sport-a-valves-porsche-958",
          "title": "Échappement sport à valves - Porsche Cayenne (958)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-doubles-noires-peinture-c-ramique",
          "title": "Sorties doubles noires peinture céramique - Porsche Cayenne (958)",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-958",
              "l": "Échappement sport - Porsche Cayenne (958)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappements-sport-a-valves-porsche-958",
              "l": "Échappement sport à valves - Porsche Cayenne (958)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseur-by-pass-porsche-958",
              "l": "Catalyseurs by-pass - Porsche Cayenne (958)",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              10,
              4,
              16,
              12
            ],
            [
              74,
              4,
              16,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-doubles-noires-peinture-c-ramique",
              "l": "Sorties doubles noires peinture céramique - Porsche Cayenne (958)",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "958",
        "Cayenne 958"
      ]
    },
    "porsche-cayenne-958-turbo": {
      "id": "porsche-cayenne-958-turbo",
      "displayName": "Cayenne Turbo (958)",
      "shortName": "Cayenne Turbo (958)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "958",
      "generationLabel": "Cayenne 958 (2010-2017)",
      "period": "2010 - 2017",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-958-turbo",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958-turbo.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-by-pass",
        "echappement-sport-porsche-958-turbo",
        "silencieux-sport-avec-valve-commande-par-interrupteur"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-by-pass",
          "title": "Catalyseurs by-pass - Porsche Cayenne (958 Turbo)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-porsche-958-turbo",
          "title": "Échappement sport - Porsche Cayenne (958 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-avec-valve-commande-par-interrupteur",
          "title": "Silencieux sport avec valve (commande par interrupteur) - Porsche Cayenne (958 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-porsche-958-turbo",
              "l": "Échappement sport - Porsche Cayenne (958 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-sport-avec-valve-commande-par-interrupteur",
              "l": "Silencieux sport avec valve (commande par interrupteur) - Porsche Cayenne (958 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": [
            "Proche de l’origine",
            "Plus libre / Racing"
          ],
          "journeyTitle": "La même pièce, plusieurs niveaux",
          "journeyHint": "La filtration change le caractère",
          "warning": "Les by-pass sont réservés à un usage sur circuit fermé.",
          "products": [
            {
              "h": "catalyseurs-by-pass",
              "l": "Catalyseurs by-pass - Porsche Cayenne (958 Turbo)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "958 Turbo"
      ]
    },
    "porsche-cayenne-9ya-v6": {
      "id": "porsche-cayenne-9ya-v6",
      "displayName": "Cayenne V6 (PO536 / 9YA)",
      "shortName": "Cayenne V6 (9YA)",
      "brand": "Porsche",
      "model": "Cayenne",
      "modelId": "cayenne",
      "generation": "Cayenne",
      "generationId": "9ya",
      "generationLabel": "Cayenne 9YA (2017+)",
      "period": "2017 - aujourd'hui",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-cayenne-9ya-v6",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-9ya-v6.webp",
      "logoKey": "porsche-cayenne",
      "logoAsset": "scart-logo-porsche-cayenne.svg",
      "logoTitle": "Cayenne",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseur-sport-200cc",
        "catalyseurs-sport-porsche-cayenne-p0536-v6",
        "echappement-a-valve-porsche-cayenne-p0536"
      ],
      "activeProducts": [
        {
          "handle": "catalyseur-sport-200cc",
          "title": "Catalyseur sport 200CC - Porsche Cayenne (PO536)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "catalyseurs-sport-porsche-cayenne-p0536-v6",
          "title": "Catalyseurs sport - V6 - Porsche Cayenne (V6)",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-a-valve-porsche-cayenne-p0536",
          "title": "Échappement à valves - V6 - Porsche Cayenne (V6)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valve-porsche-cayenne-p0536",
              "l": "Échappement à valves - V6 - Porsche Cayenne (V6)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs by-pass",
          "d": "Tubes by-pass secondaires libérant la sonorité du moteur V8.",
          "rects": [
            [
              26,
              46,
              16,
              22
            ],
            [
              58,
              46,
              16,
              22
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseur-sport-200cc",
              "l": "Catalyseur sport 200CC - Porsche Cayenne (PO536)",
              "type": "Catalyseur"
            },
            {
              "h": "catalyseurs-sport-porsche-cayenne-p0536-v6",
              "l": "Catalyseurs sport - V6 - Porsche Cayenne (V6)",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Alias `P0536` (zéro) et `PO536` (lettre O) coexistent.",
      "anomalies": [],
      "aliases": [
        "P0536",
        "PO536"
      ]
    },
    "porsche-panamera-970": {
      "id": "porsche-panamera-970",
      "displayName": "Panamera (970) hors Turbo",
      "shortName": "Panamera 970",
      "brand": "Porsche",
      "model": "Panamera",
      "modelId": "panamera",
      "generation": "Panamera",
      "generationId": "970",
      "generationLabel": "Panamera 970 (2009-2016)",
      "period": "2009 - 2016",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-panamera-970",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970.webp",
      "logoKey": "porsche-panamera",
      "logoAsset": "scart-logo-porsche-panamera.svg",
      "logoTitle": "Panamera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "filtre-air-sport-bmc-pour-panamera",
        "paire-de-tubes-interm-daires",
        "silencieux-sport-valves",
        "tubes-interm-diaires"
      ],
      "activeProducts": [
        {
          "handle": "filtre-air-sport-bmc-pour-panamera",
          "title": "Filtre à air sport BMC - Porsche Panamera",
          "type": "Filtre à air",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-tubes-interm-daires",
          "title": "Paire de tubes intermédiaires - Porsche Panamera",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-valves",
          "title": "Silencieux sport à valves - Porsche Panamera (970)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "tubes-interm-diaires",
          "title": "Tubes intermédiaires - Porsche Panamera",
          "type": "Tube",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 4,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-valves",
              "l": "Silencieux sport à valves - Porsche Panamera (970)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "mid",
          "n": "Les tubes intermédiaires",
          "d": "Tubes intermédiaires de liaison reliant les catalyseurs aux silencieux arrière.",
          "rects": [
            [
              34,
              34,
              32,
              28
            ]
          ],
          "products": [
            {
              "h": "paire-de-tubes-interm-daires",
              "l": "Paire de tubes intermédiaires - Porsche Panamera",
              "type": "Tube"
            },
            {
              "h": "tubes-interm-diaires",
              "l": "Tubes intermédiaires - Porsche Panamera",
              "type": "Tube"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "filtre-air-sport-bmc-pour-panamera",
          "title": "Filtre à air sport BMC - Porsche Panamera",
          "category": "filter",
          "description": "Filtration haute performance BMC en coton huilé lavable, optimisant le débit d’air d’admission."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Statut no-go dans la cartographie : deux fiches de tubes intermédiaires semblent décrire la même paire, moteurs compatibles non confirmés. La source visuelle est recherchée quand même.",
      "anomalies": [],
      "aliases": [
        "Panamera",
        "panamera",
        "970"
      ]
    },
    "porsche-panamera-970-turbo": {
      "id": "porsche-panamera-970-turbo",
      "displayName": "Panamera Turbo (970)",
      "shortName": "Panamera Turbo 970",
      "brand": "Porsche",
      "model": "Panamera",
      "modelId": "panamera",
      "generation": "Panamera",
      "generationId": "970",
      "generationLabel": "Panamera 970 (2009-2016)",
      "period": "2009 - 2016",
      "architecture": "Bi-turbo",
      "description": "Architecture bi-turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "porsche-panamera-970-turbo",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970-turbo.webp",
      "logoKey": "porsche-panamera",
      "logoAsset": "scart-logo-porsche-panamera.svg",
      "logoTitle": "Panamera",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-a-valves-porsche-panamera-970-turbo",
        "silencieux-sport-panamera-970-turbo"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-a-valves-porsche-panamera-970-turbo",
          "title": "Échappement sport à valves - Porsche Panamera (970 Turbo)",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-sport-panamera-970-turbo",
          "title": "Silencieux sport - Porsche Panamera (970 Turbo)",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-panamera-970-turbo",
              "l": "Silencieux sport - Porsche Panamera (970 Turbo)",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "echappement-sport-a-valves-porsche-panamera-970-turbo",
              "l": "Échappement sport à valves - Porsche Panamera (970 Turbo)",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "970 Turbo",
        "Panamera 970 Turbo"
      ]
    },
    "ferrari-f430": {
      "id": "ferrari-f430",
      "displayName": "Ferrari F430",
      "shortName": "Ferrari F430",
      "brand": "Ferrari",
      "model": "F430",
      "modelId": "f430",
      "generation": "F430",
      "generationId": "f430",
      "generationLabel": "F430 (2004-2009)",
      "period": "2004 - 2009",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-f430",
      "drawingAsset": "scart-undercarriage-ferrari-f430.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "catalyseurs-sport",
        "collecteurs-catalyseurs-sport",
        "echappement-sport-ferrari-f430",
        "silencieux-racing",
        "silencieux-valves"
      ],
      "activeProducts": [
        {
          "handle": "catalyseurs-sport",
          "title": "Catalyseurs sport - Ferrari F430",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "collecteurs-catalyseurs-sport",
          "title": "Collecteurs catalyseurs sport - Ferrari F430",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-ferrari-f430",
          "title": "Échappement sport - Ferrari F430",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-racing",
          "title": "Silencieux Racing - Ferrari F430",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves",
          "title": "Silencieux à valves - Ferrari F430",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 5,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ferrari-f430",
              "l": "Échappement sport - Ferrari F430",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-racing",
              "l": "Silencieux Racing - Ferrari F430",
              "type": "Silencieux",
              "s": 5,
              "g": "sound",
              "l_short": "Racing / Ultima"
            },
            {
              "h": "silencieux-valves",
              "l": "Silencieux à valves - Ferrari F430",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité civilisée",
            "Sonorité très expressive"
          ],
          "journeyTitle": "La même pièce, plusieurs sonorités",
          "journeyHint": "La forme fait le son"
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport",
          "d": "Catalyseurs sport haute perméabilité ou tubes by-pass.",
          "rects": [
            [
              22,
              38,
              16,
              20
            ],
            [
              62,
              38,
              16,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "catalyseurs-sport",
              "l": "Catalyseurs sport - Ferrari F430",
              "type": "Catalyseur"
            }
          ]
        },
        {
          "id": "headers",
          "n": "Les collecteurs & catalyseurs sport",
          "d": "Collecteurs primaires inox intégrant les catalyseurs sport 200 cellules.",
          "rects": [
            [
              18,
              48,
              18,
              22
            ],
            [
              64,
              48,
              18,
              22
            ]
          ],
          "products": [
            {
              "h": "collecteurs-catalyseurs-sport",
              "l": "Collecteurs catalyseurs sport - Ferrari F430",
              "type": "Catalyseur",
              "is_cat": true
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "F430"
      ]
    },
    "ferrari-456": {
      "id": "ferrari-456",
      "displayName": "Ferrari 456 / 456 M",
      "shortName": "Ferrari 456 / 456 M",
      "brand": "Ferrari",
      "model": "456",
      "modelId": "456",
      "generation": "456",
      "generationId": "456",
      "generationLabel": "456 / 456 M (1992-2003)",
      "period": "1992 - 2003",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-456",
      "drawingAsset": "scart-undercarriage-ferrari-456.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-primaire-pour-ferrari-456",
        "paire-de-silencieux-sport-ultima-pour-ferrari-456"
      ],
      "activeProducts": [
        {
          "handle": "echappement-primaire-pour-ferrari-456",
          "title": "Échappement primaire - Ferrari 456",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-silencieux-sport-ultima-pour-ferrari-456",
          "title": "Paire de silencieux sport Ultima - Ferrari 456",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux arrière Ultima",
          "d": "Paire de silencieux arrière sport Ultima pour moteur V12.",
          "rects": [
            [
              12,
              14,
              18,
              24
            ],
            [
              70,
              14,
              18,
              24
            ]
          ],
          "products": [
            {
              "h": "paire-de-silencieux-sport-ultima-pour-ferrari-456",
              "l": "Paire de silencieux sport Ultima - Ferrari 456",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        },
        {
          "id": "mid",
          "n": "L’échappement primaire central",
          "d": "Silencieux intermédiaire primaire situé dans le tunnel central.",
          "rects": [
            [
              30,
              40,
              40,
              20
            ]
          ],
          "products": [
            {
              "h": "echappement-primaire-pour-ferrari-456",
              "l": "Échappement primaire - Ferrari 456",
              "type": "Silencieux"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "456"
      ]
    },
    "ferrari-testarossa": {
      "id": "ferrari-testarossa",
      "displayName": "Ferrari Testarossa",
      "shortName": "Ferrari Testarossa",
      "brand": "Ferrari",
      "model": "Testarossa",
      "modelId": "testarossa",
      "generation": "Testarossa",
      "generationId": "testarossa",
      "generationLabel": "Testarossa (1984-1996)",
      "period": "1984 - 1996",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-testarossa",
      "drawingAsset": "scart-undercarriage-ferrari-testarossa.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-ferrari-testarossa"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-ferrari-testarossa",
          "title": "Échappement à valves - Ferrari Testarossa",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-ferrari-testarossa",
              "l": "Échappement à valves - Ferrari Testarossa",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "Testarossa"
      ]
    },
    "ferrari-360": {
      "id": "ferrari-360",
      "displayName": "Ferrari 360 Modena",
      "shortName": "Ferrari 360 Modena",
      "brand": "Ferrari",
      "model": "360",
      "modelId": "360",
      "generation": "360",
      "generationId": "360",
      "generationLabel": "360 Modena (1999-2005)",
      "period": "1999 - 2005",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-360",
      "drawingAsset": "scart-undercarriage-ferrari-360.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-ferrari-350-modena"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-ferrari-350-modena",
          "title": "Échappement sport - Modena - Ferrari 360",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-ferrari-350-modena",
              "l": "Échappement sport - Modena - Ferrari 360",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet « 360 » (carte compat PDP vide). Handle `echappement-sport-ferrari-350-modena` (faute : 350).",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "360"
      ]
    },
    "ferrari-512-bb": {
      "id": "ferrari-512-bb",
      "displayName": "Ferrari 512 BB / BBi",
      "shortName": "Ferrari 512 BB / BBi",
      "brand": "Ferrari",
      "model": "512 BB",
      "modelId": "512-bb",
      "generation": "512 BB",
      "generationId": "512-bb",
      "generationLabel": "512 BB / BBi (1976-1984)",
      "period": "1976 - 1984",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "ferrari-512-bb",
      "drawingAsset": "scart-undercarriage-ferrari-512-bb.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "paire-d-chappement-sport-pour-ferrari-512-bb"
      ],
      "activeProducts": [
        {
          "handle": "paire-d-chappement-sport-pour-ferrari-512-bb",
          "title": "Paire d'échappement sport - Ferrari 512 BB",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "paire-d-chappement-sport-pour-ferrari-512-bb",
              "l": "Paire d'échappement sport - Ferrari 512 BB",
              "type": "Ligne complète",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Libellé orphelin : aucun métaobjet « 512 BB » (carte compat PDP vide).",
      "anomalies": [
        "Libellé orphelin : aucun métaobjet vehicle_compat_label, carte compatibilité PDP vide."
      ],
      "aliases": [
        "512 BB"
      ]
    },
    "audi-r8-v8": {
      "id": "audi-r8-v8",
      "displayName": "Audi R8 V8 (type 42)",
      "shortName": "Audi R8 V8",
      "brand": "Audi",
      "model": "R8",
      "modelId": "r8",
      "generation": "R8",
      "generationId": "r8-type-42",
      "generationLabel": "R8 Type 42 (2006-2015)",
      "period": "2007 - 2012",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "audi-r8-v8",
      "drawingAsset": "scart-undercarriage-audi-r8-v8.webp",
      "logoKey": "audi-v8",
      "logoAsset": "scart-logo-audi-v8.svg",
      "logoTitle": "V8",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "silencieux-sport-pour-audi-r8-v8",
        "silencieux-valves-pour-audi-r8-v8"
      ],
      "activeProducts": [
        {
          "handle": "silencieux-sport-pour-audi-r8-v8",
          "title": "Silencieux sport - Audi R8 V8",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves-pour-audi-r8-v8",
          "title": "Silencieux à valves - Audi R8 V8",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "silencieux-sport-pour-audi-r8-v8",
              "l": "Silencieux sport - Audi R8 V8",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-valves-pour-audi-r8-v8",
              "l": "Silencieux à valves - Audi R8 V8",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "",
      "anomalies": [],
      "aliases": [
        "R8 V8"
      ]
    },
    "audi-r8-v10": {
      "id": "audi-r8-v10",
      "displayName": "Audi R8 V10 (type 42)",
      "shortName": "Audi R8 V10",
      "brand": "Audi",
      "model": "R8",
      "modelId": "r8",
      "generation": "R8",
      "generationId": "r8-type-42",
      "generationLabel": "R8 Type 42 (2006-2015)",
      "period": "2009 - 2015",
      "architecture": "Moteur V10",
      "description": "Architecture moteur v10 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "audi-r8-v10",
      "drawingAsset": "scart-undercarriage-audi-r8-v10.webp",
      "logoKey": "audi-v10",
      "logoAsset": "scart-logo-audi-v10.svg",
      "logoTitle": "V10",
      "logoFormat": "svg",
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-pour-audi-r8-v10",
        "silencieux-valves-pour-audi-r8-v10",
        "sorties-echappement-audi-r8-v10-2009-2012"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-pour-audi-r8-v10",
          "title": "Échappement sport - Audi R8 V10",
          "type": "Silencieux",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "silencieux-valves-pour-audi-r8-v10",
          "title": "Silencieux à valves - Audi R8 V10",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "sorties-echappement-audi-r8-v10-2009-2012",
          "title": "Sorties échappements - 2009 - 2012 - Audi R8 V10",
          "type": "Sortie",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-pour-audi-r8-v10",
              "l": "Échappement sport - Audi R8 V10",
              "type": "Silencieux",
              "s": 2,
              "g": "sound",
              "l_short": "Sport"
            },
            {
              "h": "silencieux-valves-pour-audi-r8-v10",
              "l": "Silencieux à valves - Audi R8 V10",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ],
          "scale": [
            "Sonorité fixe",
            "À la demande"
          ],
          "journeyTitle": "Le même emplacement, deux comportements",
          "journeyHint": "Fixe ou à la demande"
        },
        {
          "id": "outlets",
          "n": "Les sorties d’échappement",
          "d": "Finitions soignées d’origine ou sorties sport personnalisées.",
          "rects": [
            [
              14,
              6,
              14,
              12
            ],
            [
              72,
              6,
              14,
              12
            ]
          ],
          "products": [
            {
              "h": "sorties-echappement-audi-r8-v10-2009-2012",
              "l": "Sorties échappements - 2009 - 2012 - Audi R8 V10",
              "type": "Sortie"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Sorties 2009-2012 = zone spécifique ; même dessous que le V8 côté arrière mais silencieux distincts : familles séparées.",
      "anomalies": [],
      "aliases": [
        "R8 V10"
      ]
    },
    "alpine-a110": {
      "id": "alpine-a110",
      "displayName": "Alpine A110 / A110 S / A110 GT",
      "shortName": "Alpine A110",
      "brand": "Alpine",
      "model": "A110",
      "modelId": "a110",
      "generation": "A110",
      "generationId": "a110-2017",
      "generationLabel": "A110 (2017+)",
      "period": "2017 - aujourd'hui",
      "architecture": "4 cylindres turbo",
      "description": "Architecture 4 cylindres turbo et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "alpine-a110",
      "drawingAsset": "scart-undercarriage-alpine-a110.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-sport-a-valve",
        "echappement-sport-a-valve-copie",
        "kit-telecommande"
      ],
      "activeProducts": [
        {
          "handle": "echappement-sport-a-valve",
          "title": "Échappement sport à valve - Alpine A110",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "echappement-sport-a-valve-copie",
          "title": "Échappement sport à valve + Downpipe - Alpine A110",
          "type": "Ligne complète",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "kit-telecommande",
          "title": "Kit télécommande - Alpine A110 / A110R",
          "type": "Interrupteur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 3,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux principal",
          "d": "Silencieux transversal central délivrant la sonorité Scart.",
          "rects": [
            [
              20,
              14,
              60,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-sport-a-valve",
              "l": "Échappement sport à valve - Alpine A110",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            },
            {
              "h": "echappement-sport-a-valve-copie",
              "l": "Échappement sport à valve + Downpipe - Alpine A110",
              "type": "Ligne complète",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [
        {
          "handle": "kit-telecommande",
          "title": "Kit télécommande - Alpine A110 / A110R",
          "category": "switch",
          "description": "Commande de valves au tableau de bord ou kit télécommande sans fil pour piloter la sonorité."
        }
      ],
      "accessoriesCount": 1,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "`A110R` n'existe que sur le kit télécommande (accessoire) et n'a pas de métaobjet : aucun échappement SCART pour l'A110 R.",
      "anomalies": [],
      "aliases": [
        "A110",
        "A110R"
      ]
    },
    "aston-martin-db7-v12": {
      "id": "aston-martin-db7-v12",
      "displayName": "Aston Martin DB7 V12 Vantage",
      "shortName": "Aston Martin DB7 V12",
      "brand": "Aston Martin",
      "model": "DB7",
      "modelId": "db7",
      "generation": "DB7",
      "generationId": "db7-v12",
      "generationLabel": "DB7 Vantage (1999-2004)",
      "period": "1999 - 2004",
      "architecture": "Moteur 12 cylindres",
      "description": "Architecture moteur 12 cylindres et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "aston-martin-db7-v12",
      "drawingAsset": "scart-undercarriage-aston-martin-db7-v12.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-aston-martin-db7-v12-vantage",
        "paire-de-catalyseurs-sport-200-cc-aston-marin-db7-v12-vantage"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-aston-martin-db7-v12-vantage",
          "title": "Échappement SCART à valves - V12 Vantage - Aston Martin DB7",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        },
        {
          "handle": "paire-de-catalyseurs-sport-200-cc-aston-marin-db7-v12-vantage",
          "title": "Paire de catalyseurs sport 200 cc - Aston Martin V12 Vantage - Aston Martin DB7",
          "type": "Catalyseur",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 2,
      "zones": [
        {
          "id": "muffler",
          "n": "Les silencieux latéraux arrière",
          "d": "Silencieux d’extrémité arrière gauche et droit calibrant la signature sonore.",
          "rects": [
            [
              10,
              12,
              18,
              28
            ],
            [
              72,
              12,
              18,
              28
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-aston-martin-db7-v12-vantage",
              "l": "Échappement SCART à valves - V12 Vantage - Aston Martin DB7",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        },
        {
          "id": "catalyst",
          "n": "Les catalyseurs sport 200 cc",
          "d": "Catalyseurs sport haute perméabilité libérant débit et timbre.",
          "rects": [
            [
              28,
              48,
              14,
              20
            ],
            [
              58,
              48,
              14,
              20
            ]
          ],
          "scale": null,
          "journeyTitle": null,
          "journeyHint": null,
          "warning": null,
          "products": [
            {
              "h": "paire-de-catalyseurs-sport-200-cc-aston-marin-db7-v12-vantage",
              "l": "Paire de catalyseurs sport 200 cc - Aston Martin V12 Vantage - Aston Martin DB7",
              "type": "Catalyseur"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "La fiche catalyseur annonce V12 ou i6 ; le silencieux vise la V12 Vantage. Le métaobjet « V12 Vantage » (2009-2018) existe mais n'a aucun produit : ne pas le confondre avec la DB7 V12 Vantage.",
      "anomalies": [],
      "aliases": [
        "DB7"
      ]
    },
    "mercedes-amg-gt-black-series": {
      "id": "mercedes-amg-gt-black-series",
      "displayName": "Mercedes-AMG GT Black Series",
      "shortName": "Mercedes-AMG GT Black Series",
      "brand": "Mercedes-AMG",
      "model": "AMG GT",
      "modelId": "amg-gt",
      "generation": "AMG GT",
      "generationId": "c190",
      "generationLabel": "AMG GT C190 (2020-2022)",
      "period": "2020 - 2021",
      "architecture": "Moteur V8",
      "description": "Architecture moteur v8 et ligne sur mesure SCART.",
      "caption": "Vue technique, zones limitées aux pièces proposées par Scart.",
      "visualFamilyId": "mercedes-amg-gt-black-series",
      "drawingAsset": "scart-undercarriage-mercedes-amg-gt-black-series.webp",
      "logoKey": null,
      "logoAsset": null,
      "logoTitle": null,
      "logoFormat": null,
      "hasPseQuestion": false,
      "activeProductHandles": [
        "echappement-a-valves-amg-gt-black-series"
      ],
      "activeProducts": [
        {
          "handle": "echappement-a-valves-amg-gt-black-series",
          "title": "Échappement à valves - Mercedes AMG GT Black series",
          "type": "Silencieux à valves",
          "published": true,
          "isPseProduct": false
        }
      ],
      "productCount": 1,
      "zones": [
        {
          "id": "muffler",
          "n": "Le silencieux arrière à valves",
          "d": "Échappement arrière à valves actives pour moteur V8 biturbo.",
          "rects": [
            [
              18,
              14,
              64,
              24
            ]
          ],
          "products": [
            {
              "h": "echappement-a-valves-amg-gt-black-series",
              "l": "Échappement à valves - Mercedes AMG GT Black series",
              "type": "Silencieux à valves",
              "g": "valve",
              "l_short": "Avec valves"
            }
          ]
        }
      ],
      "accessories": [],
      "accessoriesCount": 0,
      "isProductionReference": false,
      "zoneCalibration": "test-heuristic",
      "notes": "Le métaobjet « AMG GT » n'a pas de collection_handle ; Mercedes est absente de la hiérarchie du configurateur.",
      "anomalies": [],
      "aliases": [
        "AMG GT Black series",
        "AMG GT"
      ]
    }
  },
  "families": [
    {
      "id": "porsche-911-type-g",
      "name": "911 Type G (2.7 / SC 3.0 / Carrera 3.2)",
      "brand": "Porsche",
      "generation": "Type G",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-type-g-2-7",
        "porsche-911-sc-3-0",
        "porsche-911-carrera-3-2"
      ],
      "isShared": true,
      "sharedVisualReason": "Un dessin = une génération (décision prod 05/08/2026) : pré-silencieux 2 en 1 + silencieux transversal identiques 2.7 / 3.0 / 3.2, mêmes zones vendues.",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-930-turbo",
      "name": "911 Turbo (930)",
      "brand": "Porsche",
      "generation": "930",
      "drawingAsset": "porsche-911-930-turbo-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-930-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-964-carrera",
      "name": "911 Carrera (964)",
      "brand": "Porsche",
      "generation": "964",
      "drawingAsset": "porsche-911-964-carrera-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-964-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-964-turbo",
      "name": "911 Turbo (964)",
      "brand": "Porsche",
      "generation": "964",
      "drawingAsset": "porsche-911-964-turbo-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-964-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-993-carrera",
      "name": "911 Carrera (993)",
      "brand": "Porsche",
      "generation": "993",
      "drawingAsset": "porsche-911-993-carrera-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-993-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-993-turbo",
      "name": "911 Turbo (993)",
      "brand": "Porsche",
      "generation": "993",
      "drawingAsset": "porsche-911-993-turbo-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-993-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-1-turbo",
      "name": "911 Turbo (997.1)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-turbo.webp",
      "vehicleIds": [
        "porsche-911-997-1-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-2-carrera",
      "name": "911 Carrera (997.2) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-carrera.webp",
      "vehicleIds": [
        "porsche-911-997-2-carrera",
        "porsche-911-997-2-carrera-pse"
      ],
      "isShared": true,
      "sharedVisualReason": "Décision Jérémie 04/09/2026 : PSE et non-PSE partagent le dessin C1 ; la question PSE ne filtre que les silencieux et sorties proposés.",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-2-turbo",
      "name": "911 Turbo / Turbo S (997.2)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-turbo.webp",
      "vehicleIds": [
        "porsche-911-997-2-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-2-gt3",
      "name": "911 GT3 / GT3 RS (997.2)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "vehicleIds": [
        "porsche-911-997-2-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-2-gt2-rs",
      "name": "911 GT2 RS (997.2)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt2-rs.webp",
      "vehicleIds": [
        "porsche-911-997-2-gt2-rs"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-356",
      "name": "356 (A / B / C)",
      "brand": "Porsche",
      "generation": "356",
      "drawingAsset": "scart-undercarriage-porsche-356.webp",
      "vehicleIds": [
        "porsche-356"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-type-f",
      "name": "911 Type F (1965-1973) et Carrera RS 2.7",
      "brand": "Porsche",
      "generation": "Type F",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "vehicleIds": [
        "porsche-911-type-f",
        "porsche-911-type-f-1973-1976",
        "porsche-911-carrera-rs-2-7"
      ],
      "isShared": true,
      "sharedVisualReason": "Type F 2.0 / 2.2 / 2.4, RS 2.7 (1973) et le libellé hérité 1973-1976 : échangeurs + silencieux transversal arrière 2 entrées, mêmes zones vendues (silencieux, collecteurs courts).",
      "status": "dessin validé"
    },
    {
      "id": "porsche-912",
      "name": "912 (1965-1969)",
      "brand": "Porsche",
      "generation": "912",
      "drawingAsset": "scart-undercarriage-porsche-912.webp",
      "vehicleIds": [
        "porsche-912"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-912e",
      "name": "912E (1976)",
      "brand": "Porsche",
      "generation": "912",
      "drawingAsset": "scart-undercarriage-porsche-912e.webp",
      "vehicleIds": [
        "porsche-912e"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-914-4",
      "name": "914/4 (1.7 / 1.8 / 2.0)",
      "brand": "Porsche",
      "generation": "914",
      "drawingAsset": "scart-undercarriage-porsche-914-4.webp",
      "vehicleIds": [
        "porsche-914-4-1-7",
        "porsche-914-4-2-0"
      ],
      "isShared": true,
      "sharedVisualReason": "1,7 L et 2,0 L : même châssis et même position du silencieux arrière ; seuls les raccords aux échangeurs diffèrent (pièces distinctes). Un dessin, deux branches produit.",
      "status": "dessin validé"
    },
    {
      "id": "porsche-928-s",
      "name": "928 S (1980-1986)",
      "brand": "Porsche",
      "generation": "928",
      "drawingAsset": "scart-undercarriage-porsche-928-s.webp",
      "vehicleIds": [
        "porsche-928-s"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-928-s4-gt-gts",
      "name": "928 S4 / GT / GTS (1987-1995)",
      "brand": "Porsche",
      "generation": "928",
      "drawingAsset": "scart-undercarriage-porsche-928-s4-gt-gts.webp",
      "vehicleIds": [
        "porsche-928-s4-gt-gts"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-944-turbo",
      "name": "944 Turbo (951)",
      "brand": "Porsche",
      "generation": "944",
      "drawingAsset": "scart-undercarriage-porsche-944-turbo.webp",
      "vehicleIds": [
        "porsche-944-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-968",
      "name": "968",
      "brand": "Porsche",
      "generation": "968",
      "drawingAsset": "scart-undercarriage-porsche-968.webp",
      "vehicleIds": [
        "porsche-968"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-boxster-986",
      "name": "Boxster 986 (2.5 / 2.7 / 3.2)",
      "brand": "Porsche",
      "generation": "986",
      "drawingAsset": "scart-undercarriage-porsche-boxster-986.webp",
      "vehicleIds": [
        "porsche-boxster-986"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-boxster-987-1",
      "name": "Boxster / Cayman 987 phase 1",
      "brand": "Porsche",
      "generation": "987",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-1.webp",
      "vehicleIds": [
        "porsche-boxster-987-1"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-boxster-987-2",
      "name": "Boxster / Cayman 987 phase 2",
      "brand": "Porsche",
      "generation": "987",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-2.webp",
      "vehicleIds": [
        "porsche-boxster-987-2"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-boxster-981",
      "name": "Boxster / Cayman 981",
      "brand": "Porsche",
      "generation": "981",
      "drawingAsset": "scart-undercarriage-porsche-boxster-981.webp",
      "vehicleIds": [
        "porsche-boxster-981"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-718-4-0",
      "name": "718 Spyder / Cayman GT4 4.0",
      "brand": "Porsche",
      "generation": "718",
      "drawingAsset": "scart-undercarriage-porsche-718-4-0.webp",
      "vehicleIds": [
        "porsche-718-4-0"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-718-gt4-rs",
      "name": "718 Cayman GT4 RS",
      "brand": "Porsche",
      "generation": "718",
      "drawingAsset": "scart-undercarriage-porsche-718-gt4-rs.webp",
      "vehicleIds": [
        "porsche-718-gt4-rs"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-996-carrera",
      "name": "911 Carrera (996) 3.4 / 3.6",
      "brand": "Porsche",
      "generation": "996",
      "drawingAsset": "scart-undercarriage-porsche-911-996-carrera.webp",
      "vehicleIds": [
        "porsche-911-996-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-996-gt3",
      "name": "911 GT3 (996)",
      "brand": "Porsche",
      "generation": "996",
      "drawingAsset": "scart-undercarriage-porsche-911-996-gt3.webp",
      "vehicleIds": [
        "porsche-911-996-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-996-turbo",
      "name": "911 Turbo (996)",
      "brand": "Porsche",
      "generation": "996",
      "drawingAsset": "scart-undercarriage-porsche-911-996-turbo.webp",
      "vehicleIds": [
        "porsche-911-996-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-1-carrera",
      "name": "911 Carrera (997.1), PSE, Sport Classic",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-carrera.webp",
      "vehicleIds": [
        "porsche-911-997-1-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-997-1-gt3",
      "name": "911 GT3 (997.1)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-gt3.webp",
      "vehicleIds": [
        "porsche-911-997-1-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-991-1-carrera",
      "name": "911 Carrera (991.1) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-1-carrera.webp",
      "vehicleIds": [
        "porsche-911-991-1-carrera",
        "porsche-911-991-1-carrera-pse"
      ],
      "isShared": true,
      "sharedVisualReason": "991.1 Carrera / Carrera S, PSE ou non : même architecture, le silencieux central SCART est commun.",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-991-1-gt3",
      "name": "911 GT3 (991.1)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "vehicleIds": [
        "porsche-911-991-1-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-991-1-turbo",
      "name": "911 Turbo (991.1)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "vehicleIds": [
        "porsche-911-991-1-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-991-2-carrera",
      "name": "911 Carrera (991.2) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-carrera.webp",
      "vehicleIds": [
        "porsche-911-991-2-carrera",
        "porsche-911-991-2-carrera-pse"
      ],
      "isShared": true,
      "sharedVisualReason": "991.2 Carrera / Carrera S, PSE ou non : X-pipe SCART commun, mêmes positions.",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-991-2-gt3",
      "name": "911 GT3 (991.2)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-gt3.webp",
      "vehicleIds": [
        "porsche-911-991-2-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-991-2-turbo",
      "name": "911 Turbo (991.2)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "vehicleIds": [
        "porsche-911-991-2-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-911-992-carrera",
      "name": "911 Carrera (992) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "992",
      "drawingAsset": "scart-undercarriage-porsche-911-992-carrera.webp",
      "vehicleIds": [
        "porsche-911-992-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-955-s",
      "name": "Cayenne S (955)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-s.webp",
      "vehicleIds": [
        "porsche-cayenne-955-s"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-955-turbo",
      "name": "Cayenne Turbo (955)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-turbo.webp",
      "vehicleIds": [
        "porsche-cayenne-955-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-957-s",
      "name": "Cayenne S (957)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-s.webp",
      "vehicleIds": [
        "porsche-cayenne-957-s"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-957-turbo",
      "name": "Cayenne Turbo (957)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-turbo.webp",
      "vehicleIds": [
        "porsche-cayenne-957-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-958",
      "name": "Cayenne (958) atmosphérique",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958.webp",
      "vehicleIds": [
        "porsche-cayenne-958"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-958-turbo",
      "name": "Cayenne Turbo (958)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958-turbo.webp",
      "vehicleIds": [
        "porsche-cayenne-958-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-cayenne-9ya-v6",
      "name": "Cayenne V6 (9YA, PO536)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-9ya-v6.webp",
      "vehicleIds": [
        "porsche-cayenne-9ya-v6"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-panamera-970",
      "name": "Panamera (970) hors Turbo",
      "brand": "Porsche",
      "generation": "Panamera",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970.webp",
      "vehicleIds": [
        "porsche-panamera-970"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "porsche-panamera-970-turbo",
      "name": "Panamera Turbo (970)",
      "brand": "Porsche",
      "generation": "Panamera",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970-turbo.webp",
      "vehicleIds": [
        "porsche-panamera-970-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "ferrari-f430",
      "name": "Ferrari F430",
      "brand": "Ferrari",
      "generation": "F430",
      "drawingAsset": "scart-undercarriage-ferrari-f430.webp",
      "vehicleIds": [
        "ferrari-f430"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "ferrari-456",
      "name": "Ferrari 456 / 456 M",
      "brand": "Ferrari",
      "generation": "456",
      "drawingAsset": "scart-undercarriage-ferrari-456.webp",
      "vehicleIds": [
        "ferrari-456"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "ferrari-testarossa",
      "name": "Ferrari Testarossa",
      "brand": "Ferrari",
      "generation": "Testarossa",
      "drawingAsset": "scart-undercarriage-ferrari-testarossa.webp",
      "vehicleIds": [
        "ferrari-testarossa"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "ferrari-360",
      "name": "Ferrari 360 Modena",
      "brand": "Ferrari",
      "generation": "360",
      "drawingAsset": "scart-undercarriage-ferrari-360.webp",
      "vehicleIds": [
        "ferrari-360"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "ferrari-512-bb",
      "name": "Ferrari 512 BB / BBi",
      "brand": "Ferrari",
      "generation": "512 BB",
      "drawingAsset": "scart-undercarriage-ferrari-512-bb.webp",
      "vehicleIds": [
        "ferrari-512-bb"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "audi-r8-v8",
      "name": "Audi R8 V8 (type 42)",
      "brand": "Audi",
      "generation": "R8",
      "drawingAsset": "scart-undercarriage-audi-r8-v8.webp",
      "vehicleIds": [
        "audi-r8-v8"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "audi-r8-v10",
      "name": "Audi R8 V10 (type 42)",
      "brand": "Audi",
      "generation": "R8",
      "drawingAsset": "scart-undercarriage-audi-r8-v10.webp",
      "vehicleIds": [
        "audi-r8-v10"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "alpine-a110",
      "name": "Alpine A110 (2017+)",
      "brand": "Alpine",
      "generation": "A110",
      "drawingAsset": "scart-undercarriage-alpine-a110.webp",
      "vehicleIds": [
        "alpine-a110"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "aston-martin-db7-v12",
      "name": "Aston Martin DB7 V12 Vantage",
      "brand": "Aston Martin",
      "generation": "DB7",
      "drawingAsset": "scart-undercarriage-aston-martin-db7-v12.webp",
      "vehicleIds": [
        "aston-martin-db7-v12"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    {
      "id": "mercedes-amg-gt-black-series",
      "name": "Mercedes-AMG GT Black Series",
      "brand": "Mercedes-AMG",
      "generation": "AMG GT",
      "drawingAsset": "scart-undercarriage-mercedes-amg-gt-black-series.webp",
      "vehicleIds": [
        "mercedes-amg-gt-black-series"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    }
  ],
  "familyMap": {
    "porsche-911-type-g": {
      "id": "porsche-911-type-g",
      "name": "911 Type G (2.7 / SC 3.0 / Carrera 3.2)",
      "brand": "Porsche",
      "generation": "Type G",
      "drawingAsset": "porsche-911-type-g-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-type-g-2-7",
        "porsche-911-sc-3-0",
        "porsche-911-carrera-3-2"
      ],
      "isShared": true,
      "sharedVisualReason": "Un dessin = une génération (décision prod 05/08/2026) : pré-silencieux 2 en 1 + silencieux transversal identiques 2.7 / 3.0 / 3.2, mêmes zones vendues.",
      "status": "dessin validé"
    },
    "porsche-911-930-turbo": {
      "id": "porsche-911-930-turbo",
      "name": "911 Turbo (930)",
      "brand": "Porsche",
      "generation": "930",
      "drawingAsset": "porsche-911-930-turbo-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-930-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-964-carrera": {
      "id": "porsche-911-964-carrera",
      "name": "911 Carrera (964)",
      "brand": "Porsche",
      "generation": "964",
      "drawingAsset": "porsche-911-964-carrera-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-964-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-964-turbo": {
      "id": "porsche-911-964-turbo",
      "name": "911 Turbo (964)",
      "brand": "Porsche",
      "generation": "964",
      "drawingAsset": "porsche-911-964-turbo-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-964-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-993-carrera": {
      "id": "porsche-911-993-carrera",
      "name": "911 Carrera (993)",
      "brand": "Porsche",
      "generation": "993",
      "drawingAsset": "porsche-911-993-carrera-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-993-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-993-turbo": {
      "id": "porsche-911-993-turbo",
      "name": "911 Turbo (993)",
      "brand": "Porsche",
      "generation": "993",
      "drawingAsset": "porsche-911-993-turbo-undercarriage-exhaust.webp",
      "vehicleIds": [
        "porsche-911-993-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-997-1-turbo": {
      "id": "porsche-911-997-1-turbo",
      "name": "911 Turbo (997.1)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-turbo.webp",
      "vehicleIds": [
        "porsche-911-997-1-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-997-2-carrera": {
      "id": "porsche-911-997-2-carrera",
      "name": "911 Carrera (997.2) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-carrera.webp",
      "vehicleIds": [
        "porsche-911-997-2-carrera",
        "porsche-911-997-2-carrera-pse"
      ],
      "isShared": true,
      "sharedVisualReason": "Décision Jérémie 04/09/2026 : PSE et non-PSE partagent le dessin C1 ; la question PSE ne filtre que les silencieux et sorties proposés.",
      "status": "dessin validé"
    },
    "porsche-911-997-2-turbo": {
      "id": "porsche-911-997-2-turbo",
      "name": "911 Turbo / Turbo S (997.2)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-turbo.webp",
      "vehicleIds": [
        "porsche-911-997-2-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-997-2-gt3": {
      "id": "porsche-911-997-2-gt3",
      "name": "911 GT3 / GT3 RS (997.2)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "vehicleIds": [
        "porsche-911-997-2-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-997-2-gt2-rs": {
      "id": "porsche-911-997-2-gt2-rs",
      "name": "911 GT2 RS (997.2)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt2-rs.webp",
      "vehicleIds": [
        "porsche-911-997-2-gt2-rs"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-356": {
      "id": "porsche-356",
      "name": "356 (A / B / C)",
      "brand": "Porsche",
      "generation": "356",
      "drawingAsset": "scart-undercarriage-porsche-356.webp",
      "vehicleIds": [
        "porsche-356"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-type-f": {
      "id": "porsche-911-type-f",
      "name": "911 Type F (1965-1973) et Carrera RS 2.7",
      "brand": "Porsche",
      "generation": "Type F",
      "drawingAsset": "scart-undercarriage-porsche-911-type-f.webp",
      "vehicleIds": [
        "porsche-911-type-f",
        "porsche-911-type-f-1973-1976",
        "porsche-911-carrera-rs-2-7"
      ],
      "isShared": true,
      "sharedVisualReason": "Type F 2.0 / 2.2 / 2.4, RS 2.7 (1973) et le libellé hérité 1973-1976 : échangeurs + silencieux transversal arrière 2 entrées, mêmes zones vendues (silencieux, collecteurs courts).",
      "status": "dessin validé"
    },
    "porsche-912": {
      "id": "porsche-912",
      "name": "912 (1965-1969)",
      "brand": "Porsche",
      "generation": "912",
      "drawingAsset": "scart-undercarriage-porsche-912.webp",
      "vehicleIds": [
        "porsche-912"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-912e": {
      "id": "porsche-912e",
      "name": "912E (1976)",
      "brand": "Porsche",
      "generation": "912",
      "drawingAsset": "scart-undercarriage-porsche-912e.webp",
      "vehicleIds": [
        "porsche-912e"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-914-4": {
      "id": "porsche-914-4",
      "name": "914/4 (1.7 / 1.8 / 2.0)",
      "brand": "Porsche",
      "generation": "914",
      "drawingAsset": "scart-undercarriage-porsche-914-4.webp",
      "vehicleIds": [
        "porsche-914-4-1-7",
        "porsche-914-4-2-0"
      ],
      "isShared": true,
      "sharedVisualReason": "1,7 L et 2,0 L : même châssis et même position du silencieux arrière ; seuls les raccords aux échangeurs diffèrent (pièces distinctes). Un dessin, deux branches produit.",
      "status": "dessin validé"
    },
    "porsche-928-s": {
      "id": "porsche-928-s",
      "name": "928 S (1980-1986)",
      "brand": "Porsche",
      "generation": "928",
      "drawingAsset": "scart-undercarriage-porsche-928-s.webp",
      "vehicleIds": [
        "porsche-928-s"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-928-s4-gt-gts": {
      "id": "porsche-928-s4-gt-gts",
      "name": "928 S4 / GT / GTS (1987-1995)",
      "brand": "Porsche",
      "generation": "928",
      "drawingAsset": "scart-undercarriage-porsche-928-s4-gt-gts.webp",
      "vehicleIds": [
        "porsche-928-s4-gt-gts"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-944-turbo": {
      "id": "porsche-944-turbo",
      "name": "944 Turbo (951)",
      "brand": "Porsche",
      "generation": "944",
      "drawingAsset": "scart-undercarriage-porsche-944-turbo.webp",
      "vehicleIds": [
        "porsche-944-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-968": {
      "id": "porsche-968",
      "name": "968",
      "brand": "Porsche",
      "generation": "968",
      "drawingAsset": "scart-undercarriage-porsche-968.webp",
      "vehicleIds": [
        "porsche-968"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-boxster-986": {
      "id": "porsche-boxster-986",
      "name": "Boxster 986 (2.5 / 2.7 / 3.2)",
      "brand": "Porsche",
      "generation": "986",
      "drawingAsset": "scart-undercarriage-porsche-boxster-986.webp",
      "vehicleIds": [
        "porsche-boxster-986"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-boxster-987-1": {
      "id": "porsche-boxster-987-1",
      "name": "Boxster / Cayman 987 phase 1",
      "brand": "Porsche",
      "generation": "987",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-1.webp",
      "vehicleIds": [
        "porsche-boxster-987-1"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-boxster-987-2": {
      "id": "porsche-boxster-987-2",
      "name": "Boxster / Cayman 987 phase 2",
      "brand": "Porsche",
      "generation": "987",
      "drawingAsset": "scart-undercarriage-porsche-boxster-987-2.webp",
      "vehicleIds": [
        "porsche-boxster-987-2"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-boxster-981": {
      "id": "porsche-boxster-981",
      "name": "Boxster / Cayman 981",
      "brand": "Porsche",
      "generation": "981",
      "drawingAsset": "scart-undercarriage-porsche-boxster-981.webp",
      "vehicleIds": [
        "porsche-boxster-981"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-718-4-0": {
      "id": "porsche-718-4-0",
      "name": "718 Spyder / Cayman GT4 4.0",
      "brand": "Porsche",
      "generation": "718",
      "drawingAsset": "scart-undercarriage-porsche-718-4-0.webp",
      "vehicleIds": [
        "porsche-718-4-0"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-718-gt4-rs": {
      "id": "porsche-718-gt4-rs",
      "name": "718 Cayman GT4 RS",
      "brand": "Porsche",
      "generation": "718",
      "drawingAsset": "scart-undercarriage-porsche-718-gt4-rs.webp",
      "vehicleIds": [
        "porsche-718-gt4-rs"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-996-carrera": {
      "id": "porsche-911-996-carrera",
      "name": "911 Carrera (996) 3.4 / 3.6",
      "brand": "Porsche",
      "generation": "996",
      "drawingAsset": "scart-undercarriage-porsche-911-996-carrera.webp",
      "vehicleIds": [
        "porsche-911-996-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-996-gt3": {
      "id": "porsche-911-996-gt3",
      "name": "911 GT3 (996)",
      "brand": "Porsche",
      "generation": "996",
      "drawingAsset": "scart-undercarriage-porsche-911-996-gt3.webp",
      "vehicleIds": [
        "porsche-911-996-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-996-turbo": {
      "id": "porsche-911-996-turbo",
      "name": "911 Turbo (996)",
      "brand": "Porsche",
      "generation": "996",
      "drawingAsset": "scart-undercarriage-porsche-911-996-turbo.webp",
      "vehicleIds": [
        "porsche-911-996-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-997-1-carrera": {
      "id": "porsche-911-997-1-carrera",
      "name": "911 Carrera (997.1), PSE, Sport Classic",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-carrera.webp",
      "vehicleIds": [
        "porsche-911-997-1-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-997-1-gt3": {
      "id": "porsche-911-997-1-gt3",
      "name": "911 GT3 (997.1)",
      "brand": "Porsche",
      "generation": "997",
      "drawingAsset": "scart-undercarriage-porsche-911-997-1-gt3.webp",
      "vehicleIds": [
        "porsche-911-997-1-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-991-1-carrera": {
      "id": "porsche-911-991-1-carrera",
      "name": "911 Carrera (991.1) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-1-carrera.webp",
      "vehicleIds": [
        "porsche-911-991-1-carrera",
        "porsche-911-991-1-carrera-pse"
      ],
      "isShared": true,
      "sharedVisualReason": "991.1 Carrera / Carrera S, PSE ou non : même architecture, le silencieux central SCART est commun.",
      "status": "dessin validé"
    },
    "porsche-911-991-1-gt3": {
      "id": "porsche-911-991-1-gt3",
      "name": "911 GT3 (991.1)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-997-2-gt3.webp",
      "vehicleIds": [
        "porsche-911-991-1-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-991-1-turbo": {
      "id": "porsche-911-991-1-turbo",
      "name": "911 Turbo (991.1)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "vehicleIds": [
        "porsche-911-991-1-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-991-2-carrera": {
      "id": "porsche-911-991-2-carrera",
      "name": "911 Carrera (991.2) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-carrera.webp",
      "vehicleIds": [
        "porsche-911-991-2-carrera",
        "porsche-911-991-2-carrera-pse"
      ],
      "isShared": true,
      "sharedVisualReason": "991.2 Carrera / Carrera S, PSE ou non : X-pipe SCART commun, mêmes positions.",
      "status": "dessin validé"
    },
    "porsche-911-991-2-gt3": {
      "id": "porsche-911-991-2-gt3",
      "name": "911 GT3 (991.2)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-gt3.webp",
      "vehicleIds": [
        "porsche-911-991-2-gt3"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-991-2-turbo": {
      "id": "porsche-911-991-2-turbo",
      "name": "911 Turbo (991.2)",
      "brand": "Porsche",
      "generation": "991",
      "drawingAsset": "scart-undercarriage-porsche-911-991-2-turbo.webp",
      "vehicleIds": [
        "porsche-911-991-2-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-911-992-carrera": {
      "id": "porsche-911-992-carrera",
      "name": "911 Carrera (992) avec ou sans PSE",
      "brand": "Porsche",
      "generation": "992",
      "drawingAsset": "scart-undercarriage-porsche-911-992-carrera.webp",
      "vehicleIds": [
        "porsche-911-992-carrera"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-955-s": {
      "id": "porsche-cayenne-955-s",
      "name": "Cayenne S (955)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-s.webp",
      "vehicleIds": [
        "porsche-cayenne-955-s"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-955-turbo": {
      "id": "porsche-cayenne-955-turbo",
      "name": "Cayenne Turbo (955)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-955-turbo.webp",
      "vehicleIds": [
        "porsche-cayenne-955-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-957-s": {
      "id": "porsche-cayenne-957-s",
      "name": "Cayenne S (957)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-s.webp",
      "vehicleIds": [
        "porsche-cayenne-957-s"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-957-turbo": {
      "id": "porsche-cayenne-957-turbo",
      "name": "Cayenne Turbo (957)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-957-turbo.webp",
      "vehicleIds": [
        "porsche-cayenne-957-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-958": {
      "id": "porsche-cayenne-958",
      "name": "Cayenne (958) atmosphérique",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958.webp",
      "vehicleIds": [
        "porsche-cayenne-958"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-958-turbo": {
      "id": "porsche-cayenne-958-turbo",
      "name": "Cayenne Turbo (958)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-958-turbo.webp",
      "vehicleIds": [
        "porsche-cayenne-958-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-cayenne-9ya-v6": {
      "id": "porsche-cayenne-9ya-v6",
      "name": "Cayenne V6 (9YA, PO536)",
      "brand": "Porsche",
      "generation": "Cayenne",
      "drawingAsset": "scart-undercarriage-porsche-cayenne-9ya-v6.webp",
      "vehicleIds": [
        "porsche-cayenne-9ya-v6"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-panamera-970": {
      "id": "porsche-panamera-970",
      "name": "Panamera (970) hors Turbo",
      "brand": "Porsche",
      "generation": "Panamera",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970.webp",
      "vehicleIds": [
        "porsche-panamera-970"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "porsche-panamera-970-turbo": {
      "id": "porsche-panamera-970-turbo",
      "name": "Panamera Turbo (970)",
      "brand": "Porsche",
      "generation": "Panamera",
      "drawingAsset": "scart-undercarriage-porsche-panamera-970-turbo.webp",
      "vehicleIds": [
        "porsche-panamera-970-turbo"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "ferrari-f430": {
      "id": "ferrari-f430",
      "name": "Ferrari F430",
      "brand": "Ferrari",
      "generation": "F430",
      "drawingAsset": "scart-undercarriage-ferrari-f430.webp",
      "vehicleIds": [
        "ferrari-f430"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "ferrari-456": {
      "id": "ferrari-456",
      "name": "Ferrari 456 / 456 M",
      "brand": "Ferrari",
      "generation": "456",
      "drawingAsset": "scart-undercarriage-ferrari-456.webp",
      "vehicleIds": [
        "ferrari-456"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "ferrari-testarossa": {
      "id": "ferrari-testarossa",
      "name": "Ferrari Testarossa",
      "brand": "Ferrari",
      "generation": "Testarossa",
      "drawingAsset": "scart-undercarriage-ferrari-testarossa.webp",
      "vehicleIds": [
        "ferrari-testarossa"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "ferrari-360": {
      "id": "ferrari-360",
      "name": "Ferrari 360 Modena",
      "brand": "Ferrari",
      "generation": "360",
      "drawingAsset": "scart-undercarriage-ferrari-360.webp",
      "vehicleIds": [
        "ferrari-360"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "ferrari-512-bb": {
      "id": "ferrari-512-bb",
      "name": "Ferrari 512 BB / BBi",
      "brand": "Ferrari",
      "generation": "512 BB",
      "drawingAsset": "scart-undercarriage-ferrari-512-bb.webp",
      "vehicleIds": [
        "ferrari-512-bb"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "audi-r8-v8": {
      "id": "audi-r8-v8",
      "name": "Audi R8 V8 (type 42)",
      "brand": "Audi",
      "generation": "R8",
      "drawingAsset": "scart-undercarriage-audi-r8-v8.webp",
      "vehicleIds": [
        "audi-r8-v8"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "audi-r8-v10": {
      "id": "audi-r8-v10",
      "name": "Audi R8 V10 (type 42)",
      "brand": "Audi",
      "generation": "R8",
      "drawingAsset": "scart-undercarriage-audi-r8-v10.webp",
      "vehicleIds": [
        "audi-r8-v10"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "alpine-a110": {
      "id": "alpine-a110",
      "name": "Alpine A110 (2017+)",
      "brand": "Alpine",
      "generation": "A110",
      "drawingAsset": "scart-undercarriage-alpine-a110.webp",
      "vehicleIds": [
        "alpine-a110"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "aston-martin-db7-v12": {
      "id": "aston-martin-db7-v12",
      "name": "Aston Martin DB7 V12 Vantage",
      "brand": "Aston Martin",
      "generation": "DB7",
      "drawingAsset": "scart-undercarriage-aston-martin-db7-v12.webp",
      "vehicleIds": [
        "aston-martin-db7-v12"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    },
    "mercedes-amg-gt-black-series": {
      "id": "mercedes-amg-gt-black-series",
      "name": "Mercedes-AMG GT Black Series",
      "brand": "Mercedes-AMG",
      "generation": "AMG GT",
      "drawingAsset": "scart-undercarriage-mercedes-amg-gt-black-series.webp",
      "vehicleIds": [
        "mercedes-amg-gt-black-series"
      ],
      "isShared": false,
      "sharedVisualReason": "",
      "status": "dessin validé"
    }
  },
  "logos": {
    "porsche-911-simple": {
      "asset": "scart-logo-porsche-911.svg",
      "title": "911",
      "format": "svg"
    },
    "porsche-carrera-rs-27": {
      "asset": "scart-logo-porsche-carrera-rs.svg",
      "title": "Carrera RS",
      "format": "svg"
    },
    "porsche-912": {
      "asset": "scart-logo-porsche-912.jpg",
      "title": "912",
      "format": "jpg"
    },
    "porsche-912e": {
      "asset": "scart-logo-porsche-912e.svg",
      "title": "912E",
      "format": "svg"
    },
    "porsche-914": {
      "asset": "scart-logo-porsche-914.svg",
      "title": "914",
      "format": "svg"
    },
    "porsche-928-s": {
      "asset": "scart-logo-porsche-928-s.svg",
      "title": "928 S",
      "format": "svg"
    },
    "porsche-928-s4": {
      "asset": "scart-logo-porsche-928-s4.svg",
      "title": "928 S4",
      "format": "svg"
    },
    "porsche-928-gt": {
      "asset": "scart-logo-porsche-928-gt.svg",
      "title": "928 GT",
      "format": "svg"
    },
    "porsche-928-gts": {
      "asset": "scart-logo-porsche-928-gts.svg",
      "title": "928 GTS",
      "format": "svg"
    },
    "porsche-718-spyder": {
      "asset": "scart-logo-porsche-718-spyder.svg",
      "title": "718 Spyder",
      "format": "svg"
    },
    "porsche-718-gt4": {
      "asset": "scart-logo-porsche-718-gt4.svg",
      "title": "Cayman GT4",
      "format": "svg"
    },
    "porsche-718-gt4-rs": {
      "asset": "scart-logo-porsche-718-gt4-rs.svg",
      "title": "GT4 RS",
      "format": "svg"
    },
    "porsche-cayenne": {
      "asset": "scart-logo-porsche-cayenne.svg",
      "title": "Cayenne",
      "format": "svg"
    },
    "porsche-panamera": {
      "asset": "scart-logo-porsche-panamera.svg",
      "title": "Panamera",
      "format": "svg"
    },
    "audi-r8": {
      "asset": "scart-logo-audi-r8.png",
      "title": "Audi R8",
      "format": "png"
    },
    "audi-v8": {
      "asset": "scart-logo-audi-v8.svg",
      "title": "V8",
      "format": "svg"
    },
    "audi-v10": {
      "asset": "scart-logo-audi-v10.svg",
      "title": "V10",
      "format": "svg"
    },
    "porsche-pse": {
      "asset": "scart-logo-porsche-carrera-pse.svg",
      "title": "Carrera + PSE",
      "format": "svg"
    },
    "porsche-911-sc": {
      "asset": "scart-badge-911-sc.svg",
      "title": "911 SC",
      "format": "svg"
    },
    "porsche-carrera": {
      "asset": "scart-porsche-carrera-wordmark.svg",
      "title": "Carrera",
      "format": "svg"
    },
    "porsche-turbo": {
      "asset": "scart-porsche-turbo-wordmark.svg",
      "title": "Turbo",
      "format": "svg"
    },
    "porsche-gt3": {
      "asset": "scart-porsche-gt3-wordmark.svg",
      "title": "GT3",
      "format": "svg"
    },
    "porsche-gt3-rs": {
      "asset": "scart-porsche-gt3-rs-wordmark.png",
      "title": "GT3 RS",
      "format": "png"
    },
    "porsche-gt2-rs": {
      "asset": "scart-porsche-gt2-rs-wordmark.png",
      "title": "GT2 RS",
      "format": "png"
    }
  },
  "brands": [
    {
      "id": "porsche",
      "name": "Porsche",
      "models": [
        {
          "id": "356",
          "name": "356",
          "generations": [
            {
              "id": "356",
              "label": "356 (1948-1965)",
              "versions": [
                "porsche-356"
              ],
              "period": "1948 - 1965",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-356"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "356"
        },
        {
          "id": "911",
          "name": "911",
          "generations": [
            {
              "id": "type-f",
              "label": "Type F (1963-1973)",
              "versions": [
                "porsche-911-type-f",
                "porsche-911-type-f-1973-1976",
                "porsche-911-carrera-rs-2-7"
              ],
              "period": "1963 - 1973",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "type-g",
              "label": "Type G (1974-1989)",
              "versions": [
                "porsche-911-type-g-2-7",
                "porsche-911-sc-3-0",
                "porsche-911-carrera-3-2"
              ],
              "period": "1974 - 1977",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "930",
              "label": "930 Turbo (1975-1989)",
              "versions": [
                "porsche-911-930-turbo"
              ],
              "period": "1975 - 1989",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-911-930-turbo"
            },
            {
              "id": "964",
              "label": "964 (1989-1994)",
              "versions": [
                "porsche-911-964-carrera",
                "porsche-911-964-turbo"
              ],
              "period": "1989 - 1994",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "993",
              "label": "993 (1994-1998)",
              "versions": [
                "porsche-911-993-carrera",
                "porsche-911-993-turbo"
              ],
              "period": "1994 - 1998",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "996",
              "label": "996 (1997-2005)",
              "versions": [
                "porsche-911-996-carrera",
                "porsche-911-996-gt3",
                "porsche-911-996-turbo"
              ],
              "period": "1997 - 2005",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "997-1",
              "label": "997.1 (2004-2008)",
              "versions": [
                "porsche-911-997-1-carrera",
                "porsche-911-997-1-gt3",
                "porsche-911-997-1-turbo"
              ],
              "period": "2004 - 2008",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "997-2",
              "label": "997.2 (2008-2012)",
              "versions": [
                "porsche-911-997-2-carrera",
                "porsche-911-997-2-carrera-pse",
                "porsche-911-997-2-gt3",
                "porsche-911-997-2-gt2-rs",
                "porsche-911-997-2-turbo"
              ],
              "period": "2008 - 2012",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "991-1",
              "label": "991.1 (2011-2015)",
              "versions": [
                "porsche-911-991-1-carrera",
                "porsche-911-991-1-carrera-pse",
                "porsche-911-991-1-gt3",
                "porsche-911-991-1-turbo"
              ],
              "period": "2011 - 2015",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "991-2",
              "label": "991.2 (2015-2019)",
              "versions": [
                "porsche-911-991-2-carrera",
                "porsche-911-991-2-carrera-pse",
                "porsche-911-991-2-gt3",
                "porsche-911-991-2-turbo"
              ],
              "period": "2015 - 2019",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "992",
              "label": "992 (2019+)",
              "versions": [
                "porsche-911-992-carrera"
              ],
              "period": "2019 - aujourd'hui",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-911-992-carrera"
            }
          ],
          "vehiclesCount": 31,
          "isSingleGeneration": false,
          "defaultGenId": null
        },
        {
          "id": "912",
          "name": "912",
          "generations": [
            {
              "id": "912",
              "label": "912 (1965-1976)",
              "versions": [
                "porsche-912",
                "porsche-912e"
              ],
              "period": "1965 - 1969",
              "isSingleVersion": false,
              "defaultVehicleId": null
            }
          ],
          "vehiclesCount": 2,
          "isSingleGeneration": true,
          "defaultGenId": "912"
        },
        {
          "id": "914",
          "name": "914",
          "generations": [
            {
              "id": "914",
              "label": "914 (1969-1976)",
              "versions": [
                "porsche-914-4-1-7",
                "porsche-914-4-2-0"
              ],
              "period": "1969 - 1973",
              "isSingleVersion": false,
              "defaultVehicleId": null
            }
          ],
          "vehiclesCount": 2,
          "isSingleGeneration": true,
          "defaultGenId": "914"
        },
        {
          "id": "928",
          "name": "928",
          "generations": [
            {
              "id": "928",
              "label": "928 (1977-1995)",
              "versions": [
                "porsche-928-s",
                "porsche-928-s4-gt-gts"
              ],
              "period": "1980 - 1986",
              "isSingleVersion": false,
              "defaultVehicleId": null
            }
          ],
          "vehiclesCount": 2,
          "isSingleGeneration": true,
          "defaultGenId": "928"
        },
        {
          "id": "944",
          "name": "944",
          "generations": [
            {
              "id": "944",
              "label": "944 (1985-1991)",
              "versions": [
                "porsche-944-turbo"
              ],
              "period": "1985 - 1991",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-944-turbo"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "944"
        },
        {
          "id": "968",
          "name": "968",
          "generations": [
            {
              "id": "968",
              "label": "968 (1992-1995)",
              "versions": [
                "porsche-968"
              ],
              "period": "1992 - 1995",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-968"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "968"
        },
        {
          "id": "boxster-cayman",
          "name": "Boxster / Cayman",
          "generations": [
            {
              "id": "986",
              "label": "986 (1996-2004)",
              "versions": [
                "porsche-boxster-986"
              ],
              "period": "1996 - 2004",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-boxster-986"
            },
            {
              "id": "987-1",
              "label": "987.1 (2004-2008)",
              "versions": [
                "porsche-boxster-987-1"
              ],
              "period": "2004 - 2008",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-boxster-987-1"
            },
            {
              "id": "987-2",
              "label": "987.2 (2009-2012)",
              "versions": [
                "porsche-boxster-987-2"
              ],
              "period": "2008 - 2012",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-boxster-987-2"
            },
            {
              "id": "981",
              "label": "981 (2012-2016)",
              "versions": [
                "porsche-boxster-981"
              ],
              "period": "2012 - 2016",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-boxster-981"
            },
            {
              "id": "718",
              "label": "718 (2016+)",
              "versions": [
                "porsche-718-4-0",
                "porsche-718-gt4-rs"
              ],
              "period": "2019 - 2024",
              "isSingleVersion": false,
              "defaultVehicleId": null
            }
          ],
          "vehiclesCount": 6,
          "isSingleGeneration": false,
          "defaultGenId": null
        },
        {
          "id": "cayenne",
          "name": "Cayenne",
          "generations": [
            {
              "id": "955",
              "label": "Cayenne 955 (2002-2007)",
              "versions": [
                "porsche-cayenne-955-s",
                "porsche-cayenne-955-turbo"
              ],
              "period": "2002 - 2007",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "957",
              "label": "Cayenne 957 (2007-2010)",
              "versions": [
                "porsche-cayenne-957-s",
                "porsche-cayenne-957-turbo"
              ],
              "period": "2007 - 2010",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "958",
              "label": "Cayenne 958 (2010-2017)",
              "versions": [
                "porsche-cayenne-958",
                "porsche-cayenne-958-turbo"
              ],
              "period": "2010 - 2017",
              "isSingleVersion": false,
              "defaultVehicleId": null
            },
            {
              "id": "9ya",
              "label": "Cayenne 9YA (2017+)",
              "versions": [
                "porsche-cayenne-9ya-v6"
              ],
              "period": "2017 - aujourd'hui",
              "isSingleVersion": true,
              "defaultVehicleId": "porsche-cayenne-9ya-v6"
            }
          ],
          "vehiclesCount": 7,
          "isSingleGeneration": false,
          "defaultGenId": null
        },
        {
          "id": "panamera",
          "name": "Panamera",
          "generations": [
            {
              "id": "970",
              "label": "Panamera 970 (2009-2016)",
              "versions": [
                "porsche-panamera-970",
                "porsche-panamera-970-turbo"
              ],
              "period": "2009 - 2016",
              "isSingleVersion": false,
              "defaultVehicleId": null
            }
          ],
          "vehiclesCount": 2,
          "isSingleGeneration": true,
          "defaultGenId": "970"
        }
      ],
      "vehiclesCount": 55
    },
    {
      "id": "ferrari",
      "name": "Ferrari",
      "models": [
        {
          "id": "f430",
          "name": "F430",
          "generations": [
            {
              "id": "f430",
              "label": "F430 (2004-2009)",
              "versions": [
                "ferrari-f430"
              ],
              "period": "2004 - 2009",
              "isSingleVersion": true,
              "defaultVehicleId": "ferrari-f430"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "f430"
        },
        {
          "id": "456",
          "name": "456",
          "generations": [
            {
              "id": "456",
              "label": "456 / 456 M (1992-2003)",
              "versions": [
                "ferrari-456"
              ],
              "period": "1992 - 2003",
              "isSingleVersion": true,
              "defaultVehicleId": "ferrari-456"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "456"
        },
        {
          "id": "testarossa",
          "name": "Testarossa",
          "generations": [
            {
              "id": "testarossa",
              "label": "Testarossa (1984-1996)",
              "versions": [
                "ferrari-testarossa"
              ],
              "period": "1984 - 1996",
              "isSingleVersion": true,
              "defaultVehicleId": "ferrari-testarossa"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "testarossa"
        },
        {
          "id": "360",
          "name": "360",
          "generations": [
            {
              "id": "360",
              "label": "360 Modena (1999-2005)",
              "versions": [
                "ferrari-360"
              ],
              "period": "1999 - 2005",
              "isSingleVersion": true,
              "defaultVehicleId": "ferrari-360"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "360"
        },
        {
          "id": "512-bb",
          "name": "512 BB",
          "generations": [
            {
              "id": "512-bb",
              "label": "512 BB / BBi (1976-1984)",
              "versions": [
                "ferrari-512-bb"
              ],
              "period": "1976 - 1984",
              "isSingleVersion": true,
              "defaultVehicleId": "ferrari-512-bb"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "512-bb"
        }
      ],
      "vehiclesCount": 5
    },
    {
      "id": "audi",
      "name": "Audi",
      "models": [
        {
          "id": "r8",
          "name": "R8",
          "generations": [
            {
              "id": "r8-type-42",
              "label": "R8 Type 42 (2006-2015)",
              "versions": [
                "audi-r8-v8",
                "audi-r8-v10"
              ],
              "period": "2007 - 2012",
              "isSingleVersion": false,
              "defaultVehicleId": null
            }
          ],
          "vehiclesCount": 2,
          "isSingleGeneration": true,
          "defaultGenId": "r8-type-42"
        }
      ],
      "vehiclesCount": 2
    },
    {
      "id": "alpine",
      "name": "Alpine",
      "models": [
        {
          "id": "a110",
          "name": "A110",
          "generations": [
            {
              "id": "a110-2017",
              "label": "A110 (2017+)",
              "versions": [
                "alpine-a110"
              ],
              "period": "2017 - aujourd'hui",
              "isSingleVersion": true,
              "defaultVehicleId": "alpine-a110"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "a110-2017"
        }
      ],
      "vehiclesCount": 1
    },
    {
      "id": "aston-martin",
      "name": "Aston Martin",
      "models": [
        {
          "id": "db7",
          "name": "DB7",
          "generations": [
            {
              "id": "db7-v12",
              "label": "DB7 Vantage (1999-2004)",
              "versions": [
                "aston-martin-db7-v12"
              ],
              "period": "1999 - 2004",
              "isSingleVersion": true,
              "defaultVehicleId": "aston-martin-db7-v12"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "db7-v12"
        }
      ],
      "vehiclesCount": 1
    },
    {
      "id": "mercedes-amg",
      "name": "Mercedes-AMG",
      "models": [
        {
          "id": "amg-gt",
          "name": "AMG GT",
          "generations": [
            {
              "id": "c190",
              "label": "AMG GT C190 (2020-2022)",
              "versions": [
                "mercedes-amg-gt-black-series"
              ],
              "period": "2020 - 2021",
              "isSingleVersion": true,
              "defaultVehicleId": "mercedes-amg-gt-black-series"
            }
          ],
          "vehiclesCount": 1,
          "isSingleGeneration": true,
          "defaultGenId": "c190"
        }
      ],
      "vehiclesCount": 1
    }
  ],
  "aliases": {
    "porsche-356": "porsche-356",
    "356": "porsche-356",
    "porsche-911-type-f": "porsche-911-type-f",
    "911-type-f": "porsche-911-type-f",
    "type-f": "porsche-911-type-f",
    "porsche-911-type-f-1973-1976": "porsche-911-type-f-1973-1976",
    "911-type-f-1973-1976": "porsche-911-type-f-1973-1976",
    "type-f-1973-1976": "porsche-911-type-f-1973-1976",
    "porsche-911-carrera-rs-2-7": "porsche-911-carrera-rs-2-7",
    "911-carrera-rs-2-7": "porsche-911-carrera-rs-2-7",
    "carrera-rs-2-7": "porsche-911-carrera-rs-2-7",
    "porsche-912": "porsche-912",
    "912": "porsche-912",
    "porsche-912e": "porsche-912e",
    "912e": "porsche-912e",
    "porsche-914-4-1-7": "porsche-914-4-1-7",
    "914-4-1-7": "porsche-914-4-1-7",
    "porsche-914-4-2-0": "porsche-914-4-2-0",
    "914-4-2-0": "porsche-914-4-2-0",
    "porsche-911-type-g-2-7": "porsche-911-type-g-2-7",
    "911-type-g-2-7": "porsche-911-type-g-2-7",
    "type-g-2-7": "porsche-911-type-g-2-7",
    "type-g-27-30": "porsche-911-type-g-2-7",
    "type-g-27": "porsche-911-type-g-2-7",
    "porsche-911-sc-3-0": "porsche-911-sc-3-0",
    "911-sc-3-0": "porsche-911-sc-3-0",
    "sc-3-0": "porsche-911-sc-3-0",
    "type-g-30": "porsche-911-sc-3-0",
    "type-g-sc": "porsche-911-sc-3-0",
    "porsche-911-carrera-3-2": "porsche-911-carrera-3-2",
    "911-carrera-3-2": "porsche-911-carrera-3-2",
    "carrera-3-2": "porsche-911-carrera-3-2",
    "type-g-32": "porsche-911-carrera-3-2",
    "type-g-carrera": "porsche-911-carrera-3-2",
    "porsche-911-930-turbo": "porsche-911-930-turbo",
    "911-930-turbo": "porsche-911-930-turbo",
    "930-turbo": "porsche-911-930-turbo",
    "930": "porsche-911-930-turbo",
    "porsche-911-964-carrera": "porsche-911-964-carrera",
    "911-964-carrera": "porsche-911-964-carrera",
    "964-carrera": "porsche-911-964-carrera",
    "964": "porsche-911-964-carrera",
    "porsche-911-964-turbo": "porsche-911-964-turbo",
    "911-964-turbo": "porsche-911-964-turbo",
    "964-turbo": "porsche-911-964-turbo",
    "porsche-911-993-carrera": "porsche-911-993-carrera",
    "911-993-carrera": "porsche-911-993-carrera",
    "993-carrera": "porsche-911-993-carrera",
    "993": "porsche-911-993-carrera",
    "porsche-911-993-turbo": "porsche-911-993-turbo",
    "911-993-turbo": "porsche-911-993-turbo",
    "993-turbo": "porsche-911-993-turbo",
    "porsche-928-s": "porsche-928-s",
    "928-s": "porsche-928-s",
    "porsche-928-s4-gt-gts": "porsche-928-s4-gt-gts",
    "928-s4-gt-gts": "porsche-928-s4-gt-gts",
    "porsche-944-turbo": "porsche-944-turbo",
    "944-turbo": "porsche-944-turbo",
    "porsche-968": "porsche-968",
    "968": "porsche-968",
    "porsche-boxster-986": "porsche-boxster-986",
    "boxster-986": "porsche-boxster-986",
    "porsche-boxster-987-1": "porsche-boxster-987-1",
    "boxster-987-1": "porsche-boxster-987-1",
    "porsche-boxster-987-2": "porsche-boxster-987-2",
    "boxster-987-2": "porsche-boxster-987-2",
    "porsche-boxster-981": "porsche-boxster-981",
    "boxster-981": "porsche-boxster-981",
    "porsche-718-4-0": "porsche-718-4-0",
    "718-4-0": "porsche-718-4-0",
    "porsche-718-gt4-rs": "porsche-718-gt4-rs",
    "718-gt4-rs": "porsche-718-gt4-rs",
    "porsche-911-996-carrera": "porsche-911-996-carrera",
    "911-996-carrera": "porsche-911-996-carrera",
    "996-carrera": "porsche-911-996-carrera",
    "996": "porsche-911-996-carrera",
    "porsche-911-996-gt3": "porsche-911-996-gt3",
    "911-996-gt3": "porsche-911-996-gt3",
    "996-gt3": "porsche-911-996-gt3",
    "porsche-911-996-turbo": "porsche-911-996-turbo",
    "911-996-turbo": "porsche-911-996-turbo",
    "996-turbo": "porsche-911-996-turbo",
    "porsche-911-997-1-carrera": "porsche-911-997-1-carrera",
    "911-997-1-carrera": "porsche-911-997-1-carrera",
    "997-1-carrera": "porsche-911-997-1-carrera",
    "997-carrera": "porsche-911-997-1-carrera",
    "porsche-911-997-1-gt3": "porsche-911-997-1-gt3",
    "911-997-1-gt3": "porsche-911-997-1-gt3",
    "997-1-gt3": "porsche-911-997-1-gt3",
    "porsche-911-997-1-turbo": "porsche-911-997-1-turbo",
    "911-997-1-turbo": "porsche-911-997-1-turbo",
    "997-1-turbo": "porsche-911-997-1-turbo",
    "porsche-911-997-2-carrera": "porsche-911-997-2-carrera",
    "911-997-2-carrera": "porsche-911-997-2-carrera",
    "997-2-carrera": "porsche-911-997-2-carrera",
    "997-2": "porsche-911-997-2-carrera",
    "porsche-911-997-2-carrera-pse": "porsche-911-997-2-carrera-pse",
    "911-997-2-carrera-pse": "porsche-911-997-2-carrera-pse",
    "997-2-carrera-pse": "porsche-911-997-2-carrera-pse",
    "997-2-pse": "porsche-911-997-2-carrera-pse",
    "porsche-911-997-2-gt3": "porsche-911-997-2-gt3",
    "911-997-2-gt3": "porsche-911-997-2-gt3",
    "997-2-gt3": "porsche-911-997-2-gt3",
    "997-2-gt3-rs": "porsche-911-997-2-gt3",
    "porsche-911-997-2-gt2-rs": "porsche-911-997-2-gt2-rs",
    "911-997-2-gt2-rs": "porsche-911-997-2-gt2-rs",
    "997-2-gt2-rs": "porsche-911-997-2-gt2-rs",
    "porsche-911-997-2-turbo": "porsche-911-997-2-turbo",
    "911-997-2-turbo": "porsche-911-997-2-turbo",
    "997-2-turbo": "porsche-911-997-2-turbo",
    "porsche-911-991-1-carrera": "porsche-911-991-1-carrera",
    "911-991-1-carrera": "porsche-911-991-1-carrera",
    "991-1-carrera": "porsche-911-991-1-carrera",
    "porsche-911-991-1-carrera-pse": "porsche-911-991-1-carrera-pse",
    "911-991-1-carrera-pse": "porsche-911-991-1-carrera-pse",
    "991-1-carrera-pse": "porsche-911-991-1-carrera-pse",
    "porsche-911-991-1-gt3": "porsche-911-991-1-gt3",
    "911-991-1-gt3": "porsche-911-991-1-gt3",
    "991-1-gt3": "porsche-911-991-1-gt3",
    "porsche-911-991-1-turbo": "porsche-911-991-1-turbo",
    "911-991-1-turbo": "porsche-911-991-1-turbo",
    "991-1-turbo": "porsche-911-991-1-turbo",
    "porsche-911-991-2-carrera": "porsche-911-991-2-carrera",
    "911-991-2-carrera": "porsche-911-991-2-carrera",
    "991-2-carrera": "porsche-911-991-2-carrera",
    "porsche-911-991-2-carrera-pse": "porsche-911-991-2-carrera-pse",
    "911-991-2-carrera-pse": "porsche-911-991-2-carrera-pse",
    "991-2-carrera-pse": "porsche-911-991-2-carrera-pse",
    "porsche-911-991-2-gt3": "porsche-911-991-2-gt3",
    "911-991-2-gt3": "porsche-911-991-2-gt3",
    "991-2-gt3": "porsche-911-991-2-gt3",
    "porsche-911-991-2-turbo": "porsche-911-991-2-turbo",
    "911-991-2-turbo": "porsche-911-991-2-turbo",
    "991-2-turbo": "porsche-911-991-2-turbo",
    "porsche-911-992-carrera": "porsche-911-992-carrera",
    "911-992-carrera": "porsche-911-992-carrera",
    "992-carrera": "porsche-911-992-carrera",
    "porsche-cayenne-955-s": "porsche-cayenne-955-s",
    "cayenne-955-s": "porsche-cayenne-955-s",
    "porsche-cayenne-955-turbo": "porsche-cayenne-955-turbo",
    "cayenne-955-turbo": "porsche-cayenne-955-turbo",
    "porsche-cayenne-957-s": "porsche-cayenne-957-s",
    "cayenne-957-s": "porsche-cayenne-957-s",
    "porsche-cayenne-957-turbo": "porsche-cayenne-957-turbo",
    "cayenne-957-turbo": "porsche-cayenne-957-turbo",
    "porsche-cayenne-958": "porsche-cayenne-958",
    "cayenne-958": "porsche-cayenne-958",
    "porsche-cayenne-958-turbo": "porsche-cayenne-958-turbo",
    "cayenne-958-turbo": "porsche-cayenne-958-turbo",
    "porsche-cayenne-9ya-v6": "porsche-cayenne-9ya-v6",
    "cayenne-9ya-v6": "porsche-cayenne-9ya-v6",
    "porsche-panamera-970": "porsche-panamera-970",
    "panamera-970": "porsche-panamera-970",
    "porsche-panamera-970-turbo": "porsche-panamera-970-turbo",
    "panamera-970-turbo": "porsche-panamera-970-turbo",
    "ferrari-f430": "ferrari-f430",
    "f430": "ferrari-f430",
    "ferrari-456": "ferrari-456",
    "ferrari-testarossa": "ferrari-testarossa",
    "ferrari-360": "ferrari-360",
    "ferrari-512-bb": "ferrari-512-bb",
    "audi-r8-v8": "audi-r8-v8",
    "r8-v8": "audi-r8-v8",
    "audi-r8-v10": "audi-r8-v10",
    "r8-v10": "audi-r8-v10",
    "alpine-a110": "alpine-a110",
    "a110": "alpine-a110",
    "aston-martin-db7-v12": "aston-martin-db7-v12",
    "db7": "aston-martin-db7-v12",
    "mercedes-amg-gt-black-series": "mercedes-amg-gt-black-series",
    "amg-gt": "mercedes-amg-gt-black-series"
  },
  "stats": {
    "vehiclesCount": 65,
    "familiesCount": 57,
    "productsCount": 276,
    "brandsCount": 6,
    "catalogProductsCount": 280,
    "productionReferenceVehiclesCount": 7,
    "testHeuristicVehiclesCount": 58
  }
};
